/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * AI Business Growth Platform API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AbTestAnalysisResponse,
  AbTestWithVariants,
  AbTestsResponse,
  AddContactNoteBody,
  AddContactTagBody,
  AddDealActivityBody,
  AddSeoCompetitorBody,
  AddSeoKeywordBody,
  AgencyClient,
  AiQuestionsResponse,
  AiRespondToReview200,
  AnalyticsDashboard,
  AttributionDashboard,
  AttributionSummary,
  AutoRunResult,
  BatchInferVerticalsResult,
  BrandMention,
  BrandMentionsResponse,
  BulkGenerateSocialPostsBody,
  BulkGenerateSocialPostsResponse,
  BusinessProfile,
  BusinessReview,
  CancelSubscription200,
  ChangeControlledPilot200,
  ChatLead,
  ChatWidget,
  ContactAiInsights,
  ContactInteraction,
  ContactNote,
  ContactNotesResponse,
  ContactSmartListsResponse,
  ContactTag,
  ContactTimelineResponse,
  ContentTemplate,
  ContentTemplatesResponse,
  ControlledPilotAction,
  ControlledPilotReview,
  CreateAbTestBody,
  CreateAgencyClientBody,
  CreateBooking200,
  CreateBookingBody,
  CreateChatWidgetBody,
  CreateContactInteractionBody,
  CreateContentTemplateBody,
  CreateDealBody,
  CreateDigestSubscription200,
  CreateDigestSubscriptionBody,
  CreateEmailDomain201,
  CreateEmailDomainBody,
  CreateGmbPost200,
  CreateGmbPostBody,
  CreateListeningKeywordBody,
  CreateMeetingType200,
  CreateMeetingTypeBody,
  CreateNetworkContactBody,
  CreateOutreachAbCampaign201,
  CreateOutreachAbCampaignBody,
  CreateOutreachSequenceBody,
  CreateProposalBody,
  CreateSmsCampaign200,
  CreateSmsCampaignBody,
  CreateSmsContact200,
  CreateSmsContactBody,
  CreateSocialPostFromContentBody,
  CreateWebhookEndpoint200,
  CreateWebhookEndpointBody,
  Deal,
  DealActivity,
  DealAiAnalysis,
  DealAttributionChain,
  DealDetailResponse,
  DealStats,
  DealsResponse,
  DeclareAbTestWinnerBody,
  DeleteAgencyClient200,
  DeleteBooking200,
  DeleteChatWidget200,
  DeleteDigestSubscription200,
  DeleteEmailDomain200,
  DeleteLeadScore200,
  DeleteMeetingType200,
  DeleteProposal200,
  DeleteReport200,
  DeleteReview200,
  DeleteSeoCompetitor200,
  DeleteSeoKeyword200,
  DeleteSmsCampaign200,
  DeleteSmsContact200,
  DeleteWebhookEndpoint200,
  DiscoverLeadsBody,
  EmailSettings,
  EnrollLeadBody,
  ExportAnalyticsReportBody,
  GenerateAbVariantsBody,
  GenerateAttribution200,
  GenerateEmailBody,
  GenerateLeadScores200,
  GenerateProposal200,
  GenerateProposalBody,
  GenerateReplyBody,
  GenerateReport200,
  GenerateReportBody,
  GenerateSeoContentBody,
  GenerateSmsMessage200,
  GenerateSmsMessageBody,
  GenerateSocialPostBody,
  GeneratedVariantsResponse,
  GetAiProfileQuestionsBody,
  GetAnalyticsReport200,
  GetAnalyticsReportParams,
  GetAttribution200,
  GetBillingInvoices200,
  GetBillingPlans200,
  GetBillingSubscription200,
  GetBrandMentionsParams,
  GetContactAllTags200,
  GetCurrentAuthUserResponse,
  GetDealsParams,
  GetDigestSubscriptions200,
  GetEmailDomains200,
  GetEmailHealth200,
  GetLeadScores200,
  GetNetworkContactsParams,
  GetOutreachEmailsParams,
  GetOutreachLeadsParams,
  GetOutreachThreadsParams,
  GetProductHealthParams,
  GetRegionsParams,
  GetReportSchedule200,
  GetReports200,
  GetReviewRequests200,
  GetReviewStatsTrend200,
  GetReviewStatsTrendParams,
  GetReviews200,
  GetReviewsParams,
  GetSchedulingAvailability200,
  GetSchedulingBookings200,
  GetSchedulingMeetingTypes200,
  GetSearchRunsParams,
  GetSeoAlerts200,
  GetSeoCompetitorAnalysis200,
  GetSeoCompetitors200,
  GetSeoKeywordHistory200,
  GetSeoKeywords200,
  GetSeoRankings200,
  GetSmsCampaigns200,
  GetSmsContacts200,
  GetSmsMessages200,
  GetSocialCalendarParams,
  GetSocialPostsParams,
  GetSocialTemplatesParams,
  GetTeamMembers200,
  GetWarmupLogs200,
  GetWebhookDeliveries200,
  GetWebhookEndpoints200,
  GetWebhookEvents200,
  GetWorkspaceOutcomesParams,
  GmbSettings,
  GoldenPathCandidate,
  GoldenPathCandidateSelectionInput,
  GoldenPathErrorResponse,
  GoldenPathOutcomeEvidencePage,
  GoldenPathOutcomeFixtureInput,
  GoldenPathRunEnvelope,
  GoldenPathRunInput,
  GoldenPathRunResumeInput,
  GoldenPathRunSummary,
  HealthStatus,
  ImportContactsBody,
  ImportContactsResult,
  InviteTeamMember201,
  InviteTeamMemberBody,
  LeadEnrollmentsResponse,
  LeadScore,
  LeadScoreComputeResult,
  LeadScoreResult,
  ListeningInsightsResponse,
  ListeningKeyword,
  ListeningKeywordsResponse,
  ListeningScanResult,
  NetworkContact,
  NetworkContactDetail,
  NetworkContactsResponse,
  OptOutSmsContact200,
  OutreachAutoRunStatus,
  OutreachEmail,
  OutreachEmailsResponse,
  OutreachLead,
  OutreachLeadsResponse,
  OutreachSequence,
  OutreachSequencesResponse,
  OutreachThreadDetail,
  OutreachThreadsResponse,
  PatchAbTestWinnerBody,
  PatchReviewBody,
  PreviewSpamScore200,
  PreviewSpamScoreBody,
  ProductHealthResponse,
  Proposal,
  RefreshSeoKeywords200,
  RegenerateReviewResponse200,
  RegionSelectionResponse,
  RegionalSourceEntry,
  RegionalSourcesResponse,
  RegionsResponse,
  RemoveTeamMember200,
  ResendTeamInvite200,
  RespondToReviewBody,
  ReviewRequest,
  ReviewStats,
  SavePostAsTemplateBody,
  SaveRegionSelectionBody,
  ScheduleSocialPostBody,
  SearchRunsResponse,
  SendReviewRequestBody,
  SendSmsCampaign200,
  SendThreadReplyBody,
  SendThreadReplyResponse,
  SeoAnalysis,
  SeoCompetitor,
  SeoContentResponse,
  SeoKeywordRank,
  SeoTask,
  SeoTasksResponse,
  SequenceEnrollment,
  SimulateGoldenPathOutcomeEvidence200,
  SocialCalendarResponse,
  SocialPost,
  SocialPostsResponse,
  SocialSettings,
  SubscribeToPlan200,
  SubscribeToPlanBody,
  SuccessResponse,
  SyncReviews200,
  TestWebhookEndpoint200,
  TrackEventBody,
  UpdateBooking200,
  UpdateBookingBody,
  UpdateDealBody,
  UpdateDigestSubscription200,
  UpdateDigestSubscriptionBody,
  UpdateEmailDomain200,
  UpdateEmailDomainBody,
  UpdateEmailSettingsBody,
  UpdateGmbSettings200,
  UpdateGmbSettingsBody,
  UpdateListeningKeywordBody,
  UpdateMeetingType200,
  UpdateMeetingTypeBody,
  UpdateNetworkContactBody,
  UpdateOutreachLeadBody,
  UpdateRegionalSourceBody,
  UpdateReportSchedule200,
  UpdateReportScheduleBody,
  UpdateSmsCampaign200,
  UpdateSmsCampaignBody,
  UpdateSocialPostBody,
  UpdateSocialSettingsBody,
  UpdateSocialTemplate200,
  UpdateSocialTemplateBody,
  UpdateTeamMember200,
  UpdateTeamMemberBody,
  UpdateWarmupSettings200,
  UpdateWarmupSettingsBody,
  UpdateWebhookEndpoint200,
  UpdateWebhookEndpointBody,
  UpsertBusinessProfileBody,
  UseSocialTemplateBody,
  VerifyEmailDomain200,
  VerticalPacksResponse,
  WhiteLabelSettings,
  WidgetChat,
  WorkspaceAnalyticsEventsResponse,
  WorkspaceMilestonesResponse,
  WorkspaceOutcomesResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetControlledPilotUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}/pilot`;
};

/**
 * @summary Review the frozen first-touch pilot without usable unsubscribe tokens
 */
export const getControlledPilot = async (
  id: string,
  options?: RequestInit,
): Promise<ControlledPilotReview> => {
  return customFetch<ControlledPilotReview>(getGetControlledPilotUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetControlledPilotQueryKey = (id: string) => {
  return [`/api/outreach/golden-path/runs/${id}/pilot`] as const;
};

export const getGetControlledPilotQueryOptions = <
  TData = Awaited<ReturnType<typeof getControlledPilot>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getControlledPilot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetControlledPilotQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getControlledPilot>>
  > = ({ signal }) => getControlledPilot(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getControlledPilot>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetControlledPilotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getControlledPilot>>
>;
export type GetControlledPilotQueryError = ErrorType<unknown>;

/**
 * @summary Review the frozen first-touch pilot without usable unsubscribe tokens
 */

export function useGetControlledPilot<
  TData = Awaited<ReturnType<typeof getControlledPilot>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getControlledPilot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetControlledPilotQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getChangeControlledPilotUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}/pilot`;
};

/**
 * @summary Admin-only deliberate pilot approval, activation, pause or revocation
 */
export const changeControlledPilot = async (
  id: string,
  controlledPilotAction: ControlledPilotAction,
  options?: RequestInit,
): Promise<ChangeControlledPilot200> => {
  return customFetch<ChangeControlledPilot200>(
    getChangeControlledPilotUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(controlledPilotAction),
    },
  );
};

export const getChangeControlledPilotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeControlledPilot>>,
    TError,
    { id: string; data: BodyType<ControlledPilotAction> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeControlledPilot>>,
  TError,
  { id: string; data: BodyType<ControlledPilotAction> },
  TContext
> => {
  const mutationKey = ["changeControlledPilot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeControlledPilot>>,
    { id: string; data: BodyType<ControlledPilotAction> }
  > = (props) => {
    const { id, data } = props ?? {};

    return changeControlledPilot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeControlledPilotMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeControlledPilot>>
>;
export type ChangeControlledPilotMutationBody = BodyType<ControlledPilotAction>;
export type ChangeControlledPilotMutationError = ErrorType<unknown>;

/**
 * @summary Admin-only deliberate pilot approval, activation, pause or revocation
 */
export const useChangeControlledPilot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeControlledPilot>>,
    TError,
    { id: string; data: BodyType<ControlledPilotAction> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeControlledPilot>>,
  TError,
  { id: string; data: BodyType<ControlledPilotAction> },
  TContext
> => {
  return useMutation(getChangeControlledPilotMutationOptions(options));
};

export const getGetGoldenPathOutcomeEvidenceUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}/outcomes`;
};

export const getGoldenPathOutcomeEvidence = async (
  id: string,
  options?: RequestInit,
): Promise<GoldenPathOutcomeEvidencePage> => {
  return customFetch<GoldenPathOutcomeEvidencePage>(
    getGetGoldenPathOutcomeEvidenceUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGoldenPathOutcomeEvidenceQueryKey = (id: string) => {
  return [`/api/outreach/golden-path/runs/${id}/outcomes`] as const;
};

export const getGetGoldenPathOutcomeEvidenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGoldenPathOutcomeEvidenceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>
  > = ({ signal }) =>
    getGoldenPathOutcomeEvidence(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoldenPathOutcomeEvidenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>
>;
export type GetGoldenPathOutcomeEvidenceQueryError = ErrorType<unknown>;

export function useGetGoldenPathOutcomeEvidence<
  TData = Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathOutcomeEvidence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoldenPathOutcomeEvidenceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSimulateGoldenPathOutcomeEvidenceUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}/outcome-fixture`;
};

export const simulateGoldenPathOutcomeEvidence = async (
  id: string,
  goldenPathOutcomeFixtureInput: GoldenPathOutcomeFixtureInput,
  options?: RequestInit,
): Promise<SimulateGoldenPathOutcomeEvidence200> => {
  return customFetch<SimulateGoldenPathOutcomeEvidence200>(
    getSimulateGoldenPathOutcomeEvidenceUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(goldenPathOutcomeFixtureInput),
    },
  );
};

export const getSimulateGoldenPathOutcomeEvidenceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>,
    TError,
    { id: string; data: BodyType<GoldenPathOutcomeFixtureInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>,
  TError,
  { id: string; data: BodyType<GoldenPathOutcomeFixtureInput> },
  TContext
> => {
  const mutationKey = ["simulateGoldenPathOutcomeEvidence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>,
    { id: string; data: BodyType<GoldenPathOutcomeFixtureInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return simulateGoldenPathOutcomeEvidence(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulateGoldenPathOutcomeEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>
>;
export type SimulateGoldenPathOutcomeEvidenceMutationBody =
  BodyType<GoldenPathOutcomeFixtureInput>;
export type SimulateGoldenPathOutcomeEvidenceMutationError = ErrorType<void>;

export const useSimulateGoldenPathOutcomeEvidence = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>,
    TError,
    { id: string; data: BodyType<GoldenPathOutcomeFixtureInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulateGoldenPathOutcomeEvidence>>,
  TError,
  { id: string; data: BodyType<GoldenPathOutcomeFixtureInput> },
  TContext
> => {
  return useMutation(
    getSimulateGoldenPathOutcomeEvidenceMutationOptions(options),
  );
};

export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

/**
 * @summary Health check
 */
export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCurrentAuthUserUrl = () => {
  return `/api/auth/user`;
};

/**
 * @summary Get current authenticated user
 */
export const getCurrentAuthUser = async (
  options?: RequestInit,
): Promise<GetCurrentAuthUserResponse> => {
  return customFetch<GetCurrentAuthUserResponse>(getGetCurrentAuthUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentAuthUserQueryKey = () => {
  return [`/api/auth/user`] as const;
};

export const getGetCurrentAuthUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentAuthUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentAuthUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentAuthUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentAuthUser>>
  > = ({ signal }) => getCurrentAuthUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentAuthUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentAuthUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentAuthUser>>
>;
export type GetCurrentAuthUserQueryError = ErrorType<unknown>;

/**
 * @summary Get current authenticated user
 */

export function useGetCurrentAuthUser<
  TData = Awaited<ReturnType<typeof getCurrentAuthUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentAuthUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentAuthUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWorkspaceMilestonesUrl = () => {
  return `/api/product/milestones`;
};

/**
 * @summary List safe achieved milestones for client analytics capture
 */
export const getWorkspaceMilestones = async (
  options?: RequestInit,
): Promise<WorkspaceMilestonesResponse> => {
  return customFetch<WorkspaceMilestonesResponse>(
    getGetWorkspaceMilestonesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceMilestonesQueryKey = () => {
  return [`/api/product/milestones`] as const;
};

export const getGetWorkspaceMilestonesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceMilestones>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceMilestones>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceMilestonesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceMilestones>>
  > = ({ signal }) => getWorkspaceMilestones({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceMilestones>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceMilestonesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceMilestones>>
>;
export type GetWorkspaceMilestonesQueryError = ErrorType<unknown>;

/**
 * @summary List safe achieved milestones for client analytics capture
 */

export function useGetWorkspaceMilestones<
  TData = Awaited<ReturnType<typeof getWorkspaceMilestones>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceMilestones>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceMilestonesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWorkspaceAnalyticsEventsUrl = () => {
  return `/api/product/events`;
};

/**
 * @summary List privacy-safe durable product event projections for this tenant
 */
export const getWorkspaceAnalyticsEvents = async (
  options?: RequestInit,
): Promise<WorkspaceAnalyticsEventsResponse> => {
  return customFetch<WorkspaceAnalyticsEventsResponse>(
    getGetWorkspaceAnalyticsEventsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceAnalyticsEventsQueryKey = () => {
  return [`/api/product/events`] as const;
};

export const getGetWorkspaceAnalyticsEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceAnalyticsEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>
  > = ({ signal }) =>
    getWorkspaceAnalyticsEvents({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceAnalyticsEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>
>;
export type GetWorkspaceAnalyticsEventsQueryError = ErrorType<unknown>;

/**
 * @summary List privacy-safe durable product event projections for this tenant
 */

export function useGetWorkspaceAnalyticsEvents<
  TData = Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceAnalyticsEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceAnalyticsEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWorkspaceOutcomesUrl = (
  params?: GetWorkspaceOutcomesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/product/outcomes?${stringifiedParams}`
    : `/api/product/outcomes`;
};

/**
 * @summary List measured outcomes associated with this workspace
 */
export const getWorkspaceOutcomes = async (
  params?: GetWorkspaceOutcomesParams,
  options?: RequestInit,
): Promise<WorkspaceOutcomesResponse> => {
  return customFetch<WorkspaceOutcomesResponse>(
    getGetWorkspaceOutcomesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkspaceOutcomesQueryKey = (
  params?: GetWorkspaceOutcomesParams,
) => {
  return [`/api/product/outcomes`, ...(params ? [params] : [])] as const;
};

export const getGetWorkspaceOutcomesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceOutcomes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWorkspaceOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceOutcomes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceOutcomesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceOutcomes>>
  > = ({ signal }) =>
    getWorkspaceOutcomes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceOutcomes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceOutcomesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceOutcomes>>
>;
export type GetWorkspaceOutcomesQueryError = ErrorType<unknown>;

/**
 * @summary List measured outcomes associated with this workspace
 */

export function useGetWorkspaceOutcomes<
  TData = Awaited<ReturnType<typeof getWorkspaceOutcomes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetWorkspaceOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceOutcomes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceOutcomesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetProductHealthUrl = (params: GetProductHealthParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/product-health?${stringifiedParams}`
    : `/api/admin/product-health`;
};

/**
 * @summary System-global aggregate product activation health
 */
export const getProductHealth = async (
  params: GetProductHealthParams,
  options?: RequestInit,
): Promise<ProductHealthResponse> => {
  return customFetch<ProductHealthResponse>(getGetProductHealthUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetProductHealthQueryKey = (
  params?: GetProductHealthParams,
) => {
  return [`/api/admin/product-health`, ...(params ? [params] : [])] as const;
};

export const getGetProductHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductHealth>>,
  TError = ErrorType<void>,
>(
  params: GetProductHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductHealth>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductHealthQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProductHealth>>
  > = ({ signal }) => getProductHealth(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductHealth>>
>;
export type GetProductHealthQueryError = ErrorType<void>;

/**
 * @summary System-global aggregate product activation health
 */

export function useGetProductHealth<
  TData = Awaited<ReturnType<typeof getProductHealth>>,
  TError = ErrorType<void>,
>(
  params: GetProductHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductHealth>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProductHealthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBusinessProfileUrl = () => {
  return `/api/business/profile`;
};

/**
 * @summary Get business profile for current user
 */
export const getBusinessProfile = async (
  options?: RequestInit,
): Promise<BusinessProfile> => {
  return customFetch<BusinessProfile>(getGetBusinessProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBusinessProfileQueryKey = () => {
  return [`/api/business/profile`] as const;
};

export const getGetBusinessProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getBusinessProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBusinessProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBusinessProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBusinessProfile>>
  > = ({ signal }) => getBusinessProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBusinessProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBusinessProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBusinessProfile>>
>;
export type GetBusinessProfileQueryError = ErrorType<void>;

/**
 * @summary Get business profile for current user
 */

export function useGetBusinessProfile<
  TData = Awaited<ReturnType<typeof getBusinessProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBusinessProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBusinessProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateBusinessProfileUrl = () => {
  return `/api/business/profile`;
};

/**
 * @summary Create or update business profile
 */
export const createBusinessProfile = async (
  upsertBusinessProfileBody: UpsertBusinessProfileBody,
  options?: RequestInit,
): Promise<BusinessProfile> => {
  return customFetch<BusinessProfile>(getCreateBusinessProfileUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upsertBusinessProfileBody),
  });
};

export const getCreateBusinessProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusinessProfile>>,
    TError,
    { data: BodyType<UpsertBusinessProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBusinessProfile>>,
  TError,
  { data: BodyType<UpsertBusinessProfileBody> },
  TContext
> => {
  const mutationKey = ["createBusinessProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBusinessProfile>>,
    { data: BodyType<UpsertBusinessProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBusinessProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBusinessProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBusinessProfile>>
>;
export type CreateBusinessProfileMutationBody =
  BodyType<UpsertBusinessProfileBody>;
export type CreateBusinessProfileMutationError = ErrorType<unknown>;

/**
 * @summary Create or update business profile
 */
export const useCreateBusinessProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusinessProfile>>,
    TError,
    { data: BodyType<UpsertBusinessProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBusinessProfile>>,
  TError,
  { data: BodyType<UpsertBusinessProfileBody> },
  TContext
> => {
  return useMutation(getCreateBusinessProfileMutationOptions(options));
};

export const getGetAiProfileQuestionsUrl = () => {
  return `/api/business/profile/ai-questions`;
};

/**
 * @summary Get AI-generated follow-up questions based on business description
 */
export const getAiProfileQuestions = async (
  getAiProfileQuestionsBody: GetAiProfileQuestionsBody,
  options?: RequestInit,
): Promise<AiQuestionsResponse> => {
  return customFetch<AiQuestionsResponse>(getGetAiProfileQuestionsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(getAiProfileQuestionsBody),
  });
};

export const getGetAiProfileQuestionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAiProfileQuestions>>,
    TError,
    { data: BodyType<GetAiProfileQuestionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAiProfileQuestions>>,
  TError,
  { data: BodyType<GetAiProfileQuestionsBody> },
  TContext
> => {
  const mutationKey = ["getAiProfileQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAiProfileQuestions>>,
    { data: BodyType<GetAiProfileQuestionsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return getAiProfileQuestions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAiProfileQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAiProfileQuestions>>
>;
export type GetAiProfileQuestionsMutationBody =
  BodyType<GetAiProfileQuestionsBody>;
export type GetAiProfileQuestionsMutationError = ErrorType<unknown>;

/**
 * @summary Get AI-generated follow-up questions based on business description
 */
export const useGetAiProfileQuestions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAiProfileQuestions>>,
    TError,
    { data: BodyType<GetAiProfileQuestionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAiProfileQuestions>>,
  TError,
  { data: BodyType<GetAiProfileQuestionsBody> },
  TContext
> => {
  return useMutation(getGetAiProfileQuestionsMutationOptions(options));
};

export const getGetRegionsUrl = (params?: GetRegionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/regions?${stringifiedParams}`
    : `/api/regions`;
};

/**
 * @summary List all available target regions
 */
export const getRegions = async (
  params?: GetRegionsParams,
  options?: RequestInit,
): Promise<RegionsResponse> => {
  return customFetch<RegionsResponse>(getGetRegionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRegionsQueryKey = (params?: GetRegionsParams) => {
  return [`/api/regions`, ...(params ? [params] : [])] as const;
};

export const getGetRegionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRegionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegions>>> = ({
    signal,
  }) => getRegions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegions>>
>;
export type GetRegionsQueryError = ErrorType<unknown>;

/**
 * @summary List all available target regions
 */

export function useGetRegions<
  TData = Awaited<ReturnType<typeof getRegions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRegionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRegionSelectionUrl = () => {
  return `/api/outreach/region-selection`;
};

/**
 * @summary Get saved region selection for current workspace
 */
export const getRegionSelection = async (
  options?: RequestInit,
): Promise<RegionSelectionResponse> => {
  return customFetch<RegionSelectionResponse>(getGetRegionSelectionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRegionSelectionQueryKey = () => {
  return [`/api/outreach/region-selection`] as const;
};

export const getGetRegionSelectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegionSelection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRegionSelection>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegionSelectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegionSelection>>
  > = ({ signal }) => getRegionSelection({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegionSelection>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegionSelectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegionSelection>>
>;
export type GetRegionSelectionQueryError = ErrorType<unknown>;

/**
 * @summary Get saved region selection for current workspace
 */

export function useGetRegionSelection<
  TData = Awaited<ReturnType<typeof getRegionSelection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRegionSelection>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegionSelectionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSaveRegionSelectionUrl = () => {
  return `/api/outreach/region-selection`;
};

/**
 * @summary Save region selection for current workspace
 */
export const saveRegionSelection = async (
  saveRegionSelectionBody: SaveRegionSelectionBody,
  options?: RequestInit,
): Promise<RegionSelectionResponse> => {
  return customFetch<RegionSelectionResponse>(getSaveRegionSelectionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveRegionSelectionBody),
  });
};

export const getSaveRegionSelectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRegionSelection>>,
    TError,
    { data: BodyType<SaveRegionSelectionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveRegionSelection>>,
  TError,
  { data: BodyType<SaveRegionSelectionBody> },
  TContext
> => {
  const mutationKey = ["saveRegionSelection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveRegionSelection>>,
    { data: BodyType<SaveRegionSelectionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveRegionSelection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveRegionSelectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveRegionSelection>>
>;
export type SaveRegionSelectionMutationBody = BodyType<SaveRegionSelectionBody>;
export type SaveRegionSelectionMutationError = ErrorType<unknown>;

/**
 * @summary Save region selection for current workspace
 */
export const useSaveRegionSelection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRegionSelection>>,
    TError,
    { data: BodyType<SaveRegionSelectionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveRegionSelection>>,
  TError,
  { data: BodyType<SaveRegionSelectionBody> },
  TContext
> => {
  return useMutation(getSaveRegionSelectionMutationOptions(options));
};

export const getGetSearchRunsUrl = (params?: GetSearchRunsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/outreach/search-runs?${stringifiedParams}`
    : `/api/outreach/search-runs`;
};

/**
 * @summary Get regional search run history for current workspace
 */
export const getSearchRuns = async (
  params?: GetSearchRunsParams,
  options?: RequestInit,
): Promise<SearchRunsResponse> => {
  return customFetch<SearchRunsResponse>(getGetSearchRunsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSearchRunsQueryKey = (params?: GetSearchRunsParams) => {
  return [`/api/outreach/search-runs`, ...(params ? [params] : [])] as const;
};

export const getGetSearchRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSearchRuns>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSearchRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSearchRunsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchRuns>>> = ({
    signal,
  }) => getSearchRuns(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSearchRuns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSearchRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSearchRuns>>
>;
export type GetSearchRunsQueryError = ErrorType<unknown>;

/**
 * @summary Get regional search run history for current workspace
 */

export function useGetSearchRuns<
  TData = Awaited<ReturnType<typeof getSearchRuns>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSearchRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSearchRunsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRegionalSourcesUrl = () => {
  return `/api/admin/regional-sources`;
};

/**
 * @summary Admin: list regional source registry
 */
export const getRegionalSources = async (
  options?: RequestInit,
): Promise<RegionalSourcesResponse> => {
  return customFetch<RegionalSourcesResponse>(getGetRegionalSourcesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRegionalSourcesQueryKey = () => {
  return [`/api/admin/regional-sources`] as const;
};

export const getGetRegionalSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegionalSources>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRegionalSources>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegionalSourcesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegionalSources>>
  > = ({ signal }) => getRegionalSources({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegionalSources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegionalSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegionalSources>>
>;
export type GetRegionalSourcesQueryError = ErrorType<unknown>;

/**
 * @summary Admin: list regional source registry
 */

export function useGetRegionalSources<
  TData = Awaited<ReturnType<typeof getRegionalSources>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRegionalSources>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegionalSourcesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateRegionalSourceUrl = (sourceId: string) => {
  return `/api/admin/regional-sources/${sourceId}`;
};

/**
 * @summary Admin: update a regional source entry
 */
export const updateRegionalSource = async (
  sourceId: string,
  updateRegionalSourceBody: UpdateRegionalSourceBody,
  options?: RequestInit,
): Promise<RegionalSourceEntry> => {
  return customFetch<RegionalSourceEntry>(
    getUpdateRegionalSourceUrl(sourceId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateRegionalSourceBody),
    },
  );
};

export const getUpdateRegionalSourceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegionalSource>>,
    TError,
    { sourceId: string; data: BodyType<UpdateRegionalSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRegionalSource>>,
  TError,
  { sourceId: string; data: BodyType<UpdateRegionalSourceBody> },
  TContext
> => {
  const mutationKey = ["updateRegionalSource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRegionalSource>>,
    { sourceId: string; data: BodyType<UpdateRegionalSourceBody> }
  > = (props) => {
    const { sourceId, data } = props ?? {};

    return updateRegionalSource(sourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRegionalSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRegionalSource>>
>;
export type UpdateRegionalSourceMutationBody =
  BodyType<UpdateRegionalSourceBody>;
export type UpdateRegionalSourceMutationError = ErrorType<unknown>;

/**
 * @summary Admin: update a regional source entry
 */
export const useUpdateRegionalSource = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegionalSource>>,
    TError,
    { sourceId: string; data: BodyType<UpdateRegionalSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRegionalSource>>,
  TError,
  { sourceId: string; data: BodyType<UpdateRegionalSourceBody> },
  TContext
> => {
  return useMutation(getUpdateRegionalSourceMutationOptions(options));
};

export const getGetOutreachLeadsUrl = (params?: GetOutreachLeadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/outreach/leads?${stringifiedParams}`
    : `/api/outreach/leads`;
};

/**
 * @summary Get outreach leads for current user
 */
export const getOutreachLeads = async (
  params?: GetOutreachLeadsParams,
  options?: RequestInit,
): Promise<OutreachLeadsResponse> => {
  return customFetch<OutreachLeadsResponse>(getGetOutreachLeadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachLeadsQueryKey = (
  params?: GetOutreachLeadsParams,
) => {
  return [`/api/outreach/leads`, ...(params ? [params] : [])] as const;
};

export const getGetOutreachLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachLeadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachLeads>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachLeadsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachLeads>>
  > = ({ signal }) => getOutreachLeads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachLeads>>
>;
export type GetOutreachLeadsQueryError = ErrorType<unknown>;

/**
 * @summary Get outreach leads for current user
 */

export function useGetOutreachLeads<
  TData = Awaited<ReturnType<typeof getOutreachLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachLeadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachLeads>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachLeadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDiscoverLeadsUrl = () => {
  return `/api/outreach/leads`;
};

/**
 * @summary Trigger AI discovery of new leads
 */
export const discoverLeads = async (
  discoverLeadsBody: DiscoverLeadsBody,
  options?: RequestInit,
): Promise<OutreachLeadsResponse> => {
  return customFetch<OutreachLeadsResponse>(getDiscoverLeadsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(discoverLeadsBody),
  });
};

export const getDiscoverLeadsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discoverLeads>>,
    TError,
    { data: BodyType<DiscoverLeadsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof discoverLeads>>,
  TError,
  { data: BodyType<DiscoverLeadsBody> },
  TContext
> => {
  const mutationKey = ["discoverLeads"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof discoverLeads>>,
    { data: BodyType<DiscoverLeadsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return discoverLeads(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DiscoverLeadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof discoverLeads>>
>;
export type DiscoverLeadsMutationBody = BodyType<DiscoverLeadsBody>;
export type DiscoverLeadsMutationError = ErrorType<unknown>;

/**
 * @summary Trigger AI discovery of new leads
 */
export const useDiscoverLeads = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discoverLeads>>,
    TError,
    { data: BodyType<DiscoverLeadsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof discoverLeads>>,
  TError,
  { data: BodyType<DiscoverLeadsBody> },
  TContext
> => {
  return useMutation(getDiscoverLeadsMutationOptions(options));
};

export const getCreateGoldenPathRunUrl = () => {
  return `/api/outreach/golden-path/runs`;
};

/**
 * @summary Create a Golden Path run
 */
export const createGoldenPathRun = async (
  goldenPathRunInput: GoldenPathRunInput,
  options?: RequestInit,
): Promise<GoldenPathRunEnvelope> => {
  return customFetch<GoldenPathRunEnvelope>(getCreateGoldenPathRunUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(goldenPathRunInput),
  });
};

export const getCreateGoldenPathRunMutationOptions = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoldenPathRun>>,
    TError,
    { data: BodyType<GoldenPathRunInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoldenPathRun>>,
  TError,
  { data: BodyType<GoldenPathRunInput> },
  TContext
> => {
  const mutationKey = ["createGoldenPathRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoldenPathRun>>,
    { data: BodyType<GoldenPathRunInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createGoldenPathRun(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoldenPathRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoldenPathRun>>
>;
export type CreateGoldenPathRunMutationBody = BodyType<GoldenPathRunInput>;
export type CreateGoldenPathRunMutationError =
  ErrorType<GoldenPathErrorResponse>;

/**
 * @summary Create a Golden Path run
 */
export const useCreateGoldenPathRun = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoldenPathRun>>,
    TError,
    { data: BodyType<GoldenPathRunInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoldenPathRun>>,
  TError,
  { data: BodyType<GoldenPathRunInput> },
  TContext
> => {
  return useMutation(getCreateGoldenPathRunMutationOptions(options));
};

export const getGetActiveGoldenPathRunUrl = () => {
  return `/api/outreach/golden-path/runs/active`;
};

/**
 * @summary Get the active Golden Path run
 */
export const getActiveGoldenPathRun = async (
  options?: RequestInit,
): Promise<GoldenPathRunEnvelope | null> => {
  return customFetch<GoldenPathRunEnvelope | null>(
    getGetActiveGoldenPathRunUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetActiveGoldenPathRunQueryKey = () => {
  return [`/api/outreach/golden-path/runs/active`] as const;
};

export const getGetActiveGoldenPathRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveGoldenPathRun>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveGoldenPathRun>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveGoldenPathRunQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveGoldenPathRun>>
  > = ({ signal }) => getActiveGoldenPathRun({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveGoldenPathRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveGoldenPathRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveGoldenPathRun>>
>;
export type GetActiveGoldenPathRunQueryError = ErrorType<unknown>;

/**
 * @summary Get the active Golden Path run
 */

export function useGetActiveGoldenPathRun<
  TData = Awaited<ReturnType<typeof getActiveGoldenPathRun>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveGoldenPathRun>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveGoldenPathRunQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGoldenPathRunUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}`;
};

/**
 * @summary Get a Golden Path run
 */
export const getGoldenPathRun = async (
  id: string,
  options?: RequestInit,
): Promise<GoldenPathRunEnvelope> => {
  return customFetch<GoldenPathRunEnvelope>(getGetGoldenPathRunUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGoldenPathRunQueryKey = (id: string) => {
  return [`/api/outreach/golden-path/runs/${id}`] as const;
};

export const getGetGoldenPathRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoldenPathRun>>,
  TError = ErrorType<GoldenPathErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathRun>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoldenPathRunQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoldenPathRun>>
  > = ({ signal }) => getGoldenPathRun(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoldenPathRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoldenPathRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoldenPathRun>>
>;
export type GetGoldenPathRunQueryError = ErrorType<GoldenPathErrorResponse>;

/**
 * @summary Get a Golden Path run
 */

export function useGetGoldenPathRun<
  TData = Awaited<ReturnType<typeof getGoldenPathRun>>,
  TError = ErrorType<GoldenPathErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathRun>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoldenPathRunQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getResumeGoldenPathRunUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}`;
};

/**
 * @summary Resume an interrupted Golden Path run
 */
export const resumeGoldenPathRun = async (
  id: string,
  goldenPathRunResumeInput: GoldenPathRunResumeInput,
  options?: RequestInit,
): Promise<GoldenPathRunEnvelope> => {
  return customFetch<GoldenPathRunEnvelope>(getResumeGoldenPathRunUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(goldenPathRunResumeInput),
  });
};

export const getResumeGoldenPathRunMutationOptions = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeGoldenPathRun>>,
    TError,
    { id: string; data: BodyType<GoldenPathRunResumeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeGoldenPathRun>>,
  TError,
  { id: string; data: BodyType<GoldenPathRunResumeInput> },
  TContext
> => {
  const mutationKey = ["resumeGoldenPathRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeGoldenPathRun>>,
    { id: string; data: BodyType<GoldenPathRunResumeInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resumeGoldenPathRun(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeGoldenPathRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeGoldenPathRun>>
>;
export type ResumeGoldenPathRunMutationBody =
  BodyType<GoldenPathRunResumeInput>;
export type ResumeGoldenPathRunMutationError =
  ErrorType<GoldenPathErrorResponse>;

/**
 * @summary Resume an interrupted Golden Path run
 */
export const useResumeGoldenPathRun = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeGoldenPathRun>>,
    TError,
    { id: string; data: BodyType<GoldenPathRunResumeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumeGoldenPathRun>>,
  TError,
  { id: string; data: BodyType<GoldenPathRunResumeInput> },
  TContext
> => {
  return useMutation(getResumeGoldenPathRunMutationOptions(options));
};

export const getGetGoldenPathRunSummaryUrl = (id: string) => {
  return `/api/outreach/golden-path/runs/${id}/summary`;
};

/**
 * @summary Get Golden Path run summary
 */
export const getGoldenPathRunSummary = async (
  id: string,
  options?: RequestInit,
): Promise<GoldenPathRunSummary> => {
  return customFetch<GoldenPathRunSummary>(getGetGoldenPathRunSummaryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGoldenPathRunSummaryQueryKey = (id: string) => {
  return [`/api/outreach/golden-path/runs/${id}/summary`] as const;
};

export const getGetGoldenPathRunSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoldenPathRunSummary>>,
  TError = ErrorType<GoldenPathErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathRunSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGoldenPathRunSummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoldenPathRunSummary>>
  > = ({ signal }) =>
    getGoldenPathRunSummary(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoldenPathRunSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoldenPathRunSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoldenPathRunSummary>>
>;
export type GetGoldenPathRunSummaryQueryError =
  ErrorType<GoldenPathErrorResponse>;

/**
 * @summary Get Golden Path run summary
 */

export function useGetGoldenPathRunSummary<
  TData = Awaited<ReturnType<typeof getGoldenPathRunSummary>>,
  TError = ErrorType<GoldenPathErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoldenPathRunSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoldenPathRunSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateGoldenPathCandidateSelectionUrl = (
  id: string,
  candidateId: string,
) => {
  return `/api/outreach/golden-path/runs/${id}/candidates/${candidateId}/selection`;
};

/**
 * @summary Select or deselect an eligible Golden Path candidate
 */
export const updateGoldenPathCandidateSelection = async (
  id: string,
  candidateId: string,
  goldenPathCandidateSelectionInput: GoldenPathCandidateSelectionInput,
  options?: RequestInit,
): Promise<GoldenPathCandidate> => {
  return customFetch<GoldenPathCandidate>(
    getUpdateGoldenPathCandidateSelectionUrl(id, candidateId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(goldenPathCandidateSelectionInput),
    },
  );
};

export const getUpdateGoldenPathCandidateSelectionMutationOptions = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>,
    TError,
    {
      id: string;
      candidateId: string;
      data: BodyType<GoldenPathCandidateSelectionInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>,
  TError,
  {
    id: string;
    candidateId: string;
    data: BodyType<GoldenPathCandidateSelectionInput>;
  },
  TContext
> => {
  const mutationKey = ["updateGoldenPathCandidateSelection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>,
    {
      id: string;
      candidateId: string;
      data: BodyType<GoldenPathCandidateSelectionInput>;
    }
  > = (props) => {
    const { id, candidateId, data } = props ?? {};

    return updateGoldenPathCandidateSelection(
      id,
      candidateId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGoldenPathCandidateSelectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>
>;
export type UpdateGoldenPathCandidateSelectionMutationBody =
  BodyType<GoldenPathCandidateSelectionInput>;
export type UpdateGoldenPathCandidateSelectionMutationError =
  ErrorType<GoldenPathErrorResponse>;

/**
 * @summary Select or deselect an eligible Golden Path candidate
 */
export const useUpdateGoldenPathCandidateSelection = <
  TError = ErrorType<GoldenPathErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>,
    TError,
    {
      id: string;
      candidateId: string;
      data: BodyType<GoldenPathCandidateSelectionInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGoldenPathCandidateSelection>>,
  TError,
  {
    id: string;
    candidateId: string;
    data: BodyType<GoldenPathCandidateSelectionInput>;
  },
  TContext
> => {
  return useMutation(
    getUpdateGoldenPathCandidateSelectionMutationOptions(options),
  );
};

export const getGetOutreachLeadUrl = (id: number) => {
  return `/api/outreach/leads/${id}`;
};

/**
 * @summary Get single outreach lead
 */
export const getOutreachLead = async (
  id: number,
  options?: RequestInit,
): Promise<OutreachLead> => {
  return customFetch<OutreachLead>(getGetOutreachLeadUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachLeadQueryKey = (id: number) => {
  return [`/api/outreach/leads/${id}`] as const;
};

export const getGetOutreachLeadQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachLead>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachLead>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOutreachLeadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreachLead>>> = ({
    signal,
  }) => getOutreachLead(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachLead>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachLeadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachLead>>
>;
export type GetOutreachLeadQueryError = ErrorType<unknown>;

/**
 * @summary Get single outreach lead
 */

export function useGetOutreachLead<
  TData = Awaited<ReturnType<typeof getOutreachLead>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachLead>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachLeadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateOutreachLeadUrl = (id: number) => {
  return `/api/outreach/leads/${id}`;
};

/**
 * @summary Update a lead
 */
export const updateOutreachLead = async (
  id: number,
  updateOutreachLeadBody: UpdateOutreachLeadBody,
  options?: RequestInit,
): Promise<OutreachLead> => {
  return customFetch<OutreachLead>(getUpdateOutreachLeadUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOutreachLeadBody),
  });
};

export const getUpdateOutreachLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOutreachLead>>,
    TError,
    { id: number; data: BodyType<UpdateOutreachLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOutreachLead>>,
  TError,
  { id: number; data: BodyType<UpdateOutreachLeadBody> },
  TContext
> => {
  const mutationKey = ["updateOutreachLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOutreachLead>>,
    { id: number; data: BodyType<UpdateOutreachLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOutreachLead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOutreachLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOutreachLead>>
>;
export type UpdateOutreachLeadMutationBody = BodyType<UpdateOutreachLeadBody>;
export type UpdateOutreachLeadMutationError = ErrorType<unknown>;

/**
 * @summary Update a lead
 */
export const useUpdateOutreachLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOutreachLead>>,
    TError,
    { id: number; data: BodyType<UpdateOutreachLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOutreachLead>>,
  TError,
  { id: number; data: BodyType<UpdateOutreachLeadBody> },
  TContext
> => {
  return useMutation(getUpdateOutreachLeadMutationOptions(options));
};

export const getGetOutreachEmailsUrl = (params?: GetOutreachEmailsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/outreach/emails?${stringifiedParams}`
    : `/api/outreach/emails`;
};

/**
 * @summary Get outreach emails
 */
export const getOutreachEmails = async (
  params?: GetOutreachEmailsParams,
  options?: RequestInit,
): Promise<OutreachEmailsResponse> => {
  return customFetch<OutreachEmailsResponse>(getGetOutreachEmailsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachEmailsQueryKey = (
  params?: GetOutreachEmailsParams,
) => {
  return [`/api/outreach/emails`, ...(params ? [params] : [])] as const;
};

export const getGetOutreachEmailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachEmails>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachEmailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachEmails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachEmailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachEmails>>
  > = ({ signal }) => getOutreachEmails(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachEmails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachEmailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachEmails>>
>;
export type GetOutreachEmailsQueryError = ErrorType<unknown>;

/**
 * @summary Get outreach emails
 */

export function useGetOutreachEmails<
  TData = Awaited<ReturnType<typeof getOutreachEmails>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachEmailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachEmails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachEmailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateOutreachEmailUrl = () => {
  return `/api/outreach/emails`;
};

/**
 * @summary Generate an AI outreach email for a lead
 */
export const generateOutreachEmail = async (
  generateEmailBody: GenerateEmailBody,
  options?: RequestInit,
): Promise<OutreachEmail> => {
  return customFetch<OutreachEmail>(getGenerateOutreachEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateEmailBody),
  });
};

export const getGenerateOutreachEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOutreachEmail>>,
    TError,
    { data: BodyType<GenerateEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOutreachEmail>>,
  TError,
  { data: BodyType<GenerateEmailBody> },
  TContext
> => {
  const mutationKey = ["generateOutreachEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOutreachEmail>>,
    { data: BodyType<GenerateEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateOutreachEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateOutreachEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOutreachEmail>>
>;
export type GenerateOutreachEmailMutationBody = BodyType<GenerateEmailBody>;
export type GenerateOutreachEmailMutationError = ErrorType<unknown>;

/**
 * @summary Generate an AI outreach email for a lead
 */
export const useGenerateOutreachEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOutreachEmail>>,
    TError,
    { data: BodyType<GenerateEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateOutreachEmail>>,
  TError,
  { data: BodyType<GenerateEmailBody> },
  TContext
> => {
  return useMutation(getGenerateOutreachEmailMutationOptions(options));
};

export const getSendOutreachEmailUrl = (id: number) => {
  return `/api/outreach/emails/${id}/send`;
};

/**
 * @summary Send an outreach email
 */
export const sendOutreachEmail = async (
  id: number,
  options?: RequestInit,
): Promise<OutreachEmail> => {
  return customFetch<OutreachEmail>(getSendOutreachEmailUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendOutreachEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOutreachEmail>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOutreachEmail>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendOutreachEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOutreachEmail>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendOutreachEmail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendOutreachEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendOutreachEmail>>
>;

export type SendOutreachEmailMutationError = ErrorType<unknown>;

/**
 * @summary Send an outreach email
 */
export const useSendOutreachEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOutreachEmail>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendOutreachEmail>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendOutreachEmailMutationOptions(options));
};

export const getGenerateEmailReplyUrl = (id: number) => {
  return `/api/outreach/emails/${id}/reply`;
};

/**
 * @summary Generate AI reply to an email thread
 */
export const generateEmailReply = async (
  id: number,
  generateReplyBody: GenerateReplyBody,
  options?: RequestInit,
): Promise<OutreachEmail> => {
  return customFetch<OutreachEmail>(getGenerateEmailReplyUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateReplyBody),
  });
};

export const getGenerateEmailReplyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailReply>>,
    TError,
    { id: number; data: BodyType<GenerateReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateEmailReply>>,
  TError,
  { id: number; data: BodyType<GenerateReplyBody> },
  TContext
> => {
  const mutationKey = ["generateEmailReply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateEmailReply>>,
    { id: number; data: BodyType<GenerateReplyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateEmailReply(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateEmailReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateEmailReply>>
>;
export type GenerateEmailReplyMutationBody = BodyType<GenerateReplyBody>;
export type GenerateEmailReplyMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI reply to an email thread
 */
export const useGenerateEmailReply = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailReply>>,
    TError,
    { id: number; data: BodyType<GenerateReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateEmailReply>>,
  TError,
  { id: number; data: BodyType<GenerateReplyBody> },
  TContext
> => {
  return useMutation(getGenerateEmailReplyMutationOptions(options));
};

export const getGetOutreachThreadsUrl = (params?: GetOutreachThreadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/outreach/threads?${stringifiedParams}`
    : `/api/outreach/threads`;
};

/**
 * @summary Get all email threads (one per lead)
 */
export const getOutreachThreads = async (
  params?: GetOutreachThreadsParams,
  options?: RequestInit,
): Promise<OutreachThreadsResponse> => {
  return customFetch<OutreachThreadsResponse>(
    getGetOutreachThreadsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetOutreachThreadsQueryKey = (
  params?: GetOutreachThreadsParams,
) => {
  return [`/api/outreach/threads`, ...(params ? [params] : [])] as const;
};

export const getGetOutreachThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachThreads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachThreads>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachThreadsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachThreads>>
  > = ({ signal }) => getOutreachThreads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachThreads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachThreads>>
>;
export type GetOutreachThreadsQueryError = ErrorType<unknown>;

/**
 * @summary Get all email threads (one per lead)
 */

export function useGetOutreachThreads<
  TData = Awaited<ReturnType<typeof getOutreachThreads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOutreachThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachThreads>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachThreadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOutreachThreadMessagesUrl = (id: number) => {
  return `/api/outreach/threads/${id}/messages`;
};

/**
 * @summary Get all messages in a thread
 */
export const getOutreachThreadMessages = async (
  id: number,
  options?: RequestInit,
): Promise<OutreachThreadDetail> => {
  return customFetch<OutreachThreadDetail>(
    getGetOutreachThreadMessagesUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetOutreachThreadMessagesQueryKey = (id: number) => {
  return [`/api/outreach/threads/${id}/messages`] as const;
};

export const getGetOutreachThreadMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachThreadMessages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachThreadMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachThreadMessagesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachThreadMessages>>
  > = ({ signal }) =>
    getOutreachThreadMessages(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachThreadMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachThreadMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachThreadMessages>>
>;
export type GetOutreachThreadMessagesQueryError = ErrorType<unknown>;

/**
 * @summary Get all messages in a thread
 */

export function useGetOutreachThreadMessages<
  TData = Awaited<ReturnType<typeof getOutreachThreadMessages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOutreachThreadMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachThreadMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getReplyToOutreachThreadUrl = (id: number) => {
  return `/api/outreach/threads/${id}/reply`;
};

/**
 * @summary Generate AI reply to a thread and record the inbound message
 */
export const replyToOutreachThread = async (
  id: number,
  generateReplyBody: GenerateReplyBody,
  options?: RequestInit,
): Promise<OutreachEmail> => {
  return customFetch<OutreachEmail>(getReplyToOutreachThreadUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateReplyBody),
  });
};

export const getReplyToOutreachThreadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyToOutreachThread>>,
    TError,
    { id: number; data: BodyType<GenerateReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replyToOutreachThread>>,
  TError,
  { id: number; data: BodyType<GenerateReplyBody> },
  TContext
> => {
  const mutationKey = ["replyToOutreachThread"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replyToOutreachThread>>,
    { id: number; data: BodyType<GenerateReplyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return replyToOutreachThread(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplyToOutreachThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof replyToOutreachThread>>
>;
export type ReplyToOutreachThreadMutationBody = BodyType<GenerateReplyBody>;
export type ReplyToOutreachThreadMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI reply to a thread and record the inbound message
 */
export const useReplyToOutreachThread = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyToOutreachThread>>,
    TError,
    { id: number; data: BodyType<GenerateReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof replyToOutreachThread>>,
  TError,
  { id: number; data: BodyType<GenerateReplyBody> },
  TContext
> => {
  return useMutation(getReplyToOutreachThreadMutationOptions(options));
};

export const getSendOutreachThreadReplyUrl = (id: number) => {
  return `/api/outreach/threads/${id}/send-reply`;
};

/**
 * @summary Send a user-authored reply directly to a lead thread
 */
export const sendOutreachThreadReply = async (
  id: number,
  sendThreadReplyBody: SendThreadReplyBody,
  options?: RequestInit,
): Promise<SendThreadReplyResponse> => {
  return customFetch<SendThreadReplyResponse>(
    getSendOutreachThreadReplyUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendThreadReplyBody),
    },
  );
};

export const getSendOutreachThreadReplyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOutreachThreadReply>>,
    TError,
    { id: number; data: BodyType<SendThreadReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOutreachThreadReply>>,
  TError,
  { id: number; data: BodyType<SendThreadReplyBody> },
  TContext
> => {
  const mutationKey = ["sendOutreachThreadReply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOutreachThreadReply>>,
    { id: number; data: BodyType<SendThreadReplyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendOutreachThreadReply(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendOutreachThreadReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendOutreachThreadReply>>
>;
export type SendOutreachThreadReplyMutationBody = BodyType<SendThreadReplyBody>;
export type SendOutreachThreadReplyMutationError = ErrorType<unknown>;

/**
 * @summary Send a user-authored reply directly to a lead thread
 */
export const useSendOutreachThreadReply = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOutreachThreadReply>>,
    TError,
    { id: number; data: BodyType<SendThreadReplyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendOutreachThreadReply>>,
  TError,
  { id: number; data: BodyType<SendThreadReplyBody> },
  TContext
> => {
  return useMutation(getSendOutreachThreadReplyMutationOptions(options));
};

export const getGetOutreachVerticalPacksUrl = () => {
  return `/api/outreach/vertical-packs`;
};

/**
 * @summary List available vertical intelligence packs
 */
export const getOutreachVerticalPacks = async (
  options?: RequestInit,
): Promise<VerticalPacksResponse> => {
  return customFetch<VerticalPacksResponse>(getGetOutreachVerticalPacksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachVerticalPacksQueryKey = () => {
  return [`/api/outreach/vertical-packs`] as const;
};

export const getGetOutreachVerticalPacksQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachVerticalPacks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachVerticalPacks>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachVerticalPacksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachVerticalPacks>>
  > = ({ signal }) => getOutreachVerticalPacks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachVerticalPacks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachVerticalPacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachVerticalPacks>>
>;
export type GetOutreachVerticalPacksQueryError = ErrorType<unknown>;

/**
 * @summary List available vertical intelligence packs
 */

export function useGetOutreachVerticalPacks<
  TData = Awaited<ReturnType<typeof getOutreachVerticalPacks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachVerticalPacks>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachVerticalPacksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOutreachSequencesUrl = () => {
  return `/api/outreach/sequences`;
};

/**
 * @summary List outreach sequences
 */
export const getOutreachSequences = async (
  options?: RequestInit,
): Promise<OutreachSequencesResponse> => {
  return customFetch<OutreachSequencesResponse>(getGetOutreachSequencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachSequencesQueryKey = () => {
  return [`/api/outreach/sequences`] as const;
};

export const getGetOutreachSequencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachSequences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachSequences>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOutreachSequencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachSequences>>
  > = ({ signal }) => getOutreachSequences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachSequences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachSequencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachSequences>>
>;
export type GetOutreachSequencesQueryError = ErrorType<unknown>;

/**
 * @summary List outreach sequences
 */

export function useGetOutreachSequences<
  TData = Awaited<ReturnType<typeof getOutreachSequences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachSequences>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachSequencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateOutreachSequenceUrl = () => {
  return `/api/outreach/sequences`;
};

/**
 * @summary Create a new outreach sequence
 */
export const createOutreachSequence = async (
  createOutreachSequenceBody: CreateOutreachSequenceBody,
  options?: RequestInit,
): Promise<OutreachSequence> => {
  return customFetch<OutreachSequence>(getCreateOutreachSequenceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createOutreachSequenceBody),
  });
};

export const getCreateOutreachSequenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachSequence>>,
    TError,
    { data: BodyType<CreateOutreachSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOutreachSequence>>,
  TError,
  { data: BodyType<CreateOutreachSequenceBody> },
  TContext
> => {
  const mutationKey = ["createOutreachSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOutreachSequence>>,
    { data: BodyType<CreateOutreachSequenceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createOutreachSequence(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOutreachSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOutreachSequence>>
>;
export type CreateOutreachSequenceMutationBody =
  BodyType<CreateOutreachSequenceBody>;
export type CreateOutreachSequenceMutationError = ErrorType<unknown>;

/**
 * @summary Create a new outreach sequence
 */
export const useCreateOutreachSequence = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachSequence>>,
    TError,
    { data: BodyType<CreateOutreachSequenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOutreachSequence>>,
  TError,
  { data: BodyType<CreateOutreachSequenceBody> },
  TContext
> => {
  return useMutation(getCreateOutreachSequenceMutationOptions(options));
};

export const getDeleteOutreachSequenceUrl = (id: number) => {
  return `/api/outreach/sequences/${id}`;
};

/**
 * @summary Delete an outreach sequence
 */
export const deleteOutreachSequence = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteOutreachSequenceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOutreachSequenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOutreachSequence>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOutreachSequence>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteOutreachSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOutreachSequence>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOutreachSequence(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOutreachSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOutreachSequence>>
>;

export type DeleteOutreachSequenceMutationError = ErrorType<unknown>;

/**
 * @summary Delete an outreach sequence
 */
export const useDeleteOutreachSequence = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOutreachSequence>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOutreachSequence>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteOutreachSequenceMutationOptions(options));
};

export const getEnrollLeadInSequenceUrl = (id: number) => {
  return `/api/outreach/sequences/${id}/enroll`;
};

/**
 * @summary Enroll a lead in a sequence
 */
export const enrollLeadInSequence = async (
  id: number,
  enrollLeadBody: EnrollLeadBody,
  options?: RequestInit,
): Promise<SequenceEnrollment> => {
  return customFetch<SequenceEnrollment>(getEnrollLeadInSequenceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(enrollLeadBody),
  });
};

export const getEnrollLeadInSequenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollLeadInSequence>>,
    TError,
    { id: number; data: BodyType<EnrollLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrollLeadInSequence>>,
  TError,
  { id: number; data: BodyType<EnrollLeadBody> },
  TContext
> => {
  const mutationKey = ["enrollLeadInSequence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrollLeadInSequence>>,
    { id: number; data: BodyType<EnrollLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return enrollLeadInSequence(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrollLeadInSequenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrollLeadInSequence>>
>;
export type EnrollLeadInSequenceMutationBody = BodyType<EnrollLeadBody>;
export type EnrollLeadInSequenceMutationError = ErrorType<unknown>;

/**
 * @summary Enroll a lead in a sequence
 */
export const useEnrollLeadInSequence = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollLeadInSequence>>,
    TError,
    { id: number; data: BodyType<EnrollLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enrollLeadInSequence>>,
  TError,
  { id: number; data: BodyType<EnrollLeadBody> },
  TContext
> => {
  return useMutation(getEnrollLeadInSequenceMutationOptions(options));
};

export const getGetLeadEnrollmentUrl = (id: number) => {
  return `/api/outreach/leads/${id}/enrollment`;
};

/**
 * @summary Get sequence enrollments for a lead
 */
export const getLeadEnrollment = async (
  id: number,
  options?: RequestInit,
): Promise<LeadEnrollmentsResponse> => {
  return customFetch<LeadEnrollmentsResponse>(getGetLeadEnrollmentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadEnrollmentQueryKey = (id: number) => {
  return [`/api/outreach/leads/${id}/enrollment`] as const;
};

export const getGetLeadEnrollmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadEnrollment>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeadEnrollment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadEnrollmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeadEnrollment>>
  > = ({ signal }) => getLeadEnrollment(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadEnrollment>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadEnrollmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadEnrollment>>
>;
export type GetLeadEnrollmentQueryError = ErrorType<unknown>;

/**
 * @summary Get sequence enrollments for a lead
 */

export function useGetLeadEnrollment<
  TData = Awaited<ReturnType<typeof getLeadEnrollment>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeadEnrollment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadEnrollmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPauseSequenceEnrollmentUrl = (id: number) => {
  return `/api/outreach/enrollments/${id}/pause`;
};

/**
 * @summary Pause a sequence enrollment
 */
export const pauseSequenceEnrollment = async (
  id: number,
  options?: RequestInit,
): Promise<SequenceEnrollment> => {
  return customFetch<SequenceEnrollment>(getPauseSequenceEnrollmentUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPauseSequenceEnrollmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseSequenceEnrollment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pauseSequenceEnrollment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["pauseSequenceEnrollment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseSequenceEnrollment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return pauseSequenceEnrollment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PauseSequenceEnrollmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof pauseSequenceEnrollment>>
>;

export type PauseSequenceEnrollmentMutationError = ErrorType<unknown>;

/**
 * @summary Pause a sequence enrollment
 */
export const usePauseSequenceEnrollment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseSequenceEnrollment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof pauseSequenceEnrollment>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPauseSequenceEnrollmentMutationOptions(options));
};

export const getEnrichOutreachLeadUrl = (id: number) => {
  return `/api/outreach/leads/${id}/enrich`;
};

/**
 * @summary AI-enrich a lead with company intelligence
 */
export const enrichOutreachLead = async (
  id: number,
  options?: RequestInit,
): Promise<OutreachLead> => {
  return customFetch<OutreachLead>(getEnrichOutreachLeadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getEnrichOutreachLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichOutreachLead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichOutreachLead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["enrichOutreachLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichOutreachLead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return enrichOutreachLead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichOutreachLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichOutreachLead>>
>;

export type EnrichOutreachLeadMutationError = ErrorType<unknown>;

/**
 * @summary AI-enrich a lead with company intelligence
 */
export const useEnrichOutreachLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichOutreachLead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enrichOutreachLead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getEnrichOutreachLeadMutationOptions(options));
};

export const getGetLeadScoreUrl = (id: number) => {
  return `/api/outreach/leads/${id}/score`;
};

/**
 * @summary Get persisted AI lead score (read-only, no AI call)
 */
export const getLeadScore = async (
  id: number,
  options?: RequestInit,
): Promise<LeadScoreResult> => {
  return customFetch<LeadScoreResult>(getGetLeadScoreUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadScoreQueryKey = (id: number) => {
  return [`/api/outreach/leads/${id}/score`] as const;
};

export const getGetLeadScoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadScore>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeadScore>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadScoreQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadScore>>> = ({
    signal,
  }) => getLeadScore(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadScore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadScoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadScore>>
>;
export type GetLeadScoreQueryError = ErrorType<unknown>;

/**
 * @summary Get persisted AI lead score (read-only, no AI call)
 */

export function useGetLeadScore<
  TData = Awaited<ReturnType<typeof getLeadScore>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeadScore>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadScoreQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getComputeLeadScoreUrl = (id: number) => {
  return `/api/outreach/leads/${id}/score`;
};

/**
 * @summary Trigger AI lead scoring, persist and return result
 */
export const computeLeadScore = async (
  id: number,
  options?: RequestInit,
): Promise<LeadScoreComputeResult> => {
  return customFetch<LeadScoreComputeResult>(getComputeLeadScoreUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getComputeLeadScoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computeLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computeLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["computeLeadScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computeLeadScore>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return computeLeadScore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputeLeadScoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof computeLeadScore>>
>;

export type ComputeLeadScoreMutationError = ErrorType<unknown>;

/**
 * @summary Trigger AI lead scoring, persist and return result
 */
export const useComputeLeadScore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computeLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof computeLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getComputeLeadScoreMutationOptions(options));
};

export const getBatchInferVerticalsUrl = () => {
  return `/api/outreach/leads/batch-infer-verticals`;
};

/**
 * @summary Bulk-classify all untagged leads into their verticals (admin only)
 */
export const batchInferVerticals = async (
  options?: RequestInit,
): Promise<BatchInferVerticalsResult> => {
  return customFetch<BatchInferVerticalsResult>(getBatchInferVerticalsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getBatchInferVerticalsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchInferVerticals>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchInferVerticals>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["batchInferVerticals"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchInferVerticals>>,
    void
  > = () => {
    return batchInferVerticals(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchInferVerticalsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchInferVerticals>>
>;

export type BatchInferVerticalsMutationError = ErrorType<void>;

/**
 * @summary Bulk-classify all untagged leads into their verticals (admin only)
 */
export const useBatchInferVerticals = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchInferVerticals>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof batchInferVerticals>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBatchInferVerticalsMutationOptions(options));
};

export const getGetOutreachAutoRunStatusUrl = () => {
  return `/api/outreach/auto-run/status`;
};

/**
 * @summary Get outreach auto-run enabled status
 */
export const getOutreachAutoRunStatus = async (
  options?: RequestInit,
): Promise<OutreachAutoRunStatus> => {
  return customFetch<OutreachAutoRunStatus>(getGetOutreachAutoRunStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOutreachAutoRunStatusQueryKey = () => {
  return [`/api/outreach/auto-run/status`] as const;
};

export const getGetOutreachAutoRunStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutreachAutoRunStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachAutoRunStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOutreachAutoRunStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOutreachAutoRunStatus>>
  > = ({ signal }) => getOutreachAutoRunStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutreachAutoRunStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOutreachAutoRunStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutreachAutoRunStatus>>
>;
export type GetOutreachAutoRunStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get outreach auto-run enabled status
 */

export function useGetOutreachAutoRunStatus<
  TData = Awaited<ReturnType<typeof getOutreachAutoRunStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOutreachAutoRunStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOutreachAutoRunStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetOutreachAutoRunStatusUrl = () => {
  return `/api/outreach/auto-run/status`;
};

/**
 * @summary Enable or disable outreach auto-run
 */
export const setOutreachAutoRunStatus = async (
  outreachAutoRunStatus: OutreachAutoRunStatus,
  options?: RequestInit,
): Promise<OutreachAutoRunStatus> => {
  return customFetch<OutreachAutoRunStatus>(getSetOutreachAutoRunStatusUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(outreachAutoRunStatus),
  });
};

export const getSetOutreachAutoRunStatusMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOutreachAutoRunStatus>>,
    TError,
    { data: BodyType<OutreachAutoRunStatus> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOutreachAutoRunStatus>>,
  TError,
  { data: BodyType<OutreachAutoRunStatus> },
  TContext
> => {
  const mutationKey = ["setOutreachAutoRunStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOutreachAutoRunStatus>>,
    { data: BodyType<OutreachAutoRunStatus> }
  > = (props) => {
    const { data } = props ?? {};

    return setOutreachAutoRunStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetOutreachAutoRunStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof setOutreachAutoRunStatus>>
>;
export type SetOutreachAutoRunStatusMutationBody =
  BodyType<OutreachAutoRunStatus>;
export type SetOutreachAutoRunStatusMutationError = ErrorType<void>;

/**
 * @summary Enable or disable outreach auto-run
 */
export const useSetOutreachAutoRunStatus = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOutreachAutoRunStatus>>,
    TError,
    { data: BodyType<OutreachAutoRunStatus> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setOutreachAutoRunStatus>>,
  TError,
  { data: BodyType<OutreachAutoRunStatus> },
  TContext
> => {
  return useMutation(getSetOutreachAutoRunStatusMutationOptions(options));
};

export const getTriggerOutreachAutoRunUrl = () => {
  return `/api/outreach/auto-run`;
};

/**
 * @summary Trigger full automated outreach cycle
 */
export const triggerOutreachAutoRun = async (
  options?: RequestInit,
): Promise<AutoRunResult> => {
  return customFetch<AutoRunResult>(getTriggerOutreachAutoRunUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTriggerOutreachAutoRunMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerOutreachAutoRun>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerOutreachAutoRun>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["triggerOutreachAutoRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerOutreachAutoRun>>,
    void
  > = () => {
    return triggerOutreachAutoRun(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerOutreachAutoRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerOutreachAutoRun>>
>;

export type TriggerOutreachAutoRunMutationError = ErrorType<unknown>;

/**
 * @summary Trigger full automated outreach cycle
 */
export const useTriggerOutreachAutoRun = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerOutreachAutoRun>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerOutreachAutoRun>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTriggerOutreachAutoRunMutationOptions(options));
};

export const getGetSocialPostsUrl = (params?: GetSocialPostsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/social/posts?${stringifiedParams}`
    : `/api/social/posts`;
};

/**
 * @summary Get social media posts
 */
export const getSocialPosts = async (
  params?: GetSocialPostsParams,
  options?: RequestInit,
): Promise<SocialPostsResponse> => {
  return customFetch<SocialPostsResponse>(getGetSocialPostsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialPostsQueryKey = (params?: GetSocialPostsParams) => {
  return [`/api/social/posts`, ...(params ? [params] : [])] as const;
};

export const getGetSocialPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialPosts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSocialPosts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSocialPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialPosts>>> = ({
    signal,
  }) => getSocialPosts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialPosts>>
>;
export type GetSocialPostsQueryError = ErrorType<unknown>;

/**
 * @summary Get social media posts
 */

export function useGetSocialPosts<
  TData = Awaited<ReturnType<typeof getSocialPosts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSocialPosts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialPostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateSocialPostUrl = () => {
  return `/api/social/posts`;
};

/**
 * @summary Generate AI social media content
 */
export const generateSocialPost = async (
  generateSocialPostBody: GenerateSocialPostBody,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getGenerateSocialPostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateSocialPostBody),
  });
};

export const getGenerateSocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSocialPost>>,
    TError,
    { data: BodyType<GenerateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSocialPost>>,
  TError,
  { data: BodyType<GenerateSocialPostBody> },
  TContext
> => {
  const mutationKey = ["generateSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSocialPost>>,
    { data: BodyType<GenerateSocialPostBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateSocialPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSocialPost>>
>;
export type GenerateSocialPostMutationBody = BodyType<GenerateSocialPostBody>;
export type GenerateSocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI social media content
 */
export const useGenerateSocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSocialPost>>,
    TError,
    { data: BodyType<GenerateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSocialPost>>,
  TError,
  { data: BodyType<GenerateSocialPostBody> },
  TContext
> => {
  return useMutation(getGenerateSocialPostMutationOptions(options));
};

export const getUpdateSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}`;
};

/**
 * @summary Update a social post
 */
export const updateSocialPost = async (
  id: number,
  updateSocialPostBody: UpdateSocialPostBody,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getUpdateSocialPostUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSocialPostBody),
  });
};

export const getUpdateSocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialPost>>,
    TError,
    { id: number; data: BodyType<UpdateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSocialPost>>,
  TError,
  { id: number; data: BodyType<UpdateSocialPostBody> },
  TContext
> => {
  const mutationKey = ["updateSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSocialPost>>,
    { id: number; data: BodyType<UpdateSocialPostBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSocialPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSocialPost>>
>;
export type UpdateSocialPostMutationBody = BodyType<UpdateSocialPostBody>;
export type UpdateSocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Update a social post
 */
export const useUpdateSocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialPost>>,
    TError,
    { id: number; data: BodyType<UpdateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSocialPost>>,
  TError,
  { id: number; data: BodyType<UpdateSocialPostBody> },
  TContext
> => {
  return useMutation(getUpdateSocialPostMutationOptions(options));
};

export const getDeleteSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}`;
};

/**
 * @summary Delete a social post
 */
export const deleteSocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteSocialPostUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSocialPost>>
>;

export type DeleteSocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Delete a social post
 */
export const useDeleteSocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSocialPostMutationOptions(options));
};

export const getPublishSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/publish`;
};

/**
 * @summary Publish a social post
 */
export const publishSocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getPublishSocialPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPublishSocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["publishSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishSocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return publishSocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishSocialPost>>
>;

export type PublishSocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Publish a social post
 */
export const usePublishSocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof publishSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPublishSocialPostMutationOptions(options));
};

export const getRetrySocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/retry`;
};

/**
 * @summary Retry a failed social post
 */
export const retrySocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getRetrySocialPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRetrySocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retrySocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retrySocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retrySocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retrySocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retrySocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetrySocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof retrySocialPost>>
>;

export type RetrySocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Retry a failed social post
 */
export const useRetrySocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retrySocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retrySocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRetrySocialPostMutationOptions(options));
};

export const getGetSocialSettingsUrl = () => {
  return `/api/social/settings`;
};

/**
 * @summary Get social platform API settings
 */
export const getSocialSettings = async (
  options?: RequestInit,
): Promise<SocialSettings> => {
  return customFetch<SocialSettings>(getGetSocialSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialSettingsQueryKey = () => {
  return [`/api/social/settings`] as const;
};

export const getGetSocialSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSocialSettings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSocialSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialSettings>>
  > = ({ signal }) => getSocialSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialSettings>>
>;
export type GetSocialSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get social platform API settings
 */

export function useGetSocialSettings<
  TData = Awaited<ReturnType<typeof getSocialSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSocialSettings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateSocialSettingsUrl = () => {
  return `/api/social/settings`;
};

/**
 * @summary Update social platform API settings
 */
export const updateSocialSettings = async (
  updateSocialSettingsBody: UpdateSocialSettingsBody,
  options?: RequestInit,
): Promise<SocialSettings> => {
  return customFetch<SocialSettings>(getUpdateSocialSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSocialSettingsBody),
  });
};

export const getUpdateSocialSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialSettings>>,
    TError,
    { data: BodyType<UpdateSocialSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSocialSettings>>,
  TError,
  { data: BodyType<UpdateSocialSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateSocialSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSocialSettings>>,
    { data: BodyType<UpdateSocialSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSocialSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSocialSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSocialSettings>>
>;
export type UpdateSocialSettingsMutationBody =
  BodyType<UpdateSocialSettingsBody>;
export type UpdateSocialSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update social platform API settings
 */
export const useUpdateSocialSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialSettings>>,
    TError,
    { data: BodyType<UpdateSocialSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSocialSettings>>,
  TError,
  { data: BodyType<UpdateSocialSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateSocialSettingsMutationOptions(options));
};

export const getTriggerSocialAutoGenerateUrl = () => {
  return `/api/social/auto-generate`;
};

/**
 * @summary Trigger automated social content generation and posting
 */
export const triggerSocialAutoGenerate = async (
  options?: RequestInit,
): Promise<AutoRunResult> => {
  return customFetch<AutoRunResult>(getTriggerSocialAutoGenerateUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTriggerSocialAutoGenerateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerSocialAutoGenerate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerSocialAutoGenerate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["triggerSocialAutoGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerSocialAutoGenerate>>,
    void
  > = () => {
    return triggerSocialAutoGenerate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerSocialAutoGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerSocialAutoGenerate>>
>;

export type TriggerSocialAutoGenerateMutationError = ErrorType<unknown>;

/**
 * @summary Trigger automated social content generation and posting
 */
export const useTriggerSocialAutoGenerate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerSocialAutoGenerate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerSocialAutoGenerate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTriggerSocialAutoGenerateMutationOptions(options));
};

export const getGetSocialTemplatesUrl = (params?: GetSocialTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/social/templates?${stringifiedParams}`
    : `/api/social/templates`;
};

/**
 * @summary Get content templates
 */
export const getSocialTemplates = async (
  params?: GetSocialTemplatesParams,
  options?: RequestInit,
): Promise<ContentTemplatesResponse> => {
  return customFetch<ContentTemplatesResponse>(
    getGetSocialTemplatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSocialTemplatesQueryKey = (
  params?: GetSocialTemplatesParams,
) => {
  return [`/api/social/templates`, ...(params ? [params] : [])] as const;
};

export const getGetSocialTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSocialTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSocialTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialTemplates>>
  > = ({ signal }) => getSocialTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialTemplates>>
>;
export type GetSocialTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary Get content templates
 */

export function useGetSocialTemplates<
  TData = Awaited<ReturnType<typeof getSocialTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSocialTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateSocialTemplateUrl = () => {
  return `/api/social/templates`;
};

/**
 * @summary Create a content template
 */
export const createSocialTemplate = async (
  createContentTemplateBody: CreateContentTemplateBody,
  options?: RequestInit,
): Promise<ContentTemplate> => {
  return customFetch<ContentTemplate>(getCreateSocialTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContentTemplateBody),
  });
};

export const getCreateSocialTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialTemplate>>,
    TError,
    { data: BodyType<CreateContentTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSocialTemplate>>,
  TError,
  { data: BodyType<CreateContentTemplateBody> },
  TContext
> => {
  const mutationKey = ["createSocialTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSocialTemplate>>,
    { data: BodyType<CreateContentTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSocialTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSocialTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSocialTemplate>>
>;
export type CreateSocialTemplateMutationBody =
  BodyType<CreateContentTemplateBody>;
export type CreateSocialTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a content template
 */
export const useCreateSocialTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialTemplate>>,
    TError,
    { data: BodyType<CreateContentTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSocialTemplate>>,
  TError,
  { data: BodyType<CreateContentTemplateBody> },
  TContext
> => {
  return useMutation(getCreateSocialTemplateMutationOptions(options));
};

export const getUpdateSocialTemplateUrl = (id: number) => {
  return `/api/social/templates/${id}`;
};

/**
 * @summary Update a content template
 */
export const updateSocialTemplate = async (
  id: number,
  updateSocialTemplateBody: UpdateSocialTemplateBody,
  options?: RequestInit,
): Promise<UpdateSocialTemplate200> => {
  return customFetch<UpdateSocialTemplate200>(getUpdateSocialTemplateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSocialTemplateBody),
  });
};

export const getUpdateSocialTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateSocialTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSocialTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateSocialTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateSocialTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSocialTemplate>>,
    { id: number; data: BodyType<UpdateSocialTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSocialTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSocialTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSocialTemplate>>
>;
export type UpdateSocialTemplateMutationBody =
  BodyType<UpdateSocialTemplateBody>;
export type UpdateSocialTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update a content template
 */
export const useUpdateSocialTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateSocialTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSocialTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateSocialTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateSocialTemplateMutationOptions(options));
};

export const getDeleteSocialTemplateUrl = (id: number) => {
  return `/api/social/templates/${id}`;
};

/**
 * @summary Delete a content template
 */
export const deleteSocialTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteSocialTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSocialTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSocialTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSocialTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSocialTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSocialTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSocialTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSocialTemplate>>
>;

export type DeleteSocialTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a content template
 */
export const useDeleteSocialTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSocialTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSocialTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSocialTemplateMutationOptions(options));
};

export const getUseSocialTemplateUrl = (id: number) => {
  return `/api/social/templates/${id}/use`;
};

/**
 * @summary Create a post from a template
 */
export const useSocialTemplate = async (
  id: number,
  useSocialTemplateBody?: UseSocialTemplateBody,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getUseSocialTemplateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(useSocialTemplateBody),
  });
};

export const getUseSocialTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof useSocialTemplate>>,
    TError,
    { id: number; data?: BodyType<UseSocialTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof useSocialTemplate>>,
  TError,
  { id: number; data?: BodyType<UseSocialTemplateBody> },
  TContext
> => {
  const mutationKey = ["useSocialTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof useSocialTemplate>>,
    { id: number; data?: BodyType<UseSocialTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return useSocialTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UseSocialTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof useSocialTemplate>>
>;
export type UseSocialTemplateMutationBody =
  | BodyType<UseSocialTemplateBody>
  | undefined;
export type UseSocialTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a post from a template
 */
export const useUseSocialTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof useSocialTemplate>>,
    TError,
    { id: number; data?: BodyType<UseSocialTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof useSocialTemplate>>,
  TError,
  { id: number; data?: BodyType<UseSocialTemplateBody> },
  TContext
> => {
  return useMutation(getUseSocialTemplateMutationOptions(options));
};

export const getGetSocialCalendarUrl = (params?: GetSocialCalendarParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/social/calendar?${stringifiedParams}`
    : `/api/social/calendar`;
};

/**
 * @summary Get social posts for a calendar month
 */
export const getSocialCalendar = async (
  params?: GetSocialCalendarParams,
  options?: RequestInit,
): Promise<SocialCalendarResponse> => {
  return customFetch<SocialCalendarResponse>(getGetSocialCalendarUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialCalendarQueryKey = (
  params?: GetSocialCalendarParams,
) => {
  return [`/api/social/calendar`, ...(params ? [params] : [])] as const;
};

export const getGetSocialCalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSocialCalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSocialCalendarQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialCalendar>>
  > = ({ signal }) => getSocialCalendar(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialCalendar>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialCalendarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialCalendar>>
>;
export type GetSocialCalendarQueryError = ErrorType<unknown>;

/**
 * @summary Get social posts for a calendar month
 */

export function useGetSocialCalendar<
  TData = Awaited<ReturnType<typeof getSocialCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSocialCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSocialCalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialCalendarQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateSocialPostFromContentUrl = () => {
  return `/api/social/posts/from-content`;
};

/**
 * @summary Create a social post from pre-generated content (no AI)
 */
export const createSocialPostFromContent = async (
  createSocialPostFromContentBody: CreateSocialPostFromContentBody,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getCreateSocialPostFromContentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSocialPostFromContentBody),
  });
};

export const getCreateSocialPostFromContentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialPostFromContent>>,
    TError,
    { data: BodyType<CreateSocialPostFromContentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSocialPostFromContent>>,
  TError,
  { data: BodyType<CreateSocialPostFromContentBody> },
  TContext
> => {
  const mutationKey = ["createSocialPostFromContent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSocialPostFromContent>>,
    { data: BodyType<CreateSocialPostFromContentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSocialPostFromContent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSocialPostFromContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSocialPostFromContent>>
>;
export type CreateSocialPostFromContentMutationBody =
  BodyType<CreateSocialPostFromContentBody>;
export type CreateSocialPostFromContentMutationError = ErrorType<unknown>;

/**
 * @summary Create a social post from pre-generated content (no AI)
 */
export const useCreateSocialPostFromContent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialPostFromContent>>,
    TError,
    { data: BodyType<CreateSocialPostFromContentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSocialPostFromContent>>,
  TError,
  { data: BodyType<CreateSocialPostFromContentBody> },
  TContext
> => {
  return useMutation(getCreateSocialPostFromContentMutationOptions(options));
};

export const getBulkGenerateSocialPostsUrl = () => {
  return `/api/social/posts/bulk-generate`;
};

/**
 * @summary AI bulk-generate multiple posts spread across a date range
 */
export const bulkGenerateSocialPosts = async (
  bulkGenerateSocialPostsBody: BulkGenerateSocialPostsBody,
  options?: RequestInit,
): Promise<BulkGenerateSocialPostsResponse> => {
  return customFetch<BulkGenerateSocialPostsResponse>(
    getBulkGenerateSocialPostsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkGenerateSocialPostsBody),
    },
  );
};

export const getBulkGenerateSocialPostsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkGenerateSocialPosts>>,
    TError,
    { data: BodyType<BulkGenerateSocialPostsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkGenerateSocialPosts>>,
  TError,
  { data: BodyType<BulkGenerateSocialPostsBody> },
  TContext
> => {
  const mutationKey = ["bulkGenerateSocialPosts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkGenerateSocialPosts>>,
    { data: BodyType<BulkGenerateSocialPostsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkGenerateSocialPosts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkGenerateSocialPostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkGenerateSocialPosts>>
>;
export type BulkGenerateSocialPostsMutationBody =
  BodyType<BulkGenerateSocialPostsBody>;
export type BulkGenerateSocialPostsMutationError = ErrorType<unknown>;

/**
 * @summary AI bulk-generate multiple posts spread across a date range
 */
export const useBulkGenerateSocialPosts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkGenerateSocialPosts>>,
    TError,
    { data: BodyType<BulkGenerateSocialPostsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkGenerateSocialPosts>>,
  TError,
  { data: BodyType<BulkGenerateSocialPostsBody> },
  TContext
> => {
  return useMutation(getBulkGenerateSocialPostsMutationOptions(options));
};

export const getSavePostAsTemplateUrl = (id: number) => {
  return `/api/social/posts/${id}/save-as-template`;
};

/**
 * @summary Save an existing post as a reusable template
 */
export const savePostAsTemplate = async (
  id: number,
  savePostAsTemplateBody?: SavePostAsTemplateBody,
  options?: RequestInit,
): Promise<ContentTemplate> => {
  return customFetch<ContentTemplate>(getSavePostAsTemplateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(savePostAsTemplateBody),
  });
};

export const getSavePostAsTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePostAsTemplate>>,
    TError,
    { id: number; data?: BodyType<SavePostAsTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savePostAsTemplate>>,
  TError,
  { id: number; data?: BodyType<SavePostAsTemplateBody> },
  TContext
> => {
  const mutationKey = ["savePostAsTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savePostAsTemplate>>,
    { id: number; data?: BodyType<SavePostAsTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return savePostAsTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavePostAsTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof savePostAsTemplate>>
>;
export type SavePostAsTemplateMutationBody =
  | BodyType<SavePostAsTemplateBody>
  | undefined;
export type SavePostAsTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Save an existing post as a reusable template
 */
export const useSavePostAsTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePostAsTemplate>>,
    TError,
    { id: number; data?: BodyType<SavePostAsTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof savePostAsTemplate>>,
  TError,
  { id: number; data?: BodyType<SavePostAsTemplateBody> },
  TContext
> => {
  return useMutation(getSavePostAsTemplateMutationOptions(options));
};

export const getScheduleSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/schedule`;
};

/**
 * @summary Schedule or unschedule a social post
 */
export const scheduleSocialPost = async (
  id: number,
  scheduleSocialPostBody?: ScheduleSocialPostBody,
  options?: RequestInit,
): Promise<SocialPost> => {
  return customFetch<SocialPost>(getScheduleSocialPostUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(scheduleSocialPostBody),
  });
};

export const getScheduleSocialPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    TError,
    { id: number; data?: BodyType<ScheduleSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleSocialPost>>,
  TError,
  { id: number; data?: BodyType<ScheduleSocialPostBody> },
  TContext
> => {
  const mutationKey = ["scheduleSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    { id: number; data?: BodyType<ScheduleSocialPostBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return scheduleSocialPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleSocialPost>>
>;
export type ScheduleSocialPostMutationBody =
  | BodyType<ScheduleSocialPostBody>
  | undefined;
export type ScheduleSocialPostMutationError = ErrorType<unknown>;

/**
 * @summary Schedule or unschedule a social post
 */
export const useScheduleSocialPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleSocialPost>>,
    TError,
    { id: number; data?: BodyType<ScheduleSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleSocialPost>>,
  TError,
  { id: number; data?: BodyType<ScheduleSocialPostBody> },
  TContext
> => {
  return useMutation(getScheduleSocialPostMutationOptions(options));
};

export const getGetListeningKeywordsUrl = () => {
  return `/api/social/keywords`;
};

/**
 * @summary Get tracked keywords
 */
export const getListeningKeywords = async (
  options?: RequestInit,
): Promise<ListeningKeywordsResponse> => {
  return customFetch<ListeningKeywordsResponse>(getGetListeningKeywordsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetListeningKeywordsQueryKey = () => {
  return [`/api/social/keywords`] as const;
};

export const getGetListeningKeywordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getListeningKeywords>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getListeningKeywords>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListeningKeywordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getListeningKeywords>>
  > = ({ signal }) => getListeningKeywords({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListeningKeywords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListeningKeywordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getListeningKeywords>>
>;
export type GetListeningKeywordsQueryError = ErrorType<unknown>;

/**
 * @summary Get tracked keywords
 */

export function useGetListeningKeywords<
  TData = Awaited<ReturnType<typeof getListeningKeywords>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getListeningKeywords>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListeningKeywordsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateListeningKeywordUrl = () => {
  return `/api/social/keywords`;
};

/**
 * @summary Add a keyword to track
 */
export const createListeningKeyword = async (
  createListeningKeywordBody: CreateListeningKeywordBody,
  options?: RequestInit,
): Promise<ListeningKeyword> => {
  return customFetch<ListeningKeyword>(getCreateListeningKeywordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createListeningKeywordBody),
  });
};

export const getCreateListeningKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createListeningKeyword>>,
    TError,
    { data: BodyType<CreateListeningKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createListeningKeyword>>,
  TError,
  { data: BodyType<CreateListeningKeywordBody> },
  TContext
> => {
  const mutationKey = ["createListeningKeyword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createListeningKeyword>>,
    { data: BodyType<CreateListeningKeywordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createListeningKeyword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateListeningKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof createListeningKeyword>>
>;
export type CreateListeningKeywordMutationBody =
  BodyType<CreateListeningKeywordBody>;
export type CreateListeningKeywordMutationError = ErrorType<unknown>;

/**
 * @summary Add a keyword to track
 */
export const useCreateListeningKeyword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createListeningKeyword>>,
    TError,
    { data: BodyType<CreateListeningKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createListeningKeyword>>,
  TError,
  { data: BodyType<CreateListeningKeywordBody> },
  TContext
> => {
  return useMutation(getCreateListeningKeywordMutationOptions(options));
};

export const getDeleteListeningKeywordUrl = (id: number) => {
  return `/api/social/keywords/${id}`;
};

/**
 * @summary Delete a keyword
 */
export const deleteListeningKeyword = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteListeningKeywordUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteListeningKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteListeningKeyword>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteListeningKeyword>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteListeningKeyword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteListeningKeyword>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteListeningKeyword(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteListeningKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteListeningKeyword>>
>;

export type DeleteListeningKeywordMutationError = ErrorType<unknown>;

/**
 * @summary Delete a keyword
 */
export const useDeleteListeningKeyword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteListeningKeyword>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteListeningKeyword>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteListeningKeywordMutationOptions(options));
};

export const getUpdateListeningKeywordUrl = (id: number) => {
  return `/api/social/keywords/${id}`;
};

/**
 * @summary Toggle keyword active/alert settings
 */
export const updateListeningKeyword = async (
  id: number,
  updateListeningKeywordBody: UpdateListeningKeywordBody,
  options?: RequestInit,
): Promise<ListeningKeyword> => {
  return customFetch<ListeningKeyword>(getUpdateListeningKeywordUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateListeningKeywordBody),
  });
};

export const getUpdateListeningKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateListeningKeyword>>,
    TError,
    { id: number; data: BodyType<UpdateListeningKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateListeningKeyword>>,
  TError,
  { id: number; data: BodyType<UpdateListeningKeywordBody> },
  TContext
> => {
  const mutationKey = ["updateListeningKeyword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateListeningKeyword>>,
    { id: number; data: BodyType<UpdateListeningKeywordBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateListeningKeyword(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateListeningKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateListeningKeyword>>
>;
export type UpdateListeningKeywordMutationBody =
  BodyType<UpdateListeningKeywordBody>;
export type UpdateListeningKeywordMutationError = ErrorType<unknown>;

/**
 * @summary Toggle keyword active/alert settings
 */
export const useUpdateListeningKeyword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateListeningKeyword>>,
    TError,
    { id: number; data: BodyType<UpdateListeningKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateListeningKeyword>>,
  TError,
  { id: number; data: BodyType<UpdateListeningKeywordBody> },
  TContext
> => {
  return useMutation(getUpdateListeningKeywordMutationOptions(options));
};

export const getGetBrandMentionsUrl = (params?: GetBrandMentionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/social/mentions?${stringifiedParams}`
    : `/api/social/mentions`;
};

/**
 * @summary Get brand mentions
 */
export const getBrandMentions = async (
  params?: GetBrandMentionsParams,
  options?: RequestInit,
): Promise<BrandMentionsResponse> => {
  return customFetch<BrandMentionsResponse>(getGetBrandMentionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetBrandMentionsQueryKey = (
  params?: GetBrandMentionsParams,
) => {
  return [`/api/social/mentions`, ...(params ? [params] : [])] as const;
};

export const getGetBrandMentionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBrandMentions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBrandMentionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBrandMentions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBrandMentionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBrandMentions>>
  > = ({ signal }) => getBrandMentions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBrandMentions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBrandMentionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBrandMentions>>
>;
export type GetBrandMentionsQueryError = ErrorType<unknown>;

/**
 * @summary Get brand mentions
 */

export function useGetBrandMentions<
  TData = Awaited<ReturnType<typeof getBrandMentions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBrandMentionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBrandMentions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBrandMentionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteMentionUrl = (id: number) => {
  return `/api/social/mentions/${id}`;
};

/**
 * @summary Delete a brand mention
 */
export const deleteMention = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteMentionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMentionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMention>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMention>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMention"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMention>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMention(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMentionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMention>>
>;

export type DeleteMentionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a brand mention
 */
export const useDeleteMention = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMention>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMention>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMentionMutationOptions(options));
};

export const getMarkMentionReadUrl = (id: number) => {
  return `/api/social/mentions/${id}/read`;
};

/**
 * @summary Mark a mention as read
 */
export const markMentionRead = async (
  id: number,
  options?: RequestInit,
): Promise<BrandMention> => {
  return customFetch<BrandMention>(getMarkMentionReadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkMentionReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMentionRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markMentionRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markMentionRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markMentionRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markMentionRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkMentionReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markMentionRead>>
>;

export type MarkMentionReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark a mention as read
 */
export const useMarkMentionRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMentionRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markMentionRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMarkMentionReadMutationOptions(options));
};

export const getRunListeningScanUrl = () => {
  return `/api/social/scan`;
};

/**
 * @summary AI scan for new brand mentions
 */
export const runListeningScan = async (
  options?: RequestInit,
): Promise<ListeningScanResult> => {
  return customFetch<ListeningScanResult>(getRunListeningScanUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRunListeningScanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runListeningScan>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runListeningScan>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runListeningScan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runListeningScan>>,
    void
  > = () => {
    return runListeningScan(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunListeningScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof runListeningScan>>
>;

export type RunListeningScanMutationError = ErrorType<unknown>;

/**
 * @summary AI scan for new brand mentions
 */
export const useRunListeningScan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runListeningScan>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runListeningScan>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunListeningScanMutationOptions(options));
};

export const getGetListeningInsightsUrl = () => {
  return `/api/social/insights`;
};

/**
 * @summary AI insights on brand mentions
 */
export const getListeningInsights = async (
  options?: RequestInit,
): Promise<ListeningInsightsResponse> => {
  return customFetch<ListeningInsightsResponse>(getGetListeningInsightsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetListeningInsightsQueryKey = () => {
  return [`/api/social/insights`] as const;
};

export const getGetListeningInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getListeningInsights>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getListeningInsights>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListeningInsightsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getListeningInsights>>
  > = ({ signal }) => getListeningInsights({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListeningInsights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListeningInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getListeningInsights>>
>;
export type GetListeningInsightsQueryError = ErrorType<unknown>;

/**
 * @summary AI insights on brand mentions
 */

export function useGetListeningInsights<
  TData = Awaited<ReturnType<typeof getListeningInsights>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getListeningInsights>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListeningInsightsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAbTestsUrl = () => {
  return `/api/abtests`;
};

/**
 * @summary Get all A/B tests
 */
export const getAbTests = async (
  options?: RequestInit,
): Promise<AbTestsResponse> => {
  return customFetch<AbTestsResponse>(getGetAbTestsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAbTestsQueryKey = () => {
  return [`/api/abtests`] as const;
};

export const getGetAbTestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAbTests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAbTests>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAbTestsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAbTests>>> = ({
    signal,
  }) => getAbTests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAbTests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAbTestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAbTests>>
>;
export type GetAbTestsQueryError = ErrorType<unknown>;

/**
 * @summary Get all A/B tests
 */

export function useGetAbTests<
  TData = Awaited<ReturnType<typeof getAbTests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAbTests>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAbTestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateAbTestUrl = () => {
  return `/api/abtests`;
};

/**
 * @summary Create a new A/B test with variants
 */
export const createAbTest = async (
  createAbTestBody: CreateAbTestBody,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getCreateAbTestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAbTestBody),
  });
};

export const getCreateAbTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  const mutationKey = ["createAbTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAbTest>>,
    { data: BodyType<CreateAbTestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAbTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAbTest>>
>;
export type CreateAbTestMutationBody = BodyType<CreateAbTestBody>;
export type CreateAbTestMutationError = ErrorType<unknown>;

/**
 * @summary Create a new A/B test with variants
 */
export const useCreateAbTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  return useMutation(getCreateAbTestMutationOptions(options));
};

export const getGenerateAbVariantsUrl = () => {
  return `/api/abtests/generate`;
};

/**
 * @summary AI-generate A/B test variants from base content
 */
export const generateAbVariants = async (
  generateAbVariantsBody: GenerateAbVariantsBody,
  options?: RequestInit,
): Promise<GeneratedVariantsResponse> => {
  return customFetch<GeneratedVariantsResponse>(getGenerateAbVariantsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateAbVariantsBody),
  });
};

export const getGenerateAbVariantsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAbVariants>>,
    TError,
    { data: BodyType<GenerateAbVariantsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAbVariants>>,
  TError,
  { data: BodyType<GenerateAbVariantsBody> },
  TContext
> => {
  const mutationKey = ["generateAbVariants"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAbVariants>>,
    { data: BodyType<GenerateAbVariantsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateAbVariants(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAbVariantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAbVariants>>
>;
export type GenerateAbVariantsMutationBody = BodyType<GenerateAbVariantsBody>;
export type GenerateAbVariantsMutationError = ErrorType<unknown>;

/**
 * @summary AI-generate A/B test variants from base content
 */
export const useGenerateAbVariants = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAbVariants>>,
    TError,
    { data: BodyType<GenerateAbVariantsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateAbVariants>>,
  TError,
  { data: BodyType<GenerateAbVariantsBody> },
  TContext
> => {
  return useMutation(getGenerateAbVariantsMutationOptions(options));
};

export const getGetAbTestUrl = (id: number) => {
  return `/api/abtests/${id}`;
};

/**
 * @summary Get a single A/B test with variants
 */
export const getAbTest = async (
  id: number,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getGetAbTestUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAbTestQueryKey = (id: number) => {
  return [`/api/abtests/${id}`] as const;
};

export const getGetAbTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getAbTest>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAbTest>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAbTestQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAbTest>>> = ({
    signal,
  }) => getAbTest(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAbTest>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetAbTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAbTest>>
>;
export type GetAbTestQueryError = ErrorType<unknown>;

/**
 * @summary Get a single A/B test with variants
 */

export function useGetAbTest<
  TData = Awaited<ReturnType<typeof getAbTest>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAbTest>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAbTestQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteAbTestUrl = (id: number) => {
  return `/api/abtests/${id}`;
};

/**
 * @summary Delete an A/B test
 */
export const deleteAbTest = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteAbTestUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAbTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAbTest>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAbTest>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAbTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAbTest>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAbTest(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAbTest>>
>;

export type DeleteAbTestMutationError = ErrorType<unknown>;

/**
 * @summary Delete an A/B test
 */
export const useDeleteAbTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAbTest>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAbTest>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAbTestMutationOptions(options));
};

export const getDeclareAbTestWinnerUrl = (id: number) => {
  return `/api/abtests/${id}/winner`;
};

/**
 * @summary Declare a winner variant for an A/B test
 */
export const declareAbTestWinner = async (
  id: number,
  declareAbTestWinnerBody: DeclareAbTestWinnerBody,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getDeclareAbTestWinnerUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(declareAbTestWinnerBody),
  });
};

export const getDeclareAbTestWinnerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof declareAbTestWinner>>,
    TError,
    { id: number; data: BodyType<DeclareAbTestWinnerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof declareAbTestWinner>>,
  TError,
  { id: number; data: BodyType<DeclareAbTestWinnerBody> },
  TContext
> => {
  const mutationKey = ["declareAbTestWinner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof declareAbTestWinner>>,
    { id: number; data: BodyType<DeclareAbTestWinnerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return declareAbTestWinner(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeclareAbTestWinnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof declareAbTestWinner>>
>;
export type DeclareAbTestWinnerMutationBody = BodyType<DeclareAbTestWinnerBody>;
export type DeclareAbTestWinnerMutationError = ErrorType<unknown>;

/**
 * @summary Declare a winner variant for an A/B test
 */
export const useDeclareAbTestWinner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof declareAbTestWinner>>,
    TError,
    { id: number; data: BodyType<DeclareAbTestWinnerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof declareAbTestWinner>>,
  TError,
  { id: number; data: BodyType<DeclareAbTestWinnerBody> },
  TContext
> => {
  return useMutation(getDeclareAbTestWinnerMutationOptions(options));
};

export const getAnalyzeAbTestUrl = (id: number) => {
  return `/api/abtests/${id}/ai-generate`;
};

/**
 * @summary AI analysis and recommendation for A/B test
 */
export const analyzeAbTest = async (
  id: number,
  options?: RequestInit,
): Promise<AbTestAnalysisResponse> => {
  return customFetch<AbTestAnalysisResponse>(getAnalyzeAbTestUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeAbTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAbTest>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeAbTest>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["analyzeAbTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeAbTest>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeAbTest(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeAbTest>>
>;

export type AnalyzeAbTestMutationError = ErrorType<unknown>;

/**
 * @summary AI analysis and recommendation for A/B test
 */
export const useAnalyzeAbTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAbTest>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeAbTest>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAnalyzeAbTestMutationOptions(options));
};

export const getListAbTestsUrl = () => {
  return `/api/ab-tests`;
};

/**
 * @summary List all A/B tests (resource-specific alias for /abtests)
 */
export const listAbTests = async (
  options?: RequestInit,
): Promise<AbTestsResponse> => {
  return customFetch<AbTestsResponse>(getListAbTestsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAbTestsQueryKey = () => {
  return [`/api/ab-tests`] as const;
};

export const getListAbTestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAbTests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listAbTests>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAbTestsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAbTests>>> = ({
    signal,
  }) => listAbTests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAbTests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAbTestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAbTests>>
>;
export type ListAbTestsQueryError = ErrorType<unknown>;

/**
 * @summary List all A/B tests (resource-specific alias for /abtests)
 */

export function useListAbTests<
  TData = Awaited<ReturnType<typeof listAbTests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listAbTests>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAbTestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateOutreachAbCampaignUrl = () => {
  return `/api/outreach/ab-campaigns`;
};

/**
 * @summary Automated 50/50 email A/B campaign split-send to a lead list
 */
export const createOutreachAbCampaign = async (
  createOutreachAbCampaignBody: CreateOutreachAbCampaignBody,
  options?: RequestInit,
): Promise<CreateOutreachAbCampaign201> => {
  return customFetch<CreateOutreachAbCampaign201>(
    getCreateOutreachAbCampaignUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createOutreachAbCampaignBody),
    },
  );
};

export const getCreateOutreachAbCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachAbCampaign>>,
    TError,
    { data: BodyType<CreateOutreachAbCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOutreachAbCampaign>>,
  TError,
  { data: BodyType<CreateOutreachAbCampaignBody> },
  TContext
> => {
  const mutationKey = ["createOutreachAbCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOutreachAbCampaign>>,
    { data: BodyType<CreateOutreachAbCampaignBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createOutreachAbCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOutreachAbCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOutreachAbCampaign>>
>;
export type CreateOutreachAbCampaignMutationBody =
  BodyType<CreateOutreachAbCampaignBody>;
export type CreateOutreachAbCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Automated 50/50 email A/B campaign split-send to a lead list
 */
export const useCreateOutreachAbCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachAbCampaign>>,
    TError,
    { data: BodyType<CreateOutreachAbCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOutreachAbCampaign>>,
  TError,
  { data: BodyType<CreateOutreachAbCampaignBody> },
  TContext
> => {
  return useMutation(getCreateOutreachAbCampaignMutationOptions(options));
};

export const getCreateOutreachAbTestUrl = () => {
  return `/api/outreach/ab-tests`;
};

/**
 * @summary Create an email subject-line A/B test from an outreach email
 */
export const createOutreachAbTest = async (
  createAbTestBody: CreateAbTestBody,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getCreateOutreachAbTestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAbTestBody),
  });
};

export const getCreateOutreachAbTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOutreachAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  const mutationKey = ["createOutreachAbTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOutreachAbTest>>,
    { data: BodyType<CreateAbTestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createOutreachAbTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOutreachAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOutreachAbTest>>
>;
export type CreateOutreachAbTestMutationBody = BodyType<CreateAbTestBody>;
export type CreateOutreachAbTestMutationError = ErrorType<unknown>;

/**
 * @summary Create an email subject-line A/B test from an outreach email
 */
export const useCreateOutreachAbTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOutreachAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOutreachAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  return useMutation(getCreateOutreachAbTestMutationOptions(options));
};

export const getCreateSocialAbTestUrl = () => {
  return `/api/social/ab-tests`;
};

/**
 * @summary Create a social post A/B test
 */
export const createSocialAbTest = async (
  createAbTestBody: CreateAbTestBody,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getCreateSocialAbTestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAbTestBody),
  });
};

export const getCreateSocialAbTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSocialAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  const mutationKey = ["createSocialAbTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSocialAbTest>>,
    { data: BodyType<CreateAbTestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSocialAbTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSocialAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSocialAbTest>>
>;
export type CreateSocialAbTestMutationBody = BodyType<CreateAbTestBody>;
export type CreateSocialAbTestMutationError = ErrorType<unknown>;

/**
 * @summary Create a social post A/B test
 */
export const useCreateSocialAbTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSocialAbTest>>,
    TError,
    { data: BodyType<CreateAbTestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSocialAbTest>>,
  TError,
  { data: BodyType<CreateAbTestBody> },
  TContext
> => {
  return useMutation(getCreateSocialAbTestMutationOptions(options));
};

export const getPatchAbTestWinnerUrl = (id: number) => {
  return `/api/ab-tests/${id}/winner`;
};

/**
 * @summary Declare a winner variant for an A/B test (PATCH method)
 */
export const patchAbTestWinner = async (
  id: number,
  patchAbTestWinnerBody: PatchAbTestWinnerBody,
  options?: RequestInit,
): Promise<AbTestWithVariants> => {
  return customFetch<AbTestWithVariants>(getPatchAbTestWinnerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchAbTestWinnerBody),
  });
};

export const getPatchAbTestWinnerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAbTestWinner>>,
    TError,
    { id: number; data: BodyType<PatchAbTestWinnerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAbTestWinner>>,
  TError,
  { id: number; data: BodyType<PatchAbTestWinnerBody> },
  TContext
> => {
  const mutationKey = ["patchAbTestWinner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAbTestWinner>>,
    { id: number; data: BodyType<PatchAbTestWinnerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchAbTestWinner(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAbTestWinnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAbTestWinner>>
>;
export type PatchAbTestWinnerMutationBody = BodyType<PatchAbTestWinnerBody>;
export type PatchAbTestWinnerMutationError = ErrorType<unknown>;

/**
 * @summary Declare a winner variant for an A/B test (PATCH method)
 */
export const usePatchAbTestWinner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAbTestWinner>>,
    TError,
    { id: number; data: BodyType<PatchAbTestWinnerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchAbTestWinner>>,
  TError,
  { id: number; data: BodyType<PatchAbTestWinnerBody> },
  TContext
> => {
  return useMutation(getPatchAbTestWinnerMutationOptions(options));
};

export const getGetDealsUrl = (params?: GetDealsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/deals?${stringifiedParams}`
    : `/api/deals`;
};

/**
 * @summary Get all deals grouped by pipeline stage
 */
export const getDeals = async (
  params?: GetDealsParams,
  options?: RequestInit,
): Promise<DealsResponse> => {
  return customFetch<DealsResponse>(getGetDealsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDealsQueryKey = (params?: GetDealsParams) => {
  return [`/api/deals`, ...(params ? [params] : [])] as const;
};

export const getGetDealsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeals>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDealsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDealsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeals>>> = ({
    signal,
  }) => getDeals(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDealsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeals>>
>;
export type GetDealsQueryError = ErrorType<unknown>;

/**
 * @summary Get all deals grouped by pipeline stage
 */

export function useGetDeals<
  TData = Awaited<ReturnType<typeof getDeals>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDealsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDealsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateDealUrl = () => {
  return `/api/deals`;
};

/**
 * @summary Create a new deal
 */
export const createDeal = async (
  createDealBody: CreateDealBody,
  options?: RequestInit,
): Promise<Deal> => {
  return customFetch<Deal>(getCreateDealUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDealBody),
  });
};

export const getCreateDealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeal>>,
    TError,
    { data: BodyType<CreateDealBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDeal>>,
  TError,
  { data: BodyType<CreateDealBody> },
  TContext
> => {
  const mutationKey = ["createDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDeal>>,
    { data: BodyType<CreateDealBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDeal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDeal>>
>;
export type CreateDealMutationBody = BodyType<CreateDealBody>;
export type CreateDealMutationError = ErrorType<unknown>;

/**
 * @summary Create a new deal
 */
export const useCreateDeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeal>>,
    TError,
    { data: BodyType<CreateDealBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDeal>>,
  TError,
  { data: BodyType<CreateDealBody> },
  TContext
> => {
  return useMutation(getCreateDealMutationOptions(options));
};

export const getGetDealUrl = (id: number) => {
  return `/api/deals/${id}`;
};

/**
 * @summary Get a deal with its activities
 */
export const getDeal = async (
  id: number,
  options?: RequestInit,
): Promise<DealDetailResponse> => {
  return customFetch<DealDetailResponse>(getGetDealUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDealQueryKey = (id: number) => {
  return [`/api/deals/${id}`] as const;
};

export const getGetDealQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDealQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeal>>> = ({
    signal,
  }) => getDeal(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetDealQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeal>>
>;
export type GetDealQueryError = ErrorType<unknown>;

/**
 * @summary Get a deal with its activities
 */

export function useGetDeal<
  TData = Awaited<ReturnType<typeof getDeal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDealQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateDealUrl = (id: number) => {
  return `/api/deals/${id}`;
};

/**
 * @summary Partially update a deal (including stage transitions with validation)
 */
export const updateDeal = async (
  id: number,
  updateDealBody: UpdateDealBody,
  options?: RequestInit,
): Promise<Deal> => {
  return customFetch<Deal>(getUpdateDealUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateDealBody),
  });
};

export const getUpdateDealMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeal>>,
    TError,
    { id: number; data: BodyType<UpdateDealBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeal>>,
  TError,
  { id: number; data: BodyType<UpdateDealBody> },
  TContext
> => {
  const mutationKey = ["updateDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeal>>,
    { id: number; data: BodyType<UpdateDealBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeal>>
>;
export type UpdateDealMutationBody = BodyType<UpdateDealBody>;
export type UpdateDealMutationError = ErrorType<void>;

/**
 * @summary Partially update a deal (including stage transitions with validation)
 */
export const useUpdateDeal = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeal>>,
    TError,
    { id: number; data: BodyType<UpdateDealBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDeal>>,
  TError,
  { id: number; data: BodyType<UpdateDealBody> },
  TContext
> => {
  return useMutation(getUpdateDealMutationOptions(options));
};

export const getDeleteDealUrl = (id: number) => {
  return `/api/deals/${id}`;
};

/**
 * @summary Delete a deal
 */
export const deleteDeal = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteDealUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDeal>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDeal>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDeal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDeal>>
>;

export type DeleteDealMutationError = ErrorType<unknown>;

/**
 * @summary Delete a deal
 */
export const useDeleteDeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDeal>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteDealMutationOptions(options));
};

export const getAddDealActivityUrl = (id: number) => {
  return `/api/deals/${id}/activities`;
};

/**
 * @summary Add a note or activity to a deal
 */
export const addDealActivity = async (
  id: number,
  addDealActivityBody: AddDealActivityBody,
  options?: RequestInit,
): Promise<DealActivity> => {
  return customFetch<DealActivity>(getAddDealActivityUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addDealActivityBody),
  });
};

export const getAddDealActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addDealActivity>>,
    TError,
    { id: number; data: BodyType<AddDealActivityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addDealActivity>>,
  TError,
  { id: number; data: BodyType<AddDealActivityBody> },
  TContext
> => {
  const mutationKey = ["addDealActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addDealActivity>>,
    { id: number; data: BodyType<AddDealActivityBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addDealActivity(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddDealActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof addDealActivity>>
>;
export type AddDealActivityMutationBody = BodyType<AddDealActivityBody>;
export type AddDealActivityMutationError = ErrorType<unknown>;

/**
 * @summary Add a note or activity to a deal
 */
export const useAddDealActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addDealActivity>>,
    TError,
    { id: number; data: BodyType<AddDealActivityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addDealActivity>>,
  TError,
  { id: number; data: BodyType<AddDealActivityBody> },
  TContext
> => {
  return useMutation(getAddDealActivityMutationOptions(options));
};

export const getGetDealAiAnalysisUrl = (id: number) => {
  return `/api/deals/${id}/ai-analysis`;
};

/**
 * @summary Get AI coaching and deal analysis
 */
export const getDealAiAnalysis = async (
  id: number,
  options?: RequestInit,
): Promise<DealAiAnalysis> => {
  return customFetch<DealAiAnalysis>(getGetDealAiAnalysisUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGetDealAiAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDealAiAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getDealAiAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["getDealAiAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDealAiAnalysis>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return getDealAiAnalysis(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetDealAiAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof getDealAiAnalysis>>
>;

export type GetDealAiAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary Get AI coaching and deal analysis
 */
export const useGetDealAiAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDealAiAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getDealAiAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getGetDealAiAnalysisMutationOptions(options));
};

export const getGetDealAttributionChainUrl = (id: number) => {
  return `/api/deals/${id}/attribution-chain`;
};

/**
 * @summary Get multi-touch attribution chain for a won deal
 */
export const getDealAttributionChain = async (
  id: number,
  options?: RequestInit,
): Promise<DealAttributionChain> => {
  return customFetch<DealAttributionChain>(getGetDealAttributionChainUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDealAttributionChainQueryKey = (id: number) => {
  return [`/api/deals/${id}/attribution-chain`] as const;
};

export const getGetDealAttributionChainQueryOptions = <
  TData = Awaited<ReturnType<typeof getDealAttributionChain>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealAttributionChain>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDealAttributionChainQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDealAttributionChain>>
  > = ({ signal }) =>
    getDealAttributionChain(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDealAttributionChain>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDealAttributionChainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDealAttributionChain>>
>;
export type GetDealAttributionChainQueryError = ErrorType<unknown>;

/**
 * @summary Get multi-touch attribution chain for a won deal
 */

export function useGetDealAttributionChain<
  TData = Awaited<ReturnType<typeof getDealAttributionChain>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealAttributionChain>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDealAttributionChainQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDealStatsUrl = () => {
  return `/api/deals/stats/summary`;
};

/**
 * @summary Get deal pipeline statistics
 */
export const getDealStats = async (
  options?: RequestInit,
): Promise<DealStats> => {
  return customFetch<DealStats>(getGetDealStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDealStatsQueryKey = () => {
  return [`/api/deals/stats/summary`] as const;
};

export const getGetDealStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDealStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDealStats>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDealStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDealStats>>> = ({
    signal,
  }) => getDealStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDealStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDealStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDealStats>>
>;
export type GetDealStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get deal pipeline statistics
 */

export function useGetDealStats<
  TData = Awaited<ReturnType<typeof getDealStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDealStats>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDealStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSeoAnalysisUrl = () => {
  return `/api/seo/analysis`;
};

/**
 * @summary Get current SEO/GEO analysis
 */
export const getSeoAnalysis = async (
  options?: RequestInit,
): Promise<SeoAnalysis> => {
  return customFetch<SeoAnalysis>(getGetSeoAnalysisUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoAnalysisQueryKey = () => {
  return [`/api/seo/analysis`] as const;
};

export const getGetSeoAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoAnalysis>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoAnalysis>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoAnalysisQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoAnalysis>>> = ({
    signal,
  }) => getSeoAnalysis({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoAnalysis>>
>;
export type GetSeoAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Get current SEO/GEO analysis
 */

export function useGetSeoAnalysis<
  TData = Awaited<ReturnType<typeof getSeoAnalysis>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoAnalysis>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoAnalysisQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRunSeoAnalysisUrl = () => {
  return `/api/seo/analysis`;
};

/**
 * @summary Run AI SEO/GEO analysis
 */
export const runSeoAnalysis = async (
  options?: RequestInit,
): Promise<SeoAnalysis> => {
  return customFetch<SeoAnalysis>(getRunSeoAnalysisUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRunSeoAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSeoAnalysis>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSeoAnalysis>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runSeoAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSeoAnalysis>>,
    void
  > = () => {
    return runSeoAnalysis(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSeoAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSeoAnalysis>>
>;

export type RunSeoAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary Run AI SEO/GEO analysis
 */
export const useRunSeoAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSeoAnalysis>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runSeoAnalysis>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunSeoAnalysisMutationOptions(options));
};

export const getGetSeoTasksUrl = () => {
  return `/api/seo/tasks`;
};

/**
 * @summary Get SEO task checklist
 */
export const getSeoTasks = async (
  options?: RequestInit,
): Promise<SeoTasksResponse> => {
  return customFetch<SeoTasksResponse>(getGetSeoTasksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoTasksQueryKey = () => {
  return [`/api/seo/tasks`] as const;
};

export const getGetSeoTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoTasks>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoTasksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoTasks>>> = ({
    signal,
  }) => getSeoTasks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoTasks>>
>;
export type GetSeoTasksQueryError = ErrorType<unknown>;

/**
 * @summary Get SEO task checklist
 */

export function useGetSeoTasks<
  TData = Awaited<ReturnType<typeof getSeoTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoTasks>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoTasksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCompleteSeoTaskUrl = (id: number) => {
  return `/api/seo/tasks/${id}/complete`;
};

/**
 * @summary Mark SEO task as complete
 */
export const completeSeoTask = async (
  id: number,
  options?: RequestInit,
): Promise<SeoTask> => {
  return customFetch<SeoTask>(getCompleteSeoTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCompleteSeoTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSeoTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeSeoTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["completeSeoTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeSeoTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return completeSeoTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteSeoTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeSeoTask>>
>;

export type CompleteSeoTaskMutationError = ErrorType<unknown>;

/**
 * @summary Mark SEO task as complete
 */
export const useCompleteSeoTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSeoTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeSeoTask>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCompleteSeoTaskMutationOptions(options));
};

export const getGenerateSeoContentUrl = () => {
  return `/api/seo/content-suggestions`;
};

/**
 * @summary Generate SEO content (blog post, meta tags, keywords)
 */
export const generateSeoContent = async (
  generateSeoContentBody: GenerateSeoContentBody,
  options?: RequestInit,
): Promise<SeoContentResponse> => {
  return customFetch<SeoContentResponse>(getGenerateSeoContentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateSeoContentBody),
  });
};

export const getGenerateSeoContentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSeoContent>>,
    TError,
    { data: BodyType<GenerateSeoContentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSeoContent>>,
  TError,
  { data: BodyType<GenerateSeoContentBody> },
  TContext
> => {
  const mutationKey = ["generateSeoContent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSeoContent>>,
    { data: BodyType<GenerateSeoContentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateSeoContent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSeoContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSeoContent>>
>;
export type GenerateSeoContentMutationBody = BodyType<GenerateSeoContentBody>;
export type GenerateSeoContentMutationError = ErrorType<unknown>;

/**
 * @summary Generate SEO content (blog post, meta tags, keywords)
 */
export const useGenerateSeoContent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSeoContent>>,
    TError,
    { data: BodyType<GenerateSeoContentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSeoContent>>,
  TError,
  { data: BodyType<GenerateSeoContentBody> },
  TContext
> => {
  return useMutation(getGenerateSeoContentMutationOptions(options));
};

export const getGetNetworkContactsUrl = (params?: GetNetworkContactsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/network/contacts?${stringifiedParams}`
    : `/api/network/contacts`;
};

/**
 * @summary Get network contacts
 */
export const getNetworkContacts = async (
  params?: GetNetworkContactsParams,
  options?: RequestInit,
): Promise<NetworkContactsResponse> => {
  return customFetch<NetworkContactsResponse>(
    getGetNetworkContactsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNetworkContactsQueryKey = (
  params?: GetNetworkContactsParams,
) => {
  return [`/api/network/contacts`, ...(params ? [params] : [])] as const;
};

export const getGetNetworkContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNetworkContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNetworkContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNetworkContacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNetworkContactsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNetworkContacts>>
  > = ({ signal }) => getNetworkContacts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNetworkContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNetworkContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNetworkContacts>>
>;
export type GetNetworkContactsQueryError = ErrorType<unknown>;

/**
 * @summary Get network contacts
 */

export function useGetNetworkContacts<
  TData = Awaited<ReturnType<typeof getNetworkContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNetworkContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNetworkContacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNetworkContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateNetworkContactUrl = () => {
  return `/api/network/contacts`;
};

/**
 * @summary Create a network contact
 */
export const createNetworkContact = async (
  createNetworkContactBody: CreateNetworkContactBody,
  options?: RequestInit,
): Promise<NetworkContact> => {
  return customFetch<NetworkContact>(getCreateNetworkContactUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNetworkContactBody),
  });
};

export const getCreateNetworkContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNetworkContact>>,
    TError,
    { data: BodyType<CreateNetworkContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNetworkContact>>,
  TError,
  { data: BodyType<CreateNetworkContactBody> },
  TContext
> => {
  const mutationKey = ["createNetworkContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNetworkContact>>,
    { data: BodyType<CreateNetworkContactBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createNetworkContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNetworkContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNetworkContact>>
>;
export type CreateNetworkContactMutationBody =
  BodyType<CreateNetworkContactBody>;
export type CreateNetworkContactMutationError = ErrorType<unknown>;

/**
 * @summary Create a network contact
 */
export const useCreateNetworkContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNetworkContact>>,
    TError,
    { data: BodyType<CreateNetworkContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNetworkContact>>,
  TError,
  { data: BodyType<CreateNetworkContactBody> },
  TContext
> => {
  return useMutation(getCreateNetworkContactMutationOptions(options));
};

export const getGetNetworkContactUrl = (id: number) => {
  return `/api/network/contacts/${id}`;
};

/**
 * @summary Get a network contact with interactions
 */
export const getNetworkContact = async (
  id: number,
  options?: RequestInit,
): Promise<NetworkContactDetail> => {
  return customFetch<NetworkContactDetail>(getGetNetworkContactUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetNetworkContactQueryKey = (id: number) => {
  return [`/api/network/contacts/${id}`] as const;
};

export const getGetNetworkContactQueryOptions = <
  TData = Awaited<ReturnType<typeof getNetworkContact>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNetworkContact>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNetworkContactQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNetworkContact>>
  > = ({ signal }) => getNetworkContact(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNetworkContact>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNetworkContactQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNetworkContact>>
>;
export type GetNetworkContactQueryError = ErrorType<unknown>;

/**
 * @summary Get a network contact with interactions
 */

export function useGetNetworkContact<
  TData = Awaited<ReturnType<typeof getNetworkContact>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNetworkContact>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNetworkContactQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateNetworkContactUrl = (id: number) => {
  return `/api/network/contacts/${id}`;
};

/**
 * @summary Update a network contact
 */
export const updateNetworkContact = async (
  id: number,
  updateNetworkContactBody: UpdateNetworkContactBody,
  options?: RequestInit,
): Promise<NetworkContact> => {
  return customFetch<NetworkContact>(getUpdateNetworkContactUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNetworkContactBody),
  });
};

export const getUpdateNetworkContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNetworkContact>>,
    TError,
    { id: number; data: BodyType<UpdateNetworkContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNetworkContact>>,
  TError,
  { id: number; data: BodyType<UpdateNetworkContactBody> },
  TContext
> => {
  const mutationKey = ["updateNetworkContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNetworkContact>>,
    { id: number; data: BodyType<UpdateNetworkContactBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNetworkContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNetworkContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNetworkContact>>
>;
export type UpdateNetworkContactMutationBody =
  BodyType<UpdateNetworkContactBody>;
export type UpdateNetworkContactMutationError = ErrorType<unknown>;

/**
 * @summary Update a network contact
 */
export const useUpdateNetworkContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNetworkContact>>,
    TError,
    { id: number; data: BodyType<UpdateNetworkContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNetworkContact>>,
  TError,
  { id: number; data: BodyType<UpdateNetworkContactBody> },
  TContext
> => {
  return useMutation(getUpdateNetworkContactMutationOptions(options));
};

export const getDeleteNetworkContactUrl = (id: number) => {
  return `/api/network/contacts/${id}`;
};

/**
 * @summary Delete a network contact
 */
export const deleteNetworkContact = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteNetworkContactUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteNetworkContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNetworkContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNetworkContact>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteNetworkContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNetworkContact>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNetworkContact(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNetworkContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNetworkContact>>
>;

export type DeleteNetworkContactMutationError = ErrorType<unknown>;

/**
 * @summary Delete a network contact
 */
export const useDeleteNetworkContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNetworkContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNetworkContact>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteNetworkContactMutationOptions(options));
};

export const getCreateContactInteractionUrl = (id: number) => {
  return `/api/network/contacts/${id}/interactions`;
};

/**
 * @summary Log a contact interaction
 */
export const createContactInteraction = async (
  id: number,
  createContactInteractionBody: CreateContactInteractionBody,
  options?: RequestInit,
): Promise<ContactInteraction> => {
  return customFetch<ContactInteraction>(getCreateContactInteractionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContactInteractionBody),
  });
};

export const getCreateContactInteractionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContactInteraction>>,
    TError,
    { id: number; data: BodyType<CreateContactInteractionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContactInteraction>>,
  TError,
  { id: number; data: BodyType<CreateContactInteractionBody> },
  TContext
> => {
  const mutationKey = ["createContactInteraction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactInteraction>>,
    { id: number; data: BodyType<CreateContactInteractionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createContactInteraction(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContactInteractionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactInteraction>>
>;
export type CreateContactInteractionMutationBody =
  BodyType<CreateContactInteractionBody>;
export type CreateContactInteractionMutationError = ErrorType<unknown>;

/**
 * @summary Log a contact interaction
 */
export const useCreateContactInteraction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContactInteraction>>,
    TError,
    { id: number; data: BodyType<CreateContactInteractionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContactInteraction>>,
  TError,
  { id: number; data: BodyType<CreateContactInteractionBody> },
  TContext
> => {
  return useMutation(getCreateContactInteractionMutationOptions(options));
};

export const getDeleteContactInteractionUrl = (id: number) => {
  return `/api/network/interactions/${id}`;
};

/**
 * @summary Delete a contact interaction
 */
export const deleteContactInteraction = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteContactInteractionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContactInteractionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactInteraction>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactInteraction>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContactInteraction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactInteraction>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContactInteraction(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactInteractionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactInteraction>>
>;

export type DeleteContactInteractionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contact interaction
 */
export const useDeleteContactInteraction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactInteraction>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactInteraction>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContactInteractionMutationOptions(options));
};

export const getGetContactAiInsightsUrl = (id: number) => {
  return `/api/network/contacts/${id}/ai-insights`;
};

/**
 * @summary Generate AI relationship insights for a contact
 */
export const getContactAiInsights = async (
  id: number,
  options?: RequestInit,
): Promise<ContactAiInsights> => {
  return customFetch<ContactAiInsights>(getGetContactAiInsightsUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGetContactAiInsightsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getContactAiInsights>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getContactAiInsights>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["getContactAiInsights"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getContactAiInsights>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return getContactAiInsights(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetContactAiInsightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getContactAiInsights>>
>;

export type GetContactAiInsightsMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI relationship insights for a contact
 */
export const useGetContactAiInsights = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getContactAiInsights>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getContactAiInsights>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getGetContactAiInsightsMutationOptions(options));
};

export const getGetContactAllTagsUrl = () => {
  return `/api/network/contacts/tags`;
};

/**
 * @summary Get all distinct tags used by the user
 */
export const getContactAllTags = async (
  options?: RequestInit,
): Promise<GetContactAllTags200> => {
  return customFetch<GetContactAllTags200>(getGetContactAllTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetContactAllTagsQueryKey = () => {
  return [`/api/network/contacts/tags`] as const;
};

export const getGetContactAllTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactAllTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getContactAllTags>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactAllTagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactAllTags>>
  > = ({ signal }) => getContactAllTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactAllTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactAllTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactAllTags>>
>;
export type GetContactAllTagsQueryError = ErrorType<unknown>;

/**
 * @summary Get all distinct tags used by the user
 */

export function useGetContactAllTags<
  TData = Awaited<ReturnType<typeof getContactAllTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getContactAllTags>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactAllTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetContactSmartListsUrl = () => {
  return `/api/network/contacts/smart-lists`;
};

/**
 * @summary Get smart list segment counts
 */
export const getContactSmartLists = async (
  options?: RequestInit,
): Promise<ContactSmartListsResponse> => {
  return customFetch<ContactSmartListsResponse>(getGetContactSmartListsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetContactSmartListsQueryKey = () => {
  return [`/api/network/contacts/smart-lists`] as const;
};

export const getGetContactSmartListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactSmartLists>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getContactSmartLists>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactSmartListsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactSmartLists>>
  > = ({ signal }) => getContactSmartLists({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactSmartLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactSmartListsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactSmartLists>>
>;
export type GetContactSmartListsQueryError = ErrorType<unknown>;

/**
 * @summary Get smart list segment counts
 */

export function useGetContactSmartLists<
  TData = Awaited<ReturnType<typeof getContactSmartLists>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getContactSmartLists>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactSmartListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportContactsUrl = () => {
  return `/api/network/contacts/export`;
};

/**
 * @summary Export contacts as CSV
 */
export const exportContacts = async (
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportContactsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportContactsQueryKey = () => {
  return [`/api/network/contacts/export`] as const;
};

export const getExportContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportContacts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportContacts>>> = ({
    signal,
  }) => exportContacts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportContacts>>
>;
export type ExportContactsQueryError = ErrorType<unknown>;

/**
 * @summary Export contacts as CSV
 */

export function useExportContacts<
  TData = Awaited<ReturnType<typeof exportContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportContacts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getImportContactsUrl = () => {
  return `/api/network/contacts/import`;
};

/**
 * @summary Import contacts from CSV
 */
export const importContacts = async (
  importContactsBody: ImportContactsBody,
  options?: RequestInit,
): Promise<ImportContactsResult> => {
  return customFetch<ImportContactsResult>(getImportContactsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(importContactsBody),
  });
};

export const getImportContactsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importContacts>>,
    TError,
    { data: BodyType<ImportContactsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importContacts>>,
  TError,
  { data: BodyType<ImportContactsBody> },
  TContext
> => {
  const mutationKey = ["importContacts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importContacts>>,
    { data: BodyType<ImportContactsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return importContacts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportContactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importContacts>>
>;
export type ImportContactsMutationBody = BodyType<ImportContactsBody>;
export type ImportContactsMutationError = ErrorType<unknown>;

/**
 * @summary Import contacts from CSV
 */
export const useImportContacts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importContacts>>,
    TError,
    { data: BodyType<ImportContactsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importContacts>>,
  TError,
  { data: BodyType<ImportContactsBody> },
  TContext
> => {
  return useMutation(getImportContactsMutationOptions(options));
};

export const getAddContactTagUrl = (id: number) => {
  return `/api/network/contacts/${id}/tags`;
};

/**
 * @summary Add a tag to a contact
 */
export const addContactTag = async (
  id: number,
  addContactTagBody: AddContactTagBody,
  options?: RequestInit,
): Promise<ContactTag> => {
  return customFetch<ContactTag>(getAddContactTagUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addContactTagBody),
  });
};

export const getAddContactTagMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactTag>>,
    TError,
    { id: number; data: BodyType<AddContactTagBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addContactTag>>,
  TError,
  { id: number; data: BodyType<AddContactTagBody> },
  TContext
> => {
  const mutationKey = ["addContactTag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addContactTag>>,
    { id: number; data: BodyType<AddContactTagBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addContactTag(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddContactTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof addContactTag>>
>;
export type AddContactTagMutationBody = BodyType<AddContactTagBody>;
export type AddContactTagMutationError = ErrorType<unknown>;

/**
 * @summary Add a tag to a contact
 */
export const useAddContactTag = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactTag>>,
    TError,
    { id: number; data: BodyType<AddContactTagBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addContactTag>>,
  TError,
  { id: number; data: BodyType<AddContactTagBody> },
  TContext
> => {
  return useMutation(getAddContactTagMutationOptions(options));
};

export const getRemoveContactTagUrl = (id: number, tag: string) => {
  return `/api/network/contacts/${id}/tags/${tag}`;
};

/**
 * @summary Remove a tag from a contact
 */
export const removeContactTag = async (
  id: number,
  tag: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRemoveContactTagUrl(id, tag), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveContactTagMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContactTag>>,
    TError,
    { id: number; tag: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeContactTag>>,
  TError,
  { id: number; tag: string },
  TContext
> => {
  const mutationKey = ["removeContactTag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeContactTag>>,
    { id: number; tag: string }
  > = (props) => {
    const { id, tag } = props ?? {};

    return removeContactTag(id, tag, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveContactTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeContactTag>>
>;

export type RemoveContactTagMutationError = ErrorType<unknown>;

/**
 * @summary Remove a tag from a contact
 */
export const useRemoveContactTag = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContactTag>>,
    TError,
    { id: number; tag: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeContactTag>>,
  TError,
  { id: number; tag: string },
  TContext
> => {
  return useMutation(getRemoveContactTagMutationOptions(options));
};

export const getGetContactNotesUrl = (id: number) => {
  return `/api/network/contacts/${id}/notes`;
};

/**
 * @summary Get notes for a contact
 */
export const getContactNotes = async (
  id: number,
  options?: RequestInit,
): Promise<ContactNotesResponse> => {
  return customFetch<ContactNotesResponse>(getGetContactNotesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactNotesQueryKey = (id: number) => {
  return [`/api/network/contacts/${id}/notes`] as const;
};

export const getGetContactNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactNotes>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactNotes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactNotesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactNotes>>> = ({
    signal,
  }) => getContactNotes(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactNotes>>
>;
export type GetContactNotesQueryError = ErrorType<unknown>;

/**
 * @summary Get notes for a contact
 */

export function useGetContactNotes<
  TData = Awaited<ReturnType<typeof getContactNotes>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactNotes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactNotesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAddContactNoteUrl = (id: number) => {
  return `/api/network/contacts/${id}/notes`;
};

/**
 * @summary Add a note to a contact
 */
export const addContactNote = async (
  id: number,
  addContactNoteBody: AddContactNoteBody,
  options?: RequestInit,
): Promise<ContactNote> => {
  return customFetch<ContactNote>(getAddContactNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addContactNoteBody),
  });
};

export const getAddContactNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactNote>>,
    TError,
    { id: number; data: BodyType<AddContactNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addContactNote>>,
  TError,
  { id: number; data: BodyType<AddContactNoteBody> },
  TContext
> => {
  const mutationKey = ["addContactNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addContactNote>>,
    { id: number; data: BodyType<AddContactNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addContactNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddContactNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof addContactNote>>
>;
export type AddContactNoteMutationBody = BodyType<AddContactNoteBody>;
export type AddContactNoteMutationError = ErrorType<unknown>;

/**
 * @summary Add a note to a contact
 */
export const useAddContactNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactNote>>,
    TError,
    { id: number; data: BodyType<AddContactNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addContactNote>>,
  TError,
  { id: number; data: BodyType<AddContactNoteBody> },
  TContext
> => {
  return useMutation(getAddContactNoteMutationOptions(options));
};

export const getDeleteContactNoteUrl = (id: number) => {
  return `/api/network/notes/${id}`;
};

/**
 * @summary Delete a contact note
 */
export const deleteContactNote = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteContactNoteUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContactNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactNote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactNote>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContactNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactNote>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContactNote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactNote>>
>;

export type DeleteContactNoteMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contact note
 */
export const useDeleteContactNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactNote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactNote>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContactNoteMutationOptions(options));
};

export const getGetContactTimelineUrl = (id: number) => {
  return `/api/network/contacts/${id}/timeline`;
};

/**
 * @summary Get activity timeline for a contact
 */
export const getContactTimeline = async (
  id: number,
  options?: RequestInit,
): Promise<ContactTimelineResponse> => {
  return customFetch<ContactTimelineResponse>(getGetContactTimelineUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactTimelineQueryKey = (id: number) => {
  return [`/api/network/contacts/${id}/timeline`] as const;
};

export const getGetContactTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactTimeline>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactTimeline>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactTimelineQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactTimeline>>
  > = ({ signal }) => getContactTimeline(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactTimeline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactTimeline>>
>;
export type GetContactTimelineQueryError = ErrorType<unknown>;

/**
 * @summary Get activity timeline for a contact
 */

export function useGetContactTimeline<
  TData = Awaited<ReturnType<typeof getContactTimeline>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactTimeline>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactTimelineQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAnalyticsDashboardUrl = () => {
  return `/api/analytics/dashboard`;
};

/**
 * @summary Get analytics dashboard data
 */
export const getAnalyticsDashboard = async (
  options?: RequestInit,
): Promise<AnalyticsDashboard> => {
  return customFetch<AnalyticsDashboard>(getGetAnalyticsDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsDashboardQueryKey = () => {
  return [`/api/analytics/dashboard`] as const;
};

export const getGetAnalyticsDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsDashboard>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsDashboard>>
  > = ({ signal }) => getAnalyticsDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsDashboard>>
>;
export type GetAnalyticsDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Get analytics dashboard data
 */

export function useGetAnalyticsDashboard<
  TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsDashboard>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getTrackAnalyticsEventUrl = () => {
  return `/api/analytics/events`;
};

/**
 * @summary Track an analytics event
 */
export const trackAnalyticsEvent = async (
  trackEventBody: TrackEventBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getTrackAnalyticsEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trackEventBody),
  });
};

export const getTrackAnalyticsEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAnalyticsEvent>>,
    TError,
    { data: BodyType<TrackEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAnalyticsEvent>>,
  TError,
  { data: BodyType<TrackEventBody> },
  TContext
> => {
  const mutationKey = ["trackAnalyticsEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAnalyticsEvent>>,
    { data: BodyType<TrackEventBody> }
  > = (props) => {
    const { data } = props ?? {};

    return trackAnalyticsEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAnalyticsEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAnalyticsEvent>>
>;
export type TrackAnalyticsEventMutationBody = BodyType<TrackEventBody>;
export type TrackAnalyticsEventMutationError = ErrorType<unknown>;

/**
 * @summary Track an analytics event
 */
export const useTrackAnalyticsEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAnalyticsEvent>>,
    TError,
    { data: BodyType<TrackEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof trackAnalyticsEvent>>,
  TError,
  { data: BodyType<TrackEventBody> },
  TContext
> => {
  return useMutation(getTrackAnalyticsEventMutationOptions(options));
};

export const getGetAnalyticsAttributionUrl = () => {
  return `/api/analytics/attribution`;
};

/**
 * @summary Get revenue attribution dashboard data
 */
export const getAnalyticsAttribution = async (
  options?: RequestInit,
): Promise<AttributionDashboard> => {
  return customFetch<AttributionDashboard>(getGetAnalyticsAttributionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsAttributionQueryKey = () => {
  return [`/api/analytics/attribution`] as const;
};

export const getGetAnalyticsAttributionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsAttribution>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsAttribution>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsAttributionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsAttribution>>
  > = ({ signal }) => getAnalyticsAttribution({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsAttribution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsAttributionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsAttribution>>
>;
export type GetAnalyticsAttributionQueryError = ErrorType<unknown>;

/**
 * @summary Get revenue attribution dashboard data
 */

export function useGetAnalyticsAttribution<
  TData = Awaited<ReturnType<typeof getAnalyticsAttribution>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsAttribution>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsAttributionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAnalyticsReportUrl = (params?: GetAnalyticsReportParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/report?${stringifiedParams}`
    : `/api/analytics/report`;
};

/**
 * @summary Get aggregated KPI data and chart series for a date range
 */
export const getAnalyticsReport = async (
  params?: GetAnalyticsReportParams,
  options?: RequestInit,
): Promise<GetAnalyticsReport200> => {
  return customFetch<GetAnalyticsReport200>(getGetAnalyticsReportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsReportQueryKey = (
  params?: GetAnalyticsReportParams,
) => {
  return [`/api/analytics/report`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsReport>>
  > = ({ signal }) => getAnalyticsReport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsReport>>
>;
export type GetAnalyticsReportQueryError = ErrorType<unknown>;

/**
 * @summary Get aggregated KPI data and chart series for a date range
 */

export function useGetAnalyticsReport<
  TData = Awaited<ReturnType<typeof getAnalyticsReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportAnalyticsReportUrl = () => {
  return `/api/analytics/report/export`;
};

/**
 * @summary Export analytics report as PDF (default) or CSV raw data table
 */
export const exportAnalyticsReport = async (
  exportAnalyticsReportBody?: ExportAnalyticsReportBody,
  options?: RequestInit,
): Promise<Blob | string> => {
  return customFetch<Blob | string>(getExportAnalyticsReportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exportAnalyticsReportBody),
  });
};

export const getExportAnalyticsReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAnalyticsReport>>,
    TError,
    { data?: BodyType<ExportAnalyticsReportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAnalyticsReport>>,
  TError,
  { data?: BodyType<ExportAnalyticsReportBody> },
  TContext
> => {
  const mutationKey = ["exportAnalyticsReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAnalyticsReport>>,
    { data?: BodyType<ExportAnalyticsReportBody> }
  > = (props) => {
    const { data } = props ?? {};

    return exportAnalyticsReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAnalyticsReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAnalyticsReport>>
>;
export type ExportAnalyticsReportMutationBody =
  | BodyType<ExportAnalyticsReportBody>
  | undefined;
export type ExportAnalyticsReportMutationError = ErrorType<unknown>;

/**
 * @summary Export analytics report as PDF (default) or CSV raw data table
 */
export const useExportAnalyticsReport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAnalyticsReport>>,
    TError,
    { data?: BodyType<ExportAnalyticsReportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportAnalyticsReport>>,
  TError,
  { data?: BodyType<ExportAnalyticsReportBody> },
  TContext
> => {
  return useMutation(getExportAnalyticsReportMutationOptions(options));
};

export const getGetReportScheduleUrl = () => {
  return `/api/settings/report-schedule`;
};

/**
 * @summary Get automated report schedule settings
 */
export const getReportSchedule = async (
  options?: RequestInit,
): Promise<GetReportSchedule200> => {
  return customFetch<GetReportSchedule200>(getGetReportScheduleUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetReportScheduleQueryKey = () => {
  return [`/api/settings/report-schedule`] as const;
};

export const getGetReportScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportSchedule>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReportSchedule>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportScheduleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportSchedule>>
  > = ({ signal }) => getReportSchedule({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportSchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportSchedule>>
>;
export type GetReportScheduleQueryError = ErrorType<unknown>;

/**
 * @summary Get automated report schedule settings
 */

export function useGetReportSchedule<
  TData = Awaited<ReturnType<typeof getReportSchedule>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReportSchedule>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportScheduleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateReportScheduleUrl = () => {
  return `/api/settings/report-schedule`;
};

/**
 * @summary Update automated report schedule settings
 */
export const updateReportSchedule = async (
  updateReportScheduleBody: UpdateReportScheduleBody,
  options?: RequestInit,
): Promise<UpdateReportSchedule200> => {
  return customFetch<UpdateReportSchedule200>(getUpdateReportScheduleUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateReportScheduleBody),
  });
};

export const getUpdateReportScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportSchedule>>,
    TError,
    { data: BodyType<UpdateReportScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReportSchedule>>,
  TError,
  { data: BodyType<UpdateReportScheduleBody> },
  TContext
> => {
  const mutationKey = ["updateReportSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReportSchedule>>,
    { data: BodyType<UpdateReportScheduleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateReportSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReportSchedule>>
>;
export type UpdateReportScheduleMutationBody =
  BodyType<UpdateReportScheduleBody>;
export type UpdateReportScheduleMutationError = ErrorType<unknown>;

/**
 * @summary Update automated report schedule settings
 */
export const useUpdateReportSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportSchedule>>,
    TError,
    { data: BodyType<UpdateReportScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReportSchedule>>,
  TError,
  { data: BodyType<UpdateReportScheduleBody> },
  TContext
> => {
  return useMutation(getUpdateReportScheduleMutationOptions(options));
};

export const getGetGmbSettingsUrl = () => {
  return `/api/settings/gmb`;
};

/**
 * @summary Get Google My Business settings
 */
export const getGmbSettings = async (
  options?: RequestInit,
): Promise<GmbSettings> => {
  return customFetch<GmbSettings>(getGetGmbSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGmbSettingsQueryKey = () => {
  return [`/api/settings/gmb`] as const;
};

export const getGetGmbSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmbSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGmbSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmbSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmbSettings>>> = ({
    signal,
  }) => getGmbSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmbSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmbSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmbSettings>>
>;
export type GetGmbSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get Google My Business settings
 */

export function useGetGmbSettings<
  TData = Awaited<ReturnType<typeof getGmbSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGmbSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmbSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateGmbSettingsUrl = () => {
  return `/api/settings/gmb`;
};

/**
 * @summary Update Google My Business settings
 */
export const updateGmbSettings = async (
  updateGmbSettingsBody: UpdateGmbSettingsBody,
  options?: RequestInit,
): Promise<UpdateGmbSettings200> => {
  return customFetch<UpdateGmbSettings200>(getUpdateGmbSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGmbSettingsBody),
  });
};

export const getUpdateGmbSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGmbSettings>>,
    TError,
    { data: BodyType<UpdateGmbSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGmbSettings>>,
  TError,
  { data: BodyType<UpdateGmbSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateGmbSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGmbSettings>>,
    { data: BodyType<UpdateGmbSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateGmbSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGmbSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGmbSettings>>
>;
export type UpdateGmbSettingsMutationBody = BodyType<UpdateGmbSettingsBody>;
export type UpdateGmbSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update Google My Business settings
 */
export const useUpdateGmbSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGmbSettings>>,
    TError,
    { data: BodyType<UpdateGmbSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGmbSettings>>,
  TError,
  { data: BodyType<UpdateGmbSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateGmbSettingsMutationOptions(options));
};

export const getGetEmailSettingsUrl = () => {
  return `/api/settings/email`;
};

/**
 * @summary Get email SMTP settings
 */
export const getEmailSettings = async (
  options?: RequestInit,
): Promise<EmailSettings> => {
  return customFetch<EmailSettings>(getGetEmailSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailSettingsQueryKey = () => {
  return [`/api/settings/email`] as const;
};

export const getGetEmailSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailSettings>>
  > = ({ signal }) => getEmailSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailSettings>>
>;
export type GetEmailSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get email SMTP settings
 */

export function useGetEmailSettings<
  TData = Awaited<ReturnType<typeof getEmailSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateEmailSettingsUrl = () => {
  return `/api/settings/email`;
};

/**
 * @summary Update email SMTP settings
 */
export const updateEmailSettings = async (
  updateEmailSettingsBody: UpdateEmailSettingsBody,
  options?: RequestInit,
): Promise<EmailSettings> => {
  return customFetch<EmailSettings>(getUpdateEmailSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailSettingsBody),
  });
};

export const getUpdateEmailSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    TError,
    { data: BodyType<UpdateEmailSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailSettings>>,
  TError,
  { data: BodyType<UpdateEmailSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateEmailSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    { data: BodyType<UpdateEmailSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailSettings>>
>;
export type UpdateEmailSettingsMutationBody = BodyType<UpdateEmailSettingsBody>;
export type UpdateEmailSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update email SMTP settings
 */
export const useUpdateEmailSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    TError,
    { data: BodyType<UpdateEmailSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailSettings>>,
  TError,
  { data: BodyType<UpdateEmailSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateEmailSettingsMutationOptions(options));
};

export const getGetEmailHealthUrl = () => {
  return `/api/settings/email/health`;
};

/**
 * @summary Get composite email deliverability score (DNS 35% + Content 25% + Warmup 20% + Bounce 20%)
 */
export const getEmailHealth = async (
  options?: RequestInit,
): Promise<GetEmailHealth200> => {
  return customFetch<GetEmailHealth200>(getGetEmailHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailHealthQueryKey = () => {
  return [`/api/settings/email/health`] as const;
};

export const getGetEmailHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailHealth>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailHealth>>> = ({
    signal,
  }) => getEmailHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailHealth>>
>;
export type GetEmailHealthQueryError = ErrorType<unknown>;

/**
 * @summary Get composite email deliverability score (DNS 35% + Content 25% + Warmup 20% + Bounce 20%)
 */

export function useGetEmailHealth<
  TData = Awaited<ReturnType<typeof getEmailHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailHealth>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPreviewSpamScoreUrl = () => {
  return `/api/settings/email/spam-check`;
};

/**
 * @summary Preview spam score for a subject + body before sending
 */
export const previewSpamScore = async (
  previewSpamScoreBody: PreviewSpamScoreBody,
  options?: RequestInit,
): Promise<PreviewSpamScore200> => {
  return customFetch<PreviewSpamScore200>(getPreviewSpamScoreUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(previewSpamScoreBody),
  });
};

export const getPreviewSpamScoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSpamScore>>,
    TError,
    { data: BodyType<PreviewSpamScoreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewSpamScore>>,
  TError,
  { data: BodyType<PreviewSpamScoreBody> },
  TContext
> => {
  const mutationKey = ["previewSpamScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewSpamScore>>,
    { data: BodyType<PreviewSpamScoreBody> }
  > = (props) => {
    const { data } = props ?? {};

    return previewSpamScore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewSpamScoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewSpamScore>>
>;
export type PreviewSpamScoreMutationBody = BodyType<PreviewSpamScoreBody>;
export type PreviewSpamScoreMutationError = ErrorType<unknown>;

/**
 * @summary Preview spam score for a subject + body before sending
 */
export const usePreviewSpamScore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSpamScore>>,
    TError,
    { data: BodyType<PreviewSpamScoreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewSpamScore>>,
  TError,
  { data: BodyType<PreviewSpamScoreBody> },
  TContext
> => {
  return useMutation(getPreviewSpamScoreMutationOptions(options));
};

export const getUpdateWarmupSettingsUrl = () => {
  return `/api/settings/email/warmup`;
};

/**
 * @summary Toggle email warmup on/off and reset warmup state
 */
export const updateWarmupSettings = async (
  updateWarmupSettingsBody: UpdateWarmupSettingsBody,
  options?: RequestInit,
): Promise<UpdateWarmupSettings200> => {
  return customFetch<UpdateWarmupSettings200>(getUpdateWarmupSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWarmupSettingsBody),
  });
};

export const getUpdateWarmupSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWarmupSettings>>,
    TError,
    { data: BodyType<UpdateWarmupSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWarmupSettings>>,
  TError,
  { data: BodyType<UpdateWarmupSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateWarmupSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWarmupSettings>>,
    { data: BodyType<UpdateWarmupSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateWarmupSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWarmupSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWarmupSettings>>
>;
export type UpdateWarmupSettingsMutationBody =
  BodyType<UpdateWarmupSettingsBody>;
export type UpdateWarmupSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Toggle email warmup on/off and reset warmup state
 */
export const useUpdateWarmupSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWarmupSettings>>,
    TError,
    { data: BodyType<UpdateWarmupSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWarmupSettings>>,
  TError,
  { data: BodyType<UpdateWarmupSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateWarmupSettingsMutationOptions(options));
};

export const getGetSeoKeywordsUrl = () => {
  return `/api/seo/keywords`;
};

/**
 * @summary Get tracked SEO keywords
 */
export const getSeoKeywords = async (
  options?: RequestInit,
): Promise<GetSeoKeywords200> => {
  return customFetch<GetSeoKeywords200>(getGetSeoKeywordsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoKeywordsQueryKey = () => {
  return [`/api/seo/keywords`] as const;
};

export const getGetSeoKeywordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoKeywords>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoKeywords>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoKeywordsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoKeywords>>> = ({
    signal,
  }) => getSeoKeywords({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoKeywords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoKeywordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoKeywords>>
>;
export type GetSeoKeywordsQueryError = ErrorType<unknown>;

/**
 * @summary Get tracked SEO keywords
 */

export function useGetSeoKeywords<
  TData = Awaited<ReturnType<typeof getSeoKeywords>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoKeywords>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoKeywordsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAddSeoKeywordUrl = () => {
  return `/api/seo/keywords`;
};

/**
 * @summary Add keyword to track
 */
export const addSeoKeyword = async (
  addSeoKeywordBody: AddSeoKeywordBody,
  options?: RequestInit,
): Promise<SeoKeywordRank> => {
  return customFetch<SeoKeywordRank>(getAddSeoKeywordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addSeoKeywordBody),
  });
};

export const getAddSeoKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSeoKeyword>>,
    TError,
    { data: BodyType<AddSeoKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSeoKeyword>>,
  TError,
  { data: BodyType<AddSeoKeywordBody> },
  TContext
> => {
  const mutationKey = ["addSeoKeyword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSeoKeyword>>,
    { data: BodyType<AddSeoKeywordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return addSeoKeyword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSeoKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSeoKeyword>>
>;
export type AddSeoKeywordMutationBody = BodyType<AddSeoKeywordBody>;
export type AddSeoKeywordMutationError = ErrorType<unknown>;

/**
 * @summary Add keyword to track
 */
export const useAddSeoKeyword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSeoKeyword>>,
    TError,
    { data: BodyType<AddSeoKeywordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSeoKeyword>>,
  TError,
  { data: BodyType<AddSeoKeywordBody> },
  TContext
> => {
  return useMutation(getAddSeoKeywordMutationOptions(options));
};

export const getRefreshSeoKeywordsUrl = () => {
  return `/api/seo/keywords/refresh`;
};

/**
 * @summary Refresh keyword rankings
 */
export const refreshSeoKeywords = async (
  options?: RequestInit,
): Promise<RefreshSeoKeywords200> => {
  return customFetch<RefreshSeoKeywords200>(getRefreshSeoKeywordsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshSeoKeywordsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSeoKeywords>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshSeoKeywords>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshSeoKeywords"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshSeoKeywords>>,
    void
  > = () => {
    return refreshSeoKeywords(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshSeoKeywordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshSeoKeywords>>
>;

export type RefreshSeoKeywordsMutationError = ErrorType<unknown>;

/**
 * @summary Refresh keyword rankings
 */
export const useRefreshSeoKeywords = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSeoKeywords>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshSeoKeywords>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshSeoKeywordsMutationOptions(options));
};

export const getGetSeoKeywordHistoryUrl = () => {
  return `/api/seo/keywords/history`;
};

/**
 * @summary Get rank history for all tracked keywords
 */
export const getSeoKeywordHistory = async (
  options?: RequestInit,
): Promise<GetSeoKeywordHistory200> => {
  return customFetch<GetSeoKeywordHistory200>(getGetSeoKeywordHistoryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoKeywordHistoryQueryKey = () => {
  return [`/api/seo/keywords/history`] as const;
};

export const getGetSeoKeywordHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoKeywordHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoKeywordHistory>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoKeywordHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSeoKeywordHistory>>
  > = ({ signal }) => getSeoKeywordHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoKeywordHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoKeywordHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoKeywordHistory>>
>;
export type GetSeoKeywordHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Get rank history for all tracked keywords
 */

export function useGetSeoKeywordHistory<
  TData = Awaited<ReturnType<typeof getSeoKeywordHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoKeywordHistory>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoKeywordHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteSeoKeywordUrl = (id: number) => {
  return `/api/seo/keywords/${id}`;
};

/**
 * @summary Delete tracked keyword
 */
export const deleteSeoKeyword = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteSeoKeyword200> => {
  return customFetch<DeleteSeoKeyword200>(getDeleteSeoKeywordUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSeoKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeoKeyword>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSeoKeyword>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSeoKeyword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSeoKeyword>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSeoKeyword(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSeoKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSeoKeyword>>
>;

export type DeleteSeoKeywordMutationError = ErrorType<unknown>;

/**
 * @summary Delete tracked keyword
 */
export const useDeleteSeoKeyword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeoKeyword>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSeoKeyword>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSeoKeywordMutationOptions(options));
};

export const getGetSeoAlertsUrl = () => {
  return `/api/seo/alerts`;
};

/**
 * @summary Get SEO rank drop alerts from the last 7 days
 */
export const getSeoAlerts = async (
  options?: RequestInit,
): Promise<GetSeoAlerts200> => {
  return customFetch<GetSeoAlerts200>(getGetSeoAlertsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoAlertsQueryKey = () => {
  return [`/api/seo/alerts`] as const;
};

export const getGetSeoAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoAlerts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoAlertsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoAlerts>>> = ({
    signal,
  }) => getSeoAlerts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoAlerts>>
>;
export type GetSeoAlertsQueryError = ErrorType<unknown>;

/**
 * @summary Get SEO rank drop alerts from the last 7 days
 */

export function useGetSeoAlerts<
  TData = Awaited<ReturnType<typeof getSeoAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoAlerts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoAlertsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSeoRankingsUrl = () => {
  return `/api/seo/rankings`;
};

/**
 * @summary Get enriched keyword rankings with latest SERP snapshot (top URLs, featured snippet)
 */
export const getSeoRankings = async (
  options?: RequestInit,
): Promise<GetSeoRankings200> => {
  return customFetch<GetSeoRankings200>(getGetSeoRankingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoRankingsQueryKey = () => {
  return [`/api/seo/rankings`] as const;
};

export const getGetSeoRankingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoRankings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoRankings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoRankingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoRankings>>> = ({
    signal,
  }) => getSeoRankings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoRankings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoRankingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoRankings>>
>;
export type GetSeoRankingsQueryError = ErrorType<unknown>;

/**
 * @summary Get enriched keyword rankings with latest SERP snapshot (top URLs, featured snippet)
 */

export function useGetSeoRankings<
  TData = Awaited<ReturnType<typeof getSeoRankings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSeoRankings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoRankingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSeoCompetitorAnalysisUrl = () => {
  return `/api/seo/competitor-analysis`;
};

/**
 * @summary Get aggregated competitor gap analysis across all tracked competitors
 */
export const getSeoCompetitorAnalysis = async (
  options?: RequestInit,
): Promise<GetSeoCompetitorAnalysis200> => {
  return customFetch<GetSeoCompetitorAnalysis200>(
    getGetSeoCompetitorAnalysisUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSeoCompetitorAnalysisQueryKey = () => {
  return [`/api/seo/competitor-analysis`] as const;
};

export const getGetSeoCompetitorAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSeoCompetitorAnalysisQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>
  > = ({ signal }) => getSeoCompetitorAnalysis({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoCompetitorAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>
>;
export type GetSeoCompetitorAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Get aggregated competitor gap analysis across all tracked competitors
 */

export function useGetSeoCompetitorAnalysis<
  TData = Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoCompetitorAnalysis>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoCompetitorAnalysisQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSeoCompetitorsUrl = () => {
  return `/api/seo/competitors`;
};

/**
 * @summary Get SEO competitors
 */
export const getSeoCompetitors = async (
  options?: RequestInit,
): Promise<GetSeoCompetitors200> => {
  return customFetch<GetSeoCompetitors200>(getGetSeoCompetitorsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSeoCompetitorsQueryKey = () => {
  return [`/api/seo/competitors`] as const;
};

export const getGetSeoCompetitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeoCompetitors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoCompetitors>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSeoCompetitorsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSeoCompetitors>>
  > = ({ signal }) => getSeoCompetitors({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeoCompetitors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSeoCompetitorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeoCompetitors>>
>;
export type GetSeoCompetitorsQueryError = ErrorType<unknown>;

/**
 * @summary Get SEO competitors
 */

export function useGetSeoCompetitors<
  TData = Awaited<ReturnType<typeof getSeoCompetitors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSeoCompetitors>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeoCompetitorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAddSeoCompetitorUrl = () => {
  return `/api/seo/competitors`;
};

/**
 * @summary Add competitor
 */
export const addSeoCompetitor = async (
  addSeoCompetitorBody: AddSeoCompetitorBody,
  options?: RequestInit,
): Promise<SeoCompetitor> => {
  return customFetch<SeoCompetitor>(getAddSeoCompetitorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addSeoCompetitorBody),
  });
};

export const getAddSeoCompetitorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSeoCompetitor>>,
    TError,
    { data: BodyType<AddSeoCompetitorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSeoCompetitor>>,
  TError,
  { data: BodyType<AddSeoCompetitorBody> },
  TContext
> => {
  const mutationKey = ["addSeoCompetitor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSeoCompetitor>>,
    { data: BodyType<AddSeoCompetitorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return addSeoCompetitor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSeoCompetitorMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSeoCompetitor>>
>;
export type AddSeoCompetitorMutationBody = BodyType<AddSeoCompetitorBody>;
export type AddSeoCompetitorMutationError = ErrorType<unknown>;

/**
 * @summary Add competitor
 */
export const useAddSeoCompetitor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSeoCompetitor>>,
    TError,
    { data: BodyType<AddSeoCompetitorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSeoCompetitor>>,
  TError,
  { data: BodyType<AddSeoCompetitorBody> },
  TContext
> => {
  return useMutation(getAddSeoCompetitorMutationOptions(options));
};

export const getDeleteSeoCompetitorUrl = (id: number) => {
  return `/api/seo/competitors/${id}`;
};

/**
 * @summary Delete competitor
 */
export const deleteSeoCompetitor = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteSeoCompetitor200> => {
  return customFetch<DeleteSeoCompetitor200>(getDeleteSeoCompetitorUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSeoCompetitorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeoCompetitor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSeoCompetitor>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSeoCompetitor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSeoCompetitor>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSeoCompetitor(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSeoCompetitorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSeoCompetitor>>
>;

export type DeleteSeoCompetitorMutationError = ErrorType<unknown>;

/**
 * @summary Delete competitor
 */
export const useDeleteSeoCompetitor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeoCompetitor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSeoCompetitor>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSeoCompetitorMutationOptions(options));
};

export const getAnalyzeSeoCompetitorUrl = (id: number) => {
  return `/api/seo/competitors/${id}/analyze`;
};

/**
 * @summary AI analyze competitor
 */
export const analyzeSeoCompetitor = async (
  id: number,
  options?: RequestInit,
): Promise<SeoCompetitor> => {
  return customFetch<SeoCompetitor>(getAnalyzeSeoCompetitorUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeSeoCompetitorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeSeoCompetitor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeSeoCompetitor>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["analyzeSeoCompetitor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeSeoCompetitor>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeSeoCompetitor(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeSeoCompetitorMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeSeoCompetitor>>
>;

export type AnalyzeSeoCompetitorMutationError = ErrorType<unknown>;

/**
 * @summary AI analyze competitor
 */
export const useAnalyzeSeoCompetitor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeSeoCompetitor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeSeoCompetitor>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAnalyzeSeoCompetitorMutationOptions(options));
};

export const getCreateGmbPostUrl = () => {
  return `/api/seo/gmb-post`;
};

/**
 * @summary Generate (and optionally publish) a Google My Business post
 */
export const createGmbPost = async (
  createGmbPostBody: CreateGmbPostBody,
  options?: RequestInit,
): Promise<CreateGmbPost200> => {
  return customFetch<CreateGmbPost200>(getCreateGmbPostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createGmbPostBody),
  });
};

export const getCreateGmbPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGmbPost>>,
    TError,
    { data: BodyType<CreateGmbPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGmbPost>>,
  TError,
  { data: BodyType<CreateGmbPostBody> },
  TContext
> => {
  const mutationKey = ["createGmbPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGmbPost>>,
    { data: BodyType<CreateGmbPostBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createGmbPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGmbPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGmbPost>>
>;
export type CreateGmbPostMutationBody = BodyType<CreateGmbPostBody>;
export type CreateGmbPostMutationError = ErrorType<unknown>;

/**
 * @summary Generate (and optionally publish) a Google My Business post
 */
export const useCreateGmbPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGmbPost>>,
    TError,
    { data: BodyType<CreateGmbPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGmbPost>>,
  TError,
  { data: BodyType<CreateGmbPostBody> },
  TContext
> => {
  return useMutation(getCreateGmbPostMutationOptions(options));
};

export const getGetReviewsUrl = (params?: GetReviewsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/reviews?${stringifiedParams}`
    : `/api/reviews`;
};

/**
 * @summary Get business reviews
 */
export const getReviews = async (
  params?: GetReviewsParams,
  options?: RequestInit,
): Promise<GetReviews200> => {
  return customFetch<GetReviews200>(getGetReviewsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetReviewsQueryKey = (params?: GetReviewsParams) => {
  return [`/api/reviews`, ...(params ? [params] : [])] as const;
};

export const getGetReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviews>>> = ({
    signal,
  }) => getReviews(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviews>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviews>>
>;
export type GetReviewsQueryError = ErrorType<unknown>;

/**
 * @summary Get business reviews
 */

export function useGetReviews<
  TData = Awaited<ReturnType<typeof getReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReviewsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetReviewStatsUrl = () => {
  return `/api/reviews/stats`;
};

/**
 * @summary Get review statistics
 */
export const getReviewStats = async (
  options?: RequestInit,
): Promise<ReviewStats> => {
  return customFetch<ReviewStats>(getGetReviewStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetReviewStatsQueryKey = () => {
  return [`/api/reviews/stats`] as const;
};

export const getGetReviewStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReviewStats>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewStats>>> = ({
    signal,
  }) => getReviewStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReviewStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewStats>>
>;
export type GetReviewStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get review statistics
 */

export function useGetReviewStats<
  TData = Awaited<ReturnType<typeof getReviewStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReviewStats>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReviewStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetReviewStatsTrendUrl = (
  params?: GetReviewStatsTrendParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/reviews/stats/trend?${stringifiedParams}`
    : `/api/reviews/stats/trend`;
};

/**
 * @summary Get weekly rating trend for the last N weeks
 */
export const getReviewStatsTrend = async (
  params?: GetReviewStatsTrendParams,
  options?: RequestInit,
): Promise<GetReviewStatsTrend200> => {
  return customFetch<GetReviewStatsTrend200>(
    getGetReviewStatsTrendUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReviewStatsTrendQueryKey = (
  params?: GetReviewStatsTrendParams,
) => {
  return [`/api/reviews/stats/trend`, ...(params ? [params] : [])] as const;
};

export const getGetReviewStatsTrendQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewStatsTrend>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReviewStatsTrendParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewStatsTrend>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReviewStatsTrendQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReviewStatsTrend>>
  > = ({ signal }) =>
    getReviewStatsTrend(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewStatsTrend>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReviewStatsTrendQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewStatsTrend>>
>;
export type GetReviewStatsTrendQueryError = ErrorType<unknown>;

/**
 * @summary Get weekly rating trend for the last N weeks
 */

export function useGetReviewStatsTrend<
  TData = Awaited<ReturnType<typeof getReviewStatsTrend>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReviewStatsTrendParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewStatsTrend>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReviewStatsTrendQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSyncReviewsUrl = () => {
  return `/api/reviews/sync`;
};

/**
 * @summary Sync reviews from Google
 */
export const syncReviews = async (
  options?: RequestInit,
): Promise<SyncReviews200> => {
  return customFetch<SyncReviews200>(getSyncReviewsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncReviews>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncReviews>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncReviews>>,
    void
  > = () => {
    return syncReviews(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncReviews>>
>;

export type SyncReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Sync reviews from Google
 */
export const useSyncReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncReviews>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncReviews>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSyncReviewsMutationOptions(options));
};

export const getGetReviewRequestsUrl = () => {
  return `/api/reviews/requests`;
};

/**
 * @summary Get review requests sent
 */
export const getReviewRequests = async (
  options?: RequestInit,
): Promise<GetReviewRequests200> => {
  return customFetch<GetReviewRequests200>(getGetReviewRequestsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetReviewRequestsQueryKey = () => {
  return [`/api/reviews/requests`] as const;
};

export const getGetReviewRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewRequests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReviewRequests>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewRequestsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReviewRequests>>
  > = ({ signal }) => getReviewRequests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReviewRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewRequests>>
>;
export type GetReviewRequestsQueryError = ErrorType<unknown>;

/**
 * @summary Get review requests sent
 */

export function useGetReviewRequests<
  TData = Awaited<ReturnType<typeof getReviewRequests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReviewRequests>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReviewRequestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSendReviewRequestUrl = () => {
  return `/api/reviews/requests`;
};

/**
 * @summary Send review request
 */
export const sendReviewRequest = async (
  sendReviewRequestBody: SendReviewRequestBody,
  options?: RequestInit,
): Promise<ReviewRequest> => {
  return customFetch<ReviewRequest>(getSendReviewRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendReviewRequestBody),
  });
};

export const getSendReviewRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendReviewRequest>>,
    TError,
    { data: BodyType<SendReviewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendReviewRequest>>,
  TError,
  { data: BodyType<SendReviewRequestBody> },
  TContext
> => {
  const mutationKey = ["sendReviewRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendReviewRequest>>,
    { data: BodyType<SendReviewRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sendReviewRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendReviewRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendReviewRequest>>
>;
export type SendReviewRequestMutationBody = BodyType<SendReviewRequestBody>;
export type SendReviewRequestMutationError = ErrorType<unknown>;

/**
 * @summary Send review request
 */
export const useSendReviewRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendReviewRequest>>,
    TError,
    { data: BodyType<SendReviewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendReviewRequest>>,
  TError,
  { data: BodyType<SendReviewRequestBody> },
  TContext
> => {
  return useMutation(getSendReviewRequestMutationOptions(options));
};

export const getRespondToReviewUrl = (id: number) => {
  return `/api/reviews/${id}/respond`;
};

/**
 * @summary Respond to a review
 */
export const respondToReview = async (
  id: number,
  respondToReviewBody: RespondToReviewBody,
  options?: RequestInit,
): Promise<BusinessReview> => {
  return customFetch<BusinessReview>(getRespondToReviewUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(respondToReviewBody),
  });
};

export const getRespondToReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof respondToReview>>,
    TError,
    { id: number; data: BodyType<RespondToReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof respondToReview>>,
  TError,
  { id: number; data: BodyType<RespondToReviewBody> },
  TContext
> => {
  const mutationKey = ["respondToReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof respondToReview>>,
    { id: number; data: BodyType<RespondToReviewBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return respondToReview(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RespondToReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof respondToReview>>
>;
export type RespondToReviewMutationBody = BodyType<RespondToReviewBody>;
export type RespondToReviewMutationError = ErrorType<unknown>;

/**
 * @summary Respond to a review
 */
export const useRespondToReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof respondToReview>>,
    TError,
    { id: number; data: BodyType<RespondToReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof respondToReview>>,
  TError,
  { id: number; data: BodyType<RespondToReviewBody> },
  TContext
> => {
  return useMutation(getRespondToReviewMutationOptions(options));
};

export const getAiRespondToReviewUrl = (id: number) => {
  return `/api/reviews/${id}/ai-respond`;
};

/**
 * @summary Generate AI response to review
 */
export const aiRespondToReview = async (
  id: number,
  options?: RequestInit,
): Promise<AiRespondToReview200> => {
  return customFetch<AiRespondToReview200>(getAiRespondToReviewUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAiRespondToReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiRespondToReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiRespondToReview>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["aiRespondToReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiRespondToReview>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return aiRespondToReview(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiRespondToReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiRespondToReview>>
>;

export type AiRespondToReviewMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI response to review
 */
export const useAiRespondToReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiRespondToReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiRespondToReview>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAiRespondToReviewMutationOptions(options));
};

export const getPatchReviewUrl = (id: number) => {
  return `/api/reviews/${id}`;
};

/**
 * @summary Update review response status or draft
 */
export const patchReview = async (
  id: number,
  patchReviewBody: PatchReviewBody,
  options?: RequestInit,
): Promise<BusinessReview> => {
  return customFetch<BusinessReview>(getPatchReviewUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchReviewBody),
  });
};

export const getPatchReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchReview>>,
    TError,
    { id: number; data: BodyType<PatchReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchReview>>,
  TError,
  { id: number; data: BodyType<PatchReviewBody> },
  TContext
> => {
  const mutationKey = ["patchReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchReview>>,
    { id: number; data: BodyType<PatchReviewBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchReview(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchReview>>
>;
export type PatchReviewMutationBody = BodyType<PatchReviewBody>;
export type PatchReviewMutationError = ErrorType<unknown>;

/**
 * @summary Update review response status or draft
 */
export const usePatchReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchReview>>,
    TError,
    { id: number; data: BodyType<PatchReviewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchReview>>,
  TError,
  { id: number; data: BodyType<PatchReviewBody> },
  TContext
> => {
  return useMutation(getPatchReviewMutationOptions(options));
};

export const getDeleteReviewUrl = (id: number) => {
  return `/api/reviews/${id}`;
};

/**
 * @summary Delete review
 */
export const deleteReview = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteReview200> => {
  return customFetch<DeleteReview200>(getDeleteReviewUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReview>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReview>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteReview(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReview>>
>;

export type DeleteReviewMutationError = ErrorType<unknown>;

/**
 * @summary Delete review
 */
export const useDeleteReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReview>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReview>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteReviewMutationOptions(options));
};

export const getRegenerateReviewResponseUrl = (id: number) => {
  return `/api/reviews/${id}/regenerate-response`;
};

/**
 * @summary Regenerate AI response draft for a review
 */
export const regenerateReviewResponse = async (
  id: number,
  options?: RequestInit,
): Promise<RegenerateReviewResponse200> => {
  return customFetch<RegenerateReviewResponse200>(
    getRegenerateReviewResponseUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRegenerateReviewResponseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateReviewResponse>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateReviewResponse>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["regenerateReviewResponse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateReviewResponse>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return regenerateReviewResponse(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateReviewResponseMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateReviewResponse>>
>;

export type RegenerateReviewResponseMutationError = ErrorType<unknown>;

/**
 * @summary Regenerate AI response draft for a review
 */
export const useRegenerateReviewResponse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateReviewResponse>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateReviewResponse>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRegenerateReviewResponseMutationOptions(options));
};

export const getGetLeadScoresUrl = () => {
  return `/api/intelligence/lead-scores`;
};

/**
 * @summary Get predictive lead scores
 */
export const getLeadScores = async (
  options?: RequestInit,
): Promise<GetLeadScores200> => {
  return customFetch<GetLeadScores200>(getGetLeadScoresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadScoresQueryKey = () => {
  return [`/api/intelligence/lead-scores`] as const;
};

export const getGetLeadScoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadScores>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeadScores>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadScoresQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadScores>>> = ({
    signal,
  }) => getLeadScores({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadScores>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadScoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadScores>>
>;
export type GetLeadScoresQueryError = ErrorType<unknown>;

/**
 * @summary Get predictive lead scores
 */

export function useGetLeadScores<
  TData = Awaited<ReturnType<typeof getLeadScores>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeadScores>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadScoresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateLeadScoresUrl = () => {
  return `/api/intelligence/lead-scores/generate`;
};

/**
 * @summary Generate AI lead scores
 */
export const generateLeadScores = async (
  options?: RequestInit,
): Promise<GenerateLeadScores200> => {
  return customFetch<GenerateLeadScores200>(getGenerateLeadScoresUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGenerateLeadScoresMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadScores>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateLeadScores>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateLeadScores"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateLeadScores>>,
    void
  > = () => {
    return generateLeadScores(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateLeadScoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateLeadScores>>
>;

export type GenerateLeadScoresMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI lead scores
 */
export const useGenerateLeadScores = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadScores>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateLeadScores>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateLeadScoresMutationOptions(options));
};

export const getRescoreLeadScoreUrl = (id: number) => {
  return `/api/intelligence/lead-scores/${id}/rescore`;
};

/**
 * @summary Rescore a lead
 */
export const rescoreLeadScore = async (
  id: number,
  options?: RequestInit,
): Promise<LeadScore> => {
  return customFetch<LeadScore>(getRescoreLeadScoreUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRescoreLeadScoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescoreLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rescoreLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["rescoreLeadScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rescoreLeadScore>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return rescoreLeadScore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RescoreLeadScoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescoreLeadScore>>
>;

export type RescoreLeadScoreMutationError = ErrorType<unknown>;

/**
 * @summary Rescore a lead
 */
export const useRescoreLeadScore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescoreLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rescoreLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRescoreLeadScoreMutationOptions(options));
};

export const getDeleteLeadScoreUrl = (id: number) => {
  return `/api/intelligence/lead-scores/${id}`;
};

/**
 * @summary Delete lead score
 */
export const deleteLeadScore = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteLeadScore200> => {
  return customFetch<DeleteLeadScore200>(getDeleteLeadScoreUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLeadScoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteLeadScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLeadScore>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLeadScore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLeadScoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLeadScore>>
>;

export type DeleteLeadScoreMutationError = ErrorType<unknown>;

/**
 * @summary Delete lead score
 */
export const useDeleteLeadScore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLeadScore>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLeadScore>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteLeadScoreMutationOptions(options));
};

export const getGetAttributionUrl = () => {
  return `/api/intelligence/attribution`;
};

/**
 * @summary Get revenue attribution records
 */
export const getAttribution = async (
  options?: RequestInit,
): Promise<GetAttribution200> => {
  return customFetch<GetAttribution200>(getGetAttributionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAttributionQueryKey = () => {
  return [`/api/intelligence/attribution`] as const;
};

export const getGetAttributionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttribution>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAttribution>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAttributionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttribution>>> = ({
    signal,
  }) => getAttribution({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttribution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttributionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttribution>>
>;
export type GetAttributionQueryError = ErrorType<unknown>;

/**
 * @summary Get revenue attribution records
 */

export function useGetAttribution<
  TData = Awaited<ReturnType<typeof getAttribution>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAttribution>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttributionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAttributionSummaryUrl = () => {
  return `/api/intelligence/attribution/summary`;
};

/**
 * @summary Get attribution summary by channel
 */
export const getAttributionSummary = async (
  options?: RequestInit,
): Promise<AttributionSummary> => {
  return customFetch<AttributionSummary>(getGetAttributionSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAttributionSummaryQueryKey = () => {
  return [`/api/intelligence/attribution/summary`] as const;
};

export const getGetAttributionSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttributionSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAttributionSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAttributionSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAttributionSummary>>
  > = ({ signal }) => getAttributionSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttributionSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttributionSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttributionSummary>>
>;
export type GetAttributionSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get attribution summary by channel
 */

export function useGetAttributionSummary<
  TData = Awaited<ReturnType<typeof getAttributionSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAttributionSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttributionSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateAttributionUrl = () => {
  return `/api/intelligence/attribution/generate`;
};

/**
 * @summary Generate AI attribution data
 */
export const generateAttribution = async (
  options?: RequestInit,
): Promise<GenerateAttribution200> => {
  return customFetch<GenerateAttribution200>(getGenerateAttributionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGenerateAttributionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAttribution>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAttribution>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateAttribution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAttribution>>,
    void
  > = () => {
    return generateAttribution(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAttributionMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAttribution>>
>;

export type GenerateAttributionMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI attribution data
 */
export const useGenerateAttribution = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAttribution>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateAttribution>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateAttributionMutationOptions(options));
};

export const getGetReportsUrl = () => {
  return `/api/reports`;
};

/**
 * @summary Get all reports
 */
export const getReports = async (
  options?: RequestInit,
): Promise<GetReports200> => {
  return customFetch<GetReports200>(getGetReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetReportsQueryKey = () => {
  return [`/api/reports`] as const;
};

export const getGetReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReports>>> = ({
    signal,
  }) => getReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReports>>
>;
export type GetReportsQueryError = ErrorType<unknown>;

/**
 * @summary Get all reports
 */

export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateReportUrl = () => {
  return `/api/reports/generate`;
};

/**
 * @summary Generate an AI report
 */
export const generateReport = async (
  generateReportBody: GenerateReportBody,
  options?: RequestInit,
): Promise<GenerateReport200> => {
  return customFetch<GenerateReport200>(getGenerateReportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateReportBody),
  });
};

export const getGenerateReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReport>>,
    TError,
    { data: BodyType<GenerateReportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReport>>,
  TError,
  { data: BodyType<GenerateReportBody> },
  TContext
> => {
  const mutationKey = ["generateReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReport>>,
    { data: BodyType<GenerateReportBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReport>>
>;
export type GenerateReportMutationBody = BodyType<GenerateReportBody>;
export type GenerateReportMutationError = ErrorType<unknown>;

/**
 * @summary Generate an AI report
 */
export const useGenerateReport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReport>>,
    TError,
    { data: BodyType<GenerateReportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateReport>>,
  TError,
  { data: BodyType<GenerateReportBody> },
  TContext
> => {
  return useMutation(getGenerateReportMutationOptions(options));
};

export const getExportReportCsvUrl = (id: number) => {
  return `/api/reports/${id}/export-csv`;
};

/**
 * @summary Export a report as CSV
 */
export const exportReportCsv = async (
  id: number,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportReportCsvUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getExportReportCsvQueryKey = (id: number) => {
  return [`/api/reports/${id}/export-csv`] as const;
};

export const getExportReportCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportReportCsv>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportReportCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportReportCsvQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportReportCsv>>> = ({
    signal,
  }) => exportReportCsv(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportReportCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportReportCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportReportCsv>>
>;
export type ExportReportCsvQueryError = ErrorType<unknown>;

/**
 * @summary Export a report as CSV
 */

export function useExportReportCsv<
  TData = Awaited<ReturnType<typeof exportReportCsv>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportReportCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportReportCsvQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteReportUrl = (id: number) => {
  return `/api/reports/${id}`;
};

/**
 * @summary Delete a report
 */
export const deleteReport = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteReport200> => {
  return customFetch<DeleteReport200>(getDeleteReportUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReport>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReport>>
>;

export type DeleteReportMutationError = ErrorType<unknown>;

/**
 * @summary Delete a report
 */
export const useDeleteReport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteReportMutationOptions(options));
};

export const getGetDigestSubscriptionsUrl = () => {
  return `/api/reports/digest`;
};

/**
 * @summary Get digest subscriptions
 */
export const getDigestSubscriptions = async (
  options?: RequestInit,
): Promise<GetDigestSubscriptions200> => {
  return customFetch<GetDigestSubscriptions200>(
    getGetDigestSubscriptionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDigestSubscriptionsQueryKey = () => {
  return [`/api/reports/digest`] as const;
};

export const getGetDigestSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDigestSubscriptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDigestSubscriptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDigestSubscriptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDigestSubscriptions>>
  > = ({ signal }) => getDigestSubscriptions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDigestSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDigestSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDigestSubscriptions>>
>;
export type GetDigestSubscriptionsQueryError = ErrorType<unknown>;

/**
 * @summary Get digest subscriptions
 */

export function useGetDigestSubscriptions<
  TData = Awaited<ReturnType<typeof getDigestSubscriptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDigestSubscriptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDigestSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateDigestSubscriptionUrl = () => {
  return `/api/reports/digest`;
};

/**
 * @summary Create digest subscription
 */
export const createDigestSubscription = async (
  createDigestSubscriptionBody: CreateDigestSubscriptionBody,
  options?: RequestInit,
): Promise<CreateDigestSubscription200> => {
  return customFetch<CreateDigestSubscription200>(
    getCreateDigestSubscriptionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createDigestSubscriptionBody),
    },
  );
};

export const getCreateDigestSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDigestSubscription>>,
    TError,
    { data: BodyType<CreateDigestSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDigestSubscription>>,
  TError,
  { data: BodyType<CreateDigestSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["createDigestSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDigestSubscription>>,
    { data: BodyType<CreateDigestSubscriptionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDigestSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDigestSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDigestSubscription>>
>;
export type CreateDigestSubscriptionMutationBody =
  BodyType<CreateDigestSubscriptionBody>;
export type CreateDigestSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Create digest subscription
 */
export const useCreateDigestSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDigestSubscription>>,
    TError,
    { data: BodyType<CreateDigestSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDigestSubscription>>,
  TError,
  { data: BodyType<CreateDigestSubscriptionBody> },
  TContext
> => {
  return useMutation(getCreateDigestSubscriptionMutationOptions(options));
};

export const getUpdateDigestSubscriptionUrl = (id: number) => {
  return `/api/reports/digest/${id}`;
};

/**
 * @summary Update digest subscription
 */
export const updateDigestSubscription = async (
  id: number,
  updateDigestSubscriptionBody: UpdateDigestSubscriptionBody,
  options?: RequestInit,
): Promise<UpdateDigestSubscription200> => {
  return customFetch<UpdateDigestSubscription200>(
    getUpdateDigestSubscriptionUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateDigestSubscriptionBody),
    },
  );
};

export const getUpdateDigestSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDigestSubscription>>,
    TError,
    { id: number; data: BodyType<UpdateDigestSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDigestSubscription>>,
  TError,
  { id: number; data: BodyType<UpdateDigestSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["updateDigestSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDigestSubscription>>,
    { id: number; data: BodyType<UpdateDigestSubscriptionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDigestSubscription(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDigestSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDigestSubscription>>
>;
export type UpdateDigestSubscriptionMutationBody =
  BodyType<UpdateDigestSubscriptionBody>;
export type UpdateDigestSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Update digest subscription
 */
export const useUpdateDigestSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDigestSubscription>>,
    TError,
    { id: number; data: BodyType<UpdateDigestSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDigestSubscription>>,
  TError,
  { id: number; data: BodyType<UpdateDigestSubscriptionBody> },
  TContext
> => {
  return useMutation(getUpdateDigestSubscriptionMutationOptions(options));
};

export const getDeleteDigestSubscriptionUrl = (id: number) => {
  return `/api/reports/digest/${id}`;
};

/**
 * @summary Delete digest subscription
 */
export const deleteDigestSubscription = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteDigestSubscription200> => {
  return customFetch<DeleteDigestSubscription200>(
    getDeleteDigestSubscriptionUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteDigestSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDigestSubscription>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDigestSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDigestSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDigestSubscription>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDigestSubscription(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDigestSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDigestSubscription>>
>;

export type DeleteDigestSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Delete digest subscription
 */
export const useDeleteDigestSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDigestSubscription>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDigestSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteDigestSubscriptionMutationOptions(options));
};

export const getGetSmsContactsUrl = () => {
  return `/api/sms/contacts`;
};

/**
 * @summary Get SMS contacts
 */
export const getSmsContacts = async (
  options?: RequestInit,
): Promise<GetSmsContacts200> => {
  return customFetch<GetSmsContacts200>(getGetSmsContactsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSmsContactsQueryKey = () => {
  return [`/api/sms/contacts`] as const;
};

export const getGetSmsContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmsContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsContacts>>> = ({
    signal,
  }) => getSmsContacts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmsContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmsContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmsContacts>>
>;
export type GetSmsContactsQueryError = ErrorType<unknown>;

/**
 * @summary Get SMS contacts
 */

export function useGetSmsContacts<
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmsContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateSmsContactUrl = () => {
  return `/api/sms/contacts`;
};

/**
 * @summary Create SMS contact
 */
export const createSmsContact = async (
  createSmsContactBody: CreateSmsContactBody,
  options?: RequestInit,
): Promise<CreateSmsContact200> => {
  return customFetch<CreateSmsContact200>(getCreateSmsContactUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSmsContactBody),
  });
};

export const getCreateSmsContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmsContact>>,
    TError,
    { data: BodyType<CreateSmsContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSmsContact>>,
  TError,
  { data: BodyType<CreateSmsContactBody> },
  TContext
> => {
  const mutationKey = ["createSmsContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSmsContact>>,
    { data: BodyType<CreateSmsContactBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSmsContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSmsContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSmsContact>>
>;
export type CreateSmsContactMutationBody = BodyType<CreateSmsContactBody>;
export type CreateSmsContactMutationError = ErrorType<unknown>;

/**
 * @summary Create SMS contact
 */
export const useCreateSmsContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmsContact>>,
    TError,
    { data: BodyType<CreateSmsContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSmsContact>>,
  TError,
  { data: BodyType<CreateSmsContactBody> },
  TContext
> => {
  return useMutation(getCreateSmsContactMutationOptions(options));
};

export const getDeleteSmsContactUrl = (id: number) => {
  return `/api/sms/contacts/${id}`;
};

/**
 * @summary Delete SMS contact
 */
export const deleteSmsContact = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteSmsContact200> => {
  return customFetch<DeleteSmsContact200>(getDeleteSmsContactUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSmsContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSmsContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSmsContact>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSmsContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSmsContact>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSmsContact(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSmsContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSmsContact>>
>;

export type DeleteSmsContactMutationError = ErrorType<unknown>;

/**
 * @summary Delete SMS contact
 */
export const useDeleteSmsContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSmsContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSmsContact>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSmsContactMutationOptions(options));
};

export const getOptOutSmsContactUrl = (id: number) => {
  return `/api/sms/contacts/${id}/opt-out`;
};

/**
 * @summary Opt out SMS contact
 */
export const optOutSmsContact = async (
  id: number,
  options?: RequestInit,
): Promise<OptOutSmsContact200> => {
  return customFetch<OptOutSmsContact200>(getOptOutSmsContactUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getOptOutSmsContactMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optOutSmsContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof optOutSmsContact>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["optOutSmsContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof optOutSmsContact>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return optOutSmsContact(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OptOutSmsContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof optOutSmsContact>>
>;

export type OptOutSmsContactMutationError = ErrorType<unknown>;

/**
 * @summary Opt out SMS contact
 */
export const useOptOutSmsContact = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optOutSmsContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof optOutSmsContact>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getOptOutSmsContactMutationOptions(options));
};

export const getGetSmsCampaignsUrl = () => {
  return `/api/sms/campaigns`;
};

/**
 * @summary Get SMS campaigns
 */
export const getSmsCampaigns = async (
  options?: RequestInit,
): Promise<GetSmsCampaigns200> => {
  return customFetch<GetSmsCampaigns200>(getGetSmsCampaignsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSmsCampaignsQueryKey = () => {
  return [`/api/sms/campaigns`] as const;
};

export const getGetSmsCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmsCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsCampaigns>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmsCampaignsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsCampaigns>>> = ({
    signal,
  }) => getSmsCampaigns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmsCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmsCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmsCampaigns>>
>;
export type GetSmsCampaignsQueryError = ErrorType<unknown>;

/**
 * @summary Get SMS campaigns
 */

export function useGetSmsCampaigns<
  TData = Awaited<ReturnType<typeof getSmsCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsCampaigns>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmsCampaignsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateSmsCampaignUrl = () => {
  return `/api/sms/campaigns`;
};

/**
 * @summary Create SMS campaign
 */
export const createSmsCampaign = async (
  createSmsCampaignBody: CreateSmsCampaignBody,
  options?: RequestInit,
): Promise<CreateSmsCampaign200> => {
  return customFetch<CreateSmsCampaign200>(getCreateSmsCampaignUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSmsCampaignBody),
  });
};

export const getCreateSmsCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmsCampaign>>,
    TError,
    { data: BodyType<CreateSmsCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSmsCampaign>>,
  TError,
  { data: BodyType<CreateSmsCampaignBody> },
  TContext
> => {
  const mutationKey = ["createSmsCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSmsCampaign>>,
    { data: BodyType<CreateSmsCampaignBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSmsCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSmsCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSmsCampaign>>
>;
export type CreateSmsCampaignMutationBody = BodyType<CreateSmsCampaignBody>;
export type CreateSmsCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Create SMS campaign
 */
export const useCreateSmsCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmsCampaign>>,
    TError,
    { data: BodyType<CreateSmsCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSmsCampaign>>,
  TError,
  { data: BodyType<CreateSmsCampaignBody> },
  TContext
> => {
  return useMutation(getCreateSmsCampaignMutationOptions(options));
};

export const getUpdateSmsCampaignUrl = (id: number) => {
  return `/api/sms/campaigns/${id}`;
};

/**
 * @summary Update SMS campaign
 */
export const updateSmsCampaign = async (
  id: number,
  updateSmsCampaignBody: UpdateSmsCampaignBody,
  options?: RequestInit,
): Promise<UpdateSmsCampaign200> => {
  return customFetch<UpdateSmsCampaign200>(getUpdateSmsCampaignUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSmsCampaignBody),
  });
};

export const getUpdateSmsCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSmsCampaign>>,
    TError,
    { id: number; data: BodyType<UpdateSmsCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSmsCampaign>>,
  TError,
  { id: number; data: BodyType<UpdateSmsCampaignBody> },
  TContext
> => {
  const mutationKey = ["updateSmsCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSmsCampaign>>,
    { id: number; data: BodyType<UpdateSmsCampaignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSmsCampaign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSmsCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSmsCampaign>>
>;
export type UpdateSmsCampaignMutationBody = BodyType<UpdateSmsCampaignBody>;
export type UpdateSmsCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Update SMS campaign
 */
export const useUpdateSmsCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSmsCampaign>>,
    TError,
    { id: number; data: BodyType<UpdateSmsCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSmsCampaign>>,
  TError,
  { id: number; data: BodyType<UpdateSmsCampaignBody> },
  TContext
> => {
  return useMutation(getUpdateSmsCampaignMutationOptions(options));
};

export const getDeleteSmsCampaignUrl = (id: number) => {
  return `/api/sms/campaigns/${id}`;
};

/**
 * @summary Delete SMS campaign
 */
export const deleteSmsCampaign = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteSmsCampaign200> => {
  return customFetch<DeleteSmsCampaign200>(getDeleteSmsCampaignUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSmsCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSmsCampaign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSmsCampaign>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSmsCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSmsCampaign>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSmsCampaign(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSmsCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSmsCampaign>>
>;

export type DeleteSmsCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Delete SMS campaign
 */
export const useDeleteSmsCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSmsCampaign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSmsCampaign>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSmsCampaignMutationOptions(options));
};

export const getSendSmsCampaignUrl = (id: number) => {
  return `/api/sms/campaigns/${id}/send`;
};

/**
 * @summary Send SMS campaign
 */
export const sendSmsCampaign = async (
  id: number,
  options?: RequestInit,
): Promise<SendSmsCampaign200> => {
  return customFetch<SendSmsCampaign200>(getSendSmsCampaignUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendSmsCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSmsCampaign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSmsCampaign>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendSmsCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSmsCampaign>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendSmsCampaign(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendSmsCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSmsCampaign>>
>;

export type SendSmsCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Send SMS campaign
 */
export const useSendSmsCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSmsCampaign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendSmsCampaign>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendSmsCampaignMutationOptions(options));
};

export const getGenerateSmsMessageUrl = () => {
  return `/api/sms/generate-message`;
};

/**
 * @summary AI generate SMS message
 */
export const generateSmsMessage = async (
  generateSmsMessageBody: GenerateSmsMessageBody,
  options?: RequestInit,
): Promise<GenerateSmsMessage200> => {
  return customFetch<GenerateSmsMessage200>(getGenerateSmsMessageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateSmsMessageBody),
  });
};

export const getGenerateSmsMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSmsMessage>>,
    TError,
    { data: BodyType<GenerateSmsMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSmsMessage>>,
  TError,
  { data: BodyType<GenerateSmsMessageBody> },
  TContext
> => {
  const mutationKey = ["generateSmsMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSmsMessage>>,
    { data: BodyType<GenerateSmsMessageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateSmsMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSmsMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSmsMessage>>
>;
export type GenerateSmsMessageMutationBody = BodyType<GenerateSmsMessageBody>;
export type GenerateSmsMessageMutationError = ErrorType<unknown>;

/**
 * @summary AI generate SMS message
 */
export const useGenerateSmsMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSmsMessage>>,
    TError,
    { data: BodyType<GenerateSmsMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSmsMessage>>,
  TError,
  { data: BodyType<GenerateSmsMessageBody> },
  TContext
> => {
  return useMutation(getGenerateSmsMessageMutationOptions(options));
};

export const getGetSmsMessagesUrl = () => {
  return `/api/sms/messages`;
};

/**
 * @summary Get SMS messages log
 */
export const getSmsMessages = async (
  options?: RequestInit,
): Promise<GetSmsMessages200> => {
  return customFetch<GetSmsMessages200>(getGetSmsMessagesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSmsMessagesQueryKey = () => {
  return [`/api/sms/messages`] as const;
};

export const getGetSmsMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmsMessages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsMessages>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmsMessagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsMessages>>> = ({
    signal,
  }) => getSmsMessages({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmsMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmsMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmsMessages>>
>;
export type GetSmsMessagesQueryError = ErrorType<unknown>;

/**
 * @summary Get SMS messages log
 */

export function useGetSmsMessages<
  TData = Awaited<ReturnType<typeof getSmsMessages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSmsMessages>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmsMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSchedulingMeetingTypesUrl = () => {
  return `/api/scheduling/meeting-types`;
};

/**
 * @summary Get meeting types
 */
export const getSchedulingMeetingTypes = async (
  options?: RequestInit,
): Promise<GetSchedulingMeetingTypes200> => {
  return customFetch<GetSchedulingMeetingTypes200>(
    getGetSchedulingMeetingTypesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchedulingMeetingTypesQueryKey = () => {
  return [`/api/scheduling/meeting-types`] as const;
};

export const getGetSchedulingMeetingTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedulingMeetingTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingMeetingTypes>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSchedulingMeetingTypesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchedulingMeetingTypes>>
  > = ({ signal }) => getSchedulingMeetingTypes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchedulingMeetingTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchedulingMeetingTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchedulingMeetingTypes>>
>;
export type GetSchedulingMeetingTypesQueryError = ErrorType<unknown>;

/**
 * @summary Get meeting types
 */

export function useGetSchedulingMeetingTypes<
  TData = Awaited<ReturnType<typeof getSchedulingMeetingTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingMeetingTypes>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchedulingMeetingTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateMeetingTypeUrl = () => {
  return `/api/scheduling/meeting-types`;
};

/**
 * @summary Create meeting type
 */
export const createMeetingType = async (
  createMeetingTypeBody: CreateMeetingTypeBody,
  options?: RequestInit,
): Promise<CreateMeetingType200> => {
  return customFetch<CreateMeetingType200>(getCreateMeetingTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMeetingTypeBody),
  });
};

export const getCreateMeetingTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingType>>,
    TError,
    { data: BodyType<CreateMeetingTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingType>>,
  TError,
  { data: BodyType<CreateMeetingTypeBody> },
  TContext
> => {
  const mutationKey = ["createMeetingType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingType>>,
    { data: BodyType<CreateMeetingTypeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMeetingType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingType>>
>;
export type CreateMeetingTypeMutationBody = BodyType<CreateMeetingTypeBody>;
export type CreateMeetingTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create meeting type
 */
export const useCreateMeetingType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingType>>,
    TError,
    { data: BodyType<CreateMeetingTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingType>>,
  TError,
  { data: BodyType<CreateMeetingTypeBody> },
  TContext
> => {
  return useMutation(getCreateMeetingTypeMutationOptions(options));
};

export const getUpdateMeetingTypeUrl = (id: number) => {
  return `/api/scheduling/meeting-types/${id}`;
};

/**
 * @summary Update meeting type
 */
export const updateMeetingType = async (
  id: number,
  updateMeetingTypeBody: UpdateMeetingTypeBody,
  options?: RequestInit,
): Promise<UpdateMeetingType200> => {
  return customFetch<UpdateMeetingType200>(getUpdateMeetingTypeUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMeetingTypeBody),
  });
};

export const getUpdateMeetingTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingType>>,
    TError,
    { id: number; data: BodyType<UpdateMeetingTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingType>>,
  TError,
  { id: number; data: BodyType<UpdateMeetingTypeBody> },
  TContext
> => {
  const mutationKey = ["updateMeetingType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingType>>,
    { id: number; data: BodyType<UpdateMeetingTypeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMeetingType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingType>>
>;
export type UpdateMeetingTypeMutationBody = BodyType<UpdateMeetingTypeBody>;
export type UpdateMeetingTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update meeting type
 */
export const useUpdateMeetingType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingType>>,
    TError,
    { id: number; data: BodyType<UpdateMeetingTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingType>>,
  TError,
  { id: number; data: BodyType<UpdateMeetingTypeBody> },
  TContext
> => {
  return useMutation(getUpdateMeetingTypeMutationOptions(options));
};

export const getDeleteMeetingTypeUrl = (id: number) => {
  return `/api/scheduling/meeting-types/${id}`;
};

/**
 * @summary Delete meeting type
 */
export const deleteMeetingType = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteMeetingType200> => {
  return customFetch<DeleteMeetingType200>(getDeleteMeetingTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMeetingTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeetingType>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMeetingType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeetingType>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMeetingType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeetingType>>
>;

export type DeleteMeetingTypeMutationError = ErrorType<unknown>;

/**
 * @summary Delete meeting type
 */
export const useDeleteMeetingType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeetingType>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMeetingTypeMutationOptions(options));
};

export const getGetSchedulingBookingsUrl = () => {
  return `/api/scheduling/bookings`;
};

/**
 * @summary Get bookings
 */
export const getSchedulingBookings = async (
  options?: RequestInit,
): Promise<GetSchedulingBookings200> => {
  return customFetch<GetSchedulingBookings200>(getGetSchedulingBookingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSchedulingBookingsQueryKey = () => {
  return [`/api/scheduling/bookings`] as const;
};

export const getGetSchedulingBookingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedulingBookings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingBookings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSchedulingBookingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchedulingBookings>>
  > = ({ signal }) => getSchedulingBookings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchedulingBookings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchedulingBookingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchedulingBookings>>
>;
export type GetSchedulingBookingsQueryError = ErrorType<unknown>;

/**
 * @summary Get bookings
 */

export function useGetSchedulingBookings<
  TData = Awaited<ReturnType<typeof getSchedulingBookings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingBookings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchedulingBookingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateBookingUrl = () => {
  return `/api/scheduling/bookings`;
};

/**
 * @summary Create booking
 */
export const createBooking = async (
  createBookingBody: CreateBookingBody,
  options?: RequestInit,
): Promise<CreateBooking200> => {
  return customFetch<CreateBooking200>(getCreateBookingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBookingBody),
  });
};

export const getCreateBookingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBooking>>,
    TError,
    { data: BodyType<CreateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBooking>>,
  TError,
  { data: BodyType<CreateBookingBody> },
  TContext
> => {
  const mutationKey = ["createBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBooking>>,
    { data: BodyType<CreateBookingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBooking(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBooking>>
>;
export type CreateBookingMutationBody = BodyType<CreateBookingBody>;
export type CreateBookingMutationError = ErrorType<unknown>;

/**
 * @summary Create booking
 */
export const useCreateBooking = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBooking>>,
    TError,
    { data: BodyType<CreateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBooking>>,
  TError,
  { data: BodyType<CreateBookingBody> },
  TContext
> => {
  return useMutation(getCreateBookingMutationOptions(options));
};

export const getUpdateBookingUrl = (id: number) => {
  return `/api/scheduling/bookings/${id}`;
};

/**
 * @summary Update booking
 */
export const updateBooking = async (
  id: number,
  updateBookingBody: UpdateBookingBody,
  options?: RequestInit,
): Promise<UpdateBooking200> => {
  return customFetch<UpdateBooking200>(getUpdateBookingUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBookingBody),
  });
};

export const getUpdateBookingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBooking>>,
    TError,
    { id: number; data: BodyType<UpdateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBooking>>,
  TError,
  { id: number; data: BodyType<UpdateBookingBody> },
  TContext
> => {
  const mutationKey = ["updateBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBooking>>,
    { id: number; data: BodyType<UpdateBookingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBooking(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBooking>>
>;
export type UpdateBookingMutationBody = BodyType<UpdateBookingBody>;
export type UpdateBookingMutationError = ErrorType<unknown>;

/**
 * @summary Update booking
 */
export const useUpdateBooking = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBooking>>,
    TError,
    { id: number; data: BodyType<UpdateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBooking>>,
  TError,
  { id: number; data: BodyType<UpdateBookingBody> },
  TContext
> => {
  return useMutation(getUpdateBookingMutationOptions(options));
};

export const getDeleteBookingUrl = (id: number) => {
  return `/api/scheduling/bookings/${id}`;
};

/**
 * @summary Delete booking
 */
export const deleteBooking = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteBooking200> => {
  return customFetch<DeleteBooking200>(getDeleteBookingUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBookingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBooking>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBooking>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBooking>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBooking(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBooking>>
>;

export type DeleteBookingMutationError = ErrorType<unknown>;

/**
 * @summary Delete booking
 */
export const useDeleteBooking = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBooking>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBooking>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBookingMutationOptions(options));
};

export const getGetSchedulingAvailabilityUrl = () => {
  return `/api/scheduling/availability`;
};

/**
 * @summary Get availability slots
 */
export const getSchedulingAvailability = async (
  options?: RequestInit,
): Promise<GetSchedulingAvailability200> => {
  return customFetch<GetSchedulingAvailability200>(
    getGetSchedulingAvailabilityUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchedulingAvailabilityQueryKey = () => {
  return [`/api/scheduling/availability`] as const;
};

export const getGetSchedulingAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedulingAvailability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingAvailability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSchedulingAvailabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchedulingAvailability>>
  > = ({ signal }) => getSchedulingAvailability({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchedulingAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchedulingAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchedulingAvailability>>
>;
export type GetSchedulingAvailabilityQueryError = ErrorType<unknown>;

/**
 * @summary Get availability slots
 */

export function useGetSchedulingAvailability<
  TData = Awaited<ReturnType<typeof getSchedulingAvailability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchedulingAvailability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchedulingAvailabilityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWebhookEventsUrl = () => {
  return `/api/webhooks/events`;
};

/**
 * @summary List available webhook events
 */
export const getWebhookEvents = async (
  options?: RequestInit,
): Promise<GetWebhookEvents200> => {
  return customFetch<GetWebhookEvents200>(getGetWebhookEventsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookEventsQueryKey = () => {
  return [`/api/webhooks/events`] as const;
};

export const getGetWebhookEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookEvents>>
  > = ({ signal }) => getWebhookEvents({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebhookEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookEvents>>
>;
export type GetWebhookEventsQueryError = ErrorType<unknown>;

/**
 * @summary List available webhook events
 */

export function useGetWebhookEvents<
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWebhookEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWebhookEndpointsUrl = () => {
  return `/api/webhooks/endpoints`;
};

/**
 * @summary List webhook endpoints
 */
export const getWebhookEndpoints = async (
  options?: RequestInit,
): Promise<GetWebhookEndpoints200> => {
  return customFetch<GetWebhookEndpoints200>(getGetWebhookEndpointsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookEndpointsQueryKey = () => {
  return [`/api/webhooks/endpoints`] as const;
};

export const getGetWebhookEndpointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookEndpoints>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWebhookEndpoints>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookEndpointsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookEndpoints>>
  > = ({ signal }) => getWebhookEndpoints({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookEndpoints>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebhookEndpointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookEndpoints>>
>;
export type GetWebhookEndpointsQueryError = ErrorType<unknown>;

/**
 * @summary List webhook endpoints
 */

export function useGetWebhookEndpoints<
  TData = Awaited<ReturnType<typeof getWebhookEndpoints>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWebhookEndpoints>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWebhookEndpointsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateWebhookEndpointUrl = () => {
  return `/api/webhooks/endpoints`;
};

/**
 * @summary Create a webhook endpoint
 */
export const createWebhookEndpoint = async (
  createWebhookEndpointBody: CreateWebhookEndpointBody,
  options?: RequestInit,
): Promise<CreateWebhookEndpoint200> => {
  return customFetch<CreateWebhookEndpoint200>(getCreateWebhookEndpointUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createWebhookEndpointBody),
  });
};

export const getCreateWebhookEndpointMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    TError,
    { data: BodyType<CreateWebhookEndpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWebhookEndpoint>>,
  TError,
  { data: BodyType<CreateWebhookEndpointBody> },
  TContext
> => {
  const mutationKey = ["createWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    { data: BodyType<CreateWebhookEndpointBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createWebhookEndpoint(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWebhookEndpoint>>
>;
export type CreateWebhookEndpointMutationBody =
  BodyType<CreateWebhookEndpointBody>;
export type CreateWebhookEndpointMutationError = ErrorType<unknown>;

/**
 * @summary Create a webhook endpoint
 */
export const useCreateWebhookEndpoint = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    TError,
    { data: BodyType<CreateWebhookEndpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWebhookEndpoint>>,
  TError,
  { data: BodyType<CreateWebhookEndpointBody> },
  TContext
> => {
  return useMutation(getCreateWebhookEndpointMutationOptions(options));
};

export const getUpdateWebhookEndpointUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}`;
};

/**
 * @summary Update a webhook endpoint
 */
export const updateWebhookEndpoint = async (
  id: number,
  updateWebhookEndpointBody: UpdateWebhookEndpointBody,
  options?: RequestInit,
): Promise<UpdateWebhookEndpoint200> => {
  return customFetch<UpdateWebhookEndpoint200>(
    getUpdateWebhookEndpointUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateWebhookEndpointBody),
    },
  );
};

export const getUpdateWebhookEndpointMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    TError,
    { id: number; data: BodyType<UpdateWebhookEndpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>,
  TError,
  { id: number; data: BodyType<UpdateWebhookEndpointBody> },
  TContext
> => {
  const mutationKey = ["updateWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    { id: number; data: BodyType<UpdateWebhookEndpointBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWebhookEndpoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>
>;
export type UpdateWebhookEndpointMutationBody =
  BodyType<UpdateWebhookEndpointBody>;
export type UpdateWebhookEndpointMutationError = ErrorType<unknown>;

/**
 * @summary Update a webhook endpoint
 */
export const useUpdateWebhookEndpoint = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    TError,
    { id: number; data: BodyType<UpdateWebhookEndpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>,
  TError,
  { id: number; data: BodyType<UpdateWebhookEndpointBody> },
  TContext
> => {
  return useMutation(getUpdateWebhookEndpointMutationOptions(options));
};

export const getDeleteWebhookEndpointUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}`;
};

/**
 * @summary Delete a webhook endpoint
 */
export const deleteWebhookEndpoint = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteWebhookEndpoint200> => {
  return customFetch<DeleteWebhookEndpoint200>(
    getDeleteWebhookEndpointUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteWebhookEndpointMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWebhookEndpoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>
>;

export type DeleteWebhookEndpointMutationError = ErrorType<unknown>;

/**
 * @summary Delete a webhook endpoint
 */
export const useDeleteWebhookEndpoint = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteWebhookEndpointMutationOptions(options));
};

export const getTestWebhookEndpointUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}/test`;
};

/**
 * @summary Send a test delivery to a webhook endpoint
 */
export const testWebhookEndpoint = async (
  id: number,
  options?: RequestInit,
): Promise<TestWebhookEndpoint200> => {
  return customFetch<TestWebhookEndpoint200>(getTestWebhookEndpointUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getTestWebhookEndpointMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["testWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testWebhookEndpoint>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return testWebhookEndpoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof testWebhookEndpoint>>
>;

export type TestWebhookEndpointMutationError = ErrorType<unknown>;

/**
 * @summary Send a test delivery to a webhook endpoint
 */
export const useTestWebhookEndpoint = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getTestWebhookEndpointMutationOptions(options));
};

export const getGetWebhookDeliveriesUrl = () => {
  return `/api/webhooks/deliveries`;
};

/**
 * @summary List webhook deliveries
 */
export const getWebhookDeliveries = async (
  options?: RequestInit,
): Promise<GetWebhookDeliveries200> => {
  return customFetch<GetWebhookDeliveries200>(getGetWebhookDeliveriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookDeliveriesQueryKey = () => {
  return [`/api/webhooks/deliveries`] as const;
};

export const getGetWebhookDeliveriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookDeliveries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWebhookDeliveries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookDeliveriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookDeliveries>>
  > = ({ signal }) => getWebhookDeliveries({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookDeliveries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebhookDeliveriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookDeliveries>>
>;
export type GetWebhookDeliveriesQueryError = ErrorType<unknown>;

/**
 * @summary List webhook deliveries
 */

export function useGetWebhookDeliveries<
  TData = Awaited<ReturnType<typeof getWebhookDeliveries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWebhookDeliveries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWebhookDeliveriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetEmailDomainsUrl = () => {
  return `/api/deliverability/domains`;
};

/**
 * @summary List email domains
 */
export const getEmailDomains = async (
  options?: RequestInit,
): Promise<GetEmailDomains200> => {
  return customFetch<GetEmailDomains200>(getGetEmailDomainsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailDomainsQueryKey = () => {
  return [`/api/deliverability/domains`] as const;
};

export const getGetEmailDomainsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailDomains>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailDomains>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailDomainsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailDomains>>> = ({
    signal,
  }) => getEmailDomains({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailDomains>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailDomainsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailDomains>>
>;
export type GetEmailDomainsQueryError = ErrorType<unknown>;

/**
 * @summary List email domains
 */

export function useGetEmailDomains<
  TData = Awaited<ReturnType<typeof getEmailDomains>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmailDomains>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailDomainsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateEmailDomainUrl = () => {
  return `/api/deliverability/domains`;
};

/**
 * @summary Add email domain
 */
export const createEmailDomain = async (
  createEmailDomainBody: CreateEmailDomainBody,
  options?: RequestInit,
): Promise<CreateEmailDomain201> => {
  return customFetch<CreateEmailDomain201>(getCreateEmailDomainUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createEmailDomainBody),
  });
};

export const getCreateEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmailDomain>>,
    TError,
    { data: BodyType<CreateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEmailDomain>>,
  TError,
  { data: BodyType<CreateEmailDomainBody> },
  TContext
> => {
  const mutationKey = ["createEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmailDomain>>,
    { data: BodyType<CreateEmailDomainBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createEmailDomain(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEmailDomain>>
>;
export type CreateEmailDomainMutationBody = BodyType<CreateEmailDomainBody>;
export type CreateEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Add email domain
 */
export const useCreateEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmailDomain>>,
    TError,
    { data: BodyType<CreateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEmailDomain>>,
  TError,
  { data: BodyType<CreateEmailDomainBody> },
  TContext
> => {
  return useMutation(getCreateEmailDomainMutationOptions(options));
};

export const getUpdateEmailDomainUrl = (id: number) => {
  return `/api/deliverability/domains/${id}`;
};

/**
 * @summary Update domain settings
 */
export const updateEmailDomain = async (
  id: number,
  updateEmailDomainBody: UpdateEmailDomainBody,
  options?: RequestInit,
): Promise<UpdateEmailDomain200> => {
  return customFetch<UpdateEmailDomain200>(getUpdateEmailDomainUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailDomainBody),
  });
};

export const getUpdateEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailDomain>>,
    TError,
    { id: number; data: BodyType<UpdateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailDomain>>,
  TError,
  { id: number; data: BodyType<UpdateEmailDomainBody> },
  TContext
> => {
  const mutationKey = ["updateEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailDomain>>,
    { id: number; data: BodyType<UpdateEmailDomainBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEmailDomain(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailDomain>>
>;
export type UpdateEmailDomainMutationBody = BodyType<UpdateEmailDomainBody>;
export type UpdateEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Update domain settings
 */
export const useUpdateEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailDomain>>,
    TError,
    { id: number; data: BodyType<UpdateEmailDomainBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailDomain>>,
  TError,
  { id: number; data: BodyType<UpdateEmailDomainBody> },
  TContext
> => {
  return useMutation(getUpdateEmailDomainMutationOptions(options));
};

export const getDeleteEmailDomainUrl = (id: number) => {
  return `/api/deliverability/domains/${id}`;
};

/**
 * @summary Delete email domain
 */
export const deleteEmailDomain = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteEmailDomain200> => {
  return customFetch<DeleteEmailDomain200>(getDeleteEmailDomainUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmailDomain>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEmailDomain>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEmailDomain>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEmailDomain(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEmailDomain>>
>;

export type DeleteEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Delete email domain
 */
export const useDeleteEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmailDomain>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEmailDomain>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteEmailDomainMutationOptions(options));
};

export const getVerifyEmailDomainUrl = (id: number) => {
  return `/api/deliverability/domains/${id}/verify`;
};

/**
 * @summary Verify domain DNS records
 */
export const verifyEmailDomain = async (
  id: number,
  options?: RequestInit,
): Promise<VerifyEmailDomain200> => {
  return customFetch<VerifyEmailDomain200>(getVerifyEmailDomainUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getVerifyEmailDomainMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmailDomain>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmailDomain>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["verifyEmailDomain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmailDomain>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return verifyEmailDomain(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmailDomain>>
>;

export type VerifyEmailDomainMutationError = ErrorType<unknown>;

/**
 * @summary Verify domain DNS records
 */
export const useVerifyEmailDomain = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmailDomain>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmailDomain>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getVerifyEmailDomainMutationOptions(options));
};

export const getGetWarmupLogsUrl = (domainId: number) => {
  return `/api/deliverability/warmup/${domainId}`;
};

/**
 * @summary Get warmup logs for domain
 */
export const getWarmupLogs = async (
  domainId: number,
  options?: RequestInit,
): Promise<GetWarmupLogs200> => {
  return customFetch<GetWarmupLogs200>(getGetWarmupLogsUrl(domainId), {
    ...options,
    method: "GET",
  });
};

export const getGetWarmupLogsQueryKey = (domainId: number) => {
  return [`/api/deliverability/warmup/${domainId}`] as const;
};

export const getGetWarmupLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarmupLogs>>,
  TError = ErrorType<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarmupLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWarmupLogsQueryKey(domainId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWarmupLogs>>> = ({
    signal,
  }) => getWarmupLogs(domainId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: domainId !== null && domainId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarmupLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWarmupLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarmupLogs>>
>;
export type GetWarmupLogsQueryError = ErrorType<unknown>;

/**
 * @summary Get warmup logs for domain
 */

export function useGetWarmupLogs<
  TData = Awaited<ReturnType<typeof getWarmupLogs>>,
  TError = ErrorType<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarmupLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWarmupLogsQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTeamMembersUrl = () => {
  return `/api/team/members`;
};

/**
 * @summary List team members
 */
export const getTeamMembers = async (
  options?: RequestInit,
): Promise<GetTeamMembers200> => {
  return customFetch<GetTeamMembers200>(getGetTeamMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamMembersQueryKey = () => {
  return [`/api/team/members`] as const;
};

export const getGetTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamMembersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMembers>>> = ({
    signal,
  }) => getTeamMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamMembers>>
>;
export type GetTeamMembersQueryError = ErrorType<unknown>;

/**
 * @summary List team members
 */

export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTeamMembersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getInviteTeamMemberUrl = () => {
  return `/api/team/members`;
};

/**
 * @summary Invite a team member
 */
export const inviteTeamMember = async (
  inviteTeamMemberBody: InviteTeamMemberBody,
  options?: RequestInit,
): Promise<InviteTeamMember201> => {
  return customFetch<InviteTeamMember201>(getInviteTeamMemberUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteTeamMemberBody),
  });
};

export const getInviteTeamMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteTeamMember>>,
    TError,
    { data: BodyType<InviteTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteTeamMember>>,
  TError,
  { data: BodyType<InviteTeamMemberBody> },
  TContext
> => {
  const mutationKey = ["inviteTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteTeamMember>>,
    { data: BodyType<InviteTeamMemberBody> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteTeamMember(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteTeamMember>>
>;
export type InviteTeamMemberMutationBody = BodyType<InviteTeamMemberBody>;
export type InviteTeamMemberMutationError = ErrorType<unknown>;

/**
 * @summary Invite a team member
 */
export const useInviteTeamMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteTeamMember>>,
    TError,
    { data: BodyType<InviteTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteTeamMember>>,
  TError,
  { data: BodyType<InviteTeamMemberBody> },
  TContext
> => {
  return useMutation(getInviteTeamMemberMutationOptions(options));
};

export const getUpdateTeamMemberUrl = (id: number) => {
  return `/api/team/members/${id}`;
};

/**
 * @summary Update team member role or status
 */
export const updateTeamMember = async (
  id: number,
  updateTeamMemberBody: UpdateTeamMemberBody,
  options?: RequestInit,
): Promise<UpdateTeamMember200> => {
  return customFetch<UpdateTeamMember200>(getUpdateTeamMemberUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTeamMemberBody),
  });
};

export const getUpdateTeamMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamMember>>,
    TError,
    { id: number; data: BodyType<UpdateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamMember>>,
  TError,
  { id: number; data: BodyType<UpdateTeamMemberBody> },
  TContext
> => {
  const mutationKey = ["updateTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamMember>>,
    { id: number; data: BodyType<UpdateTeamMemberBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTeamMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeamMember>>
>;
export type UpdateTeamMemberMutationBody = BodyType<UpdateTeamMemberBody>;
export type UpdateTeamMemberMutationError = ErrorType<unknown>;

/**
 * @summary Update team member role or status
 */
export const useUpdateTeamMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamMember>>,
    TError,
    { id: number; data: BodyType<UpdateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamMember>>,
  TError,
  { id: number; data: BodyType<UpdateTeamMemberBody> },
  TContext
> => {
  return useMutation(getUpdateTeamMemberMutationOptions(options));
};

export const getRemoveTeamMemberUrl = (id: number) => {
  return `/api/team/members/${id}`;
};

/**
 * @summary Remove a team member
 */
export const removeTeamMember = async (
  id: number,
  options?: RequestInit,
): Promise<RemoveTeamMember200> => {
  return customFetch<RemoveTeamMember200>(getRemoveTeamMemberUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveTeamMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTeamMember>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTeamMember>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["removeTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTeamMember>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return removeTeamMember(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTeamMember>>
>;

export type RemoveTeamMemberMutationError = ErrorType<unknown>;

/**
 * @summary Remove a team member
 */
export const useRemoveTeamMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTeamMember>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeTeamMember>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRemoveTeamMemberMutationOptions(options));
};

export const getResendTeamInviteUrl = (id: number) => {
  return `/api/team/members/${id}/resend`;
};

/**
 * @summary Resend invite to team member
 */
export const resendTeamInvite = async (
  id: number,
  options?: RequestInit,
): Promise<ResendTeamInvite200> => {
  return customFetch<ResendTeamInvite200>(getResendTeamInviteUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResendTeamInviteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendTeamInvite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendTeamInvite>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resendTeamInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendTeamInvite>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resendTeamInvite(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendTeamInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendTeamInvite>>
>;

export type ResendTeamInviteMutationError = ErrorType<unknown>;

/**
 * @summary Resend invite to team member
 */
export const useResendTeamInvite = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendTeamInvite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendTeamInvite>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResendTeamInviteMutationOptions(options));
};

export const getGetBillingSubscriptionUrl = () => {
  return `/api/billing/subscription`;
};

/**
 * @summary Get current subscription
 */
export const getBillingSubscription = async (
  options?: RequestInit,
): Promise<GetBillingSubscription200> => {
  return customFetch<GetBillingSubscription200>(
    getGetBillingSubscriptionUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBillingSubscriptionQueryKey = () => {
  return [`/api/billing/subscription`] as const;
};

export const getGetBillingSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingSubscription>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBillingSubscription>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBillingSubscriptionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingSubscription>>
  > = ({ signal }) => getBillingSubscription({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingSubscription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingSubscription>>
>;
export type GetBillingSubscriptionQueryError = ErrorType<unknown>;

/**
 * @summary Get current subscription
 */

export function useGetBillingSubscription<
  TData = Awaited<ReturnType<typeof getBillingSubscription>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBillingSubscription>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingSubscriptionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBillingPlansUrl = () => {
  return `/api/billing/plans`;
};

/**
 * @summary Get available plans
 */
export const getBillingPlans = async (
  options?: RequestInit,
): Promise<GetBillingPlans200> => {
  return customFetch<GetBillingPlans200>(getGetBillingPlansUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingPlansQueryKey = () => {
  return [`/api/billing/plans`] as const;
};

export const getGetBillingPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBillingPlans>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingPlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingPlans>>> = ({
    signal,
  }) => getBillingPlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingPlans>>
>;
export type GetBillingPlansQueryError = ErrorType<unknown>;

/**
 * @summary Get available plans
 */

export function useGetBillingPlans<
  TData = Awaited<ReturnType<typeof getBillingPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBillingPlans>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingPlansQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSubscribeToPlanUrl = () => {
  return `/api/billing/subscribe`;
};

/**
 * @summary Subscribe to a plan
 */
export const subscribeToPlan = async (
  subscribeToPlanBody: SubscribeToPlanBody,
  options?: RequestInit,
): Promise<SubscribeToPlan200> => {
  return customFetch<SubscribeToPlan200>(getSubscribeToPlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(subscribeToPlanBody),
  });
};

export const getSubscribeToPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeToPlan>>,
    TError,
    { data: BodyType<SubscribeToPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribeToPlan>>,
  TError,
  { data: BodyType<SubscribeToPlanBody> },
  TContext
> => {
  const mutationKey = ["subscribeToPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribeToPlan>>,
    { data: BodyType<SubscribeToPlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return subscribeToPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribeToPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribeToPlan>>
>;
export type SubscribeToPlanMutationBody = BodyType<SubscribeToPlanBody>;
export type SubscribeToPlanMutationError = ErrorType<unknown>;

/**
 * @summary Subscribe to a plan
 */
export const useSubscribeToPlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeToPlan>>,
    TError,
    { data: BodyType<SubscribeToPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribeToPlan>>,
  TError,
  { data: BodyType<SubscribeToPlanBody> },
  TContext
> => {
  return useMutation(getSubscribeToPlanMutationOptions(options));
};

export const getCancelSubscriptionUrl = () => {
  return `/api/billing/cancel`;
};

/**
 * @summary Cancel subscription at period end
 */
export const cancelSubscription = async (
  options?: RequestInit,
): Promise<CancelSubscription200> => {
  return customFetch<CancelSubscription200>(getCancelSubscriptionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCancelSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSubscription>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["cancelSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSubscription>>,
    void
  > = () => {
    return cancelSubscription(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSubscription>>
>;

export type CancelSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Cancel subscription at period end
 */
export const useCancelSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelSubscription>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCancelSubscriptionMutationOptions(options));
};

export const getGetBillingInvoicesUrl = () => {
  return `/api/billing/invoices`;
};

/**
 * @summary Get invoice history
 */
export const getBillingInvoices = async (
  options?: RequestInit,
): Promise<GetBillingInvoices200> => {
  return customFetch<GetBillingInvoices200>(getGetBillingInvoicesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingInvoicesQueryKey = () => {
  return [`/api/billing/invoices`] as const;
};

export const getGetBillingInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBillingInvoices>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingInvoicesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingInvoices>>
  > = ({ signal }) => getBillingInvoices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingInvoices>>
>;
export type GetBillingInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary Get invoice history
 */

export function useGetBillingInvoices<
  TData = Awaited<ReturnType<typeof getBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBillingInvoices>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingInvoicesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetProposalsUrl = () => {
  return `/api/api/proposals`;
};

/**
 * @summary List proposals
 */
export const getProposals = async (
  options?: RequestInit,
): Promise<Proposal[]> => {
  return customFetch<Proposal[]>(getGetProposalsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProposalsQueryKey = () => {
  return [`/api/api/proposals`] as const;
};

export const getGetProposalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProposals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProposals>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProposalsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProposals>>> = ({
    signal,
  }) => getProposals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProposals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProposalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProposals>>
>;
export type GetProposalsQueryError = ErrorType<unknown>;

/**
 * @summary List proposals
 */

export function useGetProposals<
  TData = Awaited<ReturnType<typeof getProposals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProposals>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProposalsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateProposalUrl = () => {
  return `/api/api/proposals`;
};

/**
 * @summary Create proposal
 */
export const createProposal = async (
  createProposalBody: CreateProposalBody,
  options?: RequestInit,
): Promise<Proposal> => {
  return customFetch<Proposal>(getCreateProposalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProposalBody),
  });
};

export const getCreateProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProposal>>,
    TError,
    { data: BodyType<CreateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProposal>>,
  TError,
  { data: BodyType<CreateProposalBody> },
  TContext
> => {
  const mutationKey = ["createProposal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProposal>>,
    { data: BodyType<CreateProposalBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProposal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProposal>>
>;
export type CreateProposalMutationBody = BodyType<CreateProposalBody>;
export type CreateProposalMutationError = ErrorType<unknown>;

/**
 * @summary Create proposal
 */
export const useCreateProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProposal>>,
    TError,
    { data: BodyType<CreateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProposal>>,
  TError,
  { data: BodyType<CreateProposalBody> },
  TContext
> => {
  return useMutation(getCreateProposalMutationOptions(options));
};

export const getGenerateProposalUrl = () => {
  return `/api/api/proposals/generate`;
};

/**
 * @summary AI generate proposal
 */
export const generateProposal = async (
  generateProposalBody: GenerateProposalBody,
  options?: RequestInit,
): Promise<GenerateProposal200> => {
  return customFetch<GenerateProposal200>(getGenerateProposalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateProposalBody),
  });
};

export const getGenerateProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateProposal>>,
    TError,
    { data: BodyType<GenerateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateProposal>>,
  TError,
  { data: BodyType<GenerateProposalBody> },
  TContext
> => {
  const mutationKey = ["generateProposal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateProposal>>,
    { data: BodyType<GenerateProposalBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateProposal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateProposal>>
>;
export type GenerateProposalMutationBody = BodyType<GenerateProposalBody>;
export type GenerateProposalMutationError = ErrorType<unknown>;

/**
 * @summary AI generate proposal
 */
export const useGenerateProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateProposal>>,
    TError,
    { data: BodyType<GenerateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateProposal>>,
  TError,
  { data: BodyType<GenerateProposalBody> },
  TContext
> => {
  return useMutation(getGenerateProposalMutationOptions(options));
};

export const getGetProposalUrl = (id: number) => {
  return `/api/api/proposals/${id}`;
};

/**
 * @summary Get proposal
 */
export const getProposal = async (
  id: number,
  options?: RequestInit,
): Promise<Proposal> => {
  return customFetch<Proposal>(getGetProposalUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProposalQueryKey = (id: number) => {
  return [`/api/api/proposals/${id}`] as const;
};

export const getGetProposalQueryOptions = <
  TData = Awaited<ReturnType<typeof getProposal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProposal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProposalQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProposal>>> = ({
    signal,
  }) => getProposal(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProposal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProposalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProposal>>
>;
export type GetProposalQueryError = ErrorType<unknown>;

/**
 * @summary Get proposal
 */

export function useGetProposal<
  TData = Awaited<ReturnType<typeof getProposal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProposal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProposalQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateProposalUrl = (id: number) => {
  return `/api/api/proposals/${id}`;
};

/**
 * @summary Update proposal
 */
export const updateProposal = async (
  id: number,
  createProposalBody: CreateProposalBody,
  options?: RequestInit,
): Promise<Proposal> => {
  return customFetch<Proposal>(getUpdateProposalUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProposalBody),
  });
};

export const getUpdateProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProposal>>,
    TError,
    { id: number; data: BodyType<CreateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProposal>>,
  TError,
  { id: number; data: BodyType<CreateProposalBody> },
  TContext
> => {
  const mutationKey = ["updateProposal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProposal>>,
    { id: number; data: BodyType<CreateProposalBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProposal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProposal>>
>;
export type UpdateProposalMutationBody = BodyType<CreateProposalBody>;
export type UpdateProposalMutationError = ErrorType<unknown>;

/**
 * @summary Update proposal
 */
export const useUpdateProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProposal>>,
    TError,
    { id: number; data: BodyType<CreateProposalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProposal>>,
  TError,
  { id: number; data: BodyType<CreateProposalBody> },
  TContext
> => {
  return useMutation(getUpdateProposalMutationOptions(options));
};

export const getDeleteProposalUrl = (id: number) => {
  return `/api/api/proposals/${id}`;
};

/**
 * @summary Delete proposal
 */
export const deleteProposal = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteProposal200> => {
  return customFetch<DeleteProposal200>(getDeleteProposalUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProposal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProposal>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteProposal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProposal>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProposal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProposal>>
>;

export type DeleteProposalMutationError = ErrorType<unknown>;

/**
 * @summary Delete proposal
 */
export const useDeleteProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProposal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProposal>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteProposalMutationOptions(options));
};

export const getSendProposalUrl = (id: number) => {
  return `/api/api/proposals/${id}/send`;
};

/**
 * @summary Send proposal
 */
export const sendProposal = async (
  id: number,
  options?: RequestInit,
): Promise<Proposal> => {
  return customFetch<Proposal>(getSendProposalUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProposal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendProposal>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendProposal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendProposal>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendProposal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendProposal>>
>;

export type SendProposalMutationError = ErrorType<unknown>;

/**
 * @summary Send proposal
 */
export const useSendProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProposal>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendProposal>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendProposalMutationOptions(options));
};

export const getGetChatWidgetsUrl = () => {
  return `/api/chat-widgets`;
};

/**
 * @summary List chat widgets
 */
export const getChatWidgets = async (
  options?: RequestInit,
): Promise<ChatWidget[]> => {
  return customFetch<ChatWidget[]>(getGetChatWidgetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetChatWidgetsQueryKey = () => {
  return [`/api/chat-widgets`] as const;
};

export const getGetChatWidgetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatWidgets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getChatWidgets>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatWidgetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatWidgets>>> = ({
    signal,
  }) => getChatWidgets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatWidgets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatWidgetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatWidgets>>
>;
export type GetChatWidgetsQueryError = ErrorType<unknown>;

/**
 * @summary List chat widgets
 */

export function useGetChatWidgets<
  TData = Awaited<ReturnType<typeof getChatWidgets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getChatWidgets>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetChatWidgetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateChatWidgetUrl = () => {
  return `/api/chat-widgets`;
};

/**
 * @summary Create chat widget
 */
export const createChatWidget = async (
  createChatWidgetBody: CreateChatWidgetBody,
  options?: RequestInit,
): Promise<ChatWidget> => {
  return customFetch<ChatWidget>(getCreateChatWidgetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createChatWidgetBody),
  });
};

export const getCreateChatWidgetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatWidget>>,
    TError,
    { data: BodyType<CreateChatWidgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChatWidget>>,
  TError,
  { data: BodyType<CreateChatWidgetBody> },
  TContext
> => {
  const mutationKey = ["createChatWidget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChatWidget>>,
    { data: BodyType<CreateChatWidgetBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createChatWidget(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChatWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChatWidget>>
>;
export type CreateChatWidgetMutationBody = BodyType<CreateChatWidgetBody>;
export type CreateChatWidgetMutationError = ErrorType<unknown>;

/**
 * @summary Create chat widget
 */
export const useCreateChatWidget = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatWidget>>,
    TError,
    { data: BodyType<CreateChatWidgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChatWidget>>,
  TError,
  { data: BodyType<CreateChatWidgetBody> },
  TContext
> => {
  return useMutation(getCreateChatWidgetMutationOptions(options));
};

export const getUpdateChatWidgetUrl = (id: number) => {
  return `/api/chat-widgets/${id}`;
};

/**
 * @summary Update chat widget
 */
export const updateChatWidget = async (
  id: number,
  createChatWidgetBody: CreateChatWidgetBody,
  options?: RequestInit,
): Promise<ChatWidget> => {
  return customFetch<ChatWidget>(getUpdateChatWidgetUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createChatWidgetBody),
  });
};

export const getUpdateChatWidgetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatWidget>>,
    TError,
    { id: number; data: BodyType<CreateChatWidgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChatWidget>>,
  TError,
  { id: number; data: BodyType<CreateChatWidgetBody> },
  TContext
> => {
  const mutationKey = ["updateChatWidget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChatWidget>>,
    { id: number; data: BodyType<CreateChatWidgetBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChatWidget(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChatWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChatWidget>>
>;
export type UpdateChatWidgetMutationBody = BodyType<CreateChatWidgetBody>;
export type UpdateChatWidgetMutationError = ErrorType<unknown>;

/**
 * @summary Update chat widget
 */
export const useUpdateChatWidget = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatWidget>>,
    TError,
    { id: number; data: BodyType<CreateChatWidgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChatWidget>>,
  TError,
  { id: number; data: BodyType<CreateChatWidgetBody> },
  TContext
> => {
  return useMutation(getUpdateChatWidgetMutationOptions(options));
};

export const getDeleteChatWidgetUrl = (id: number) => {
  return `/api/chat-widgets/${id}`;
};

/**
 * @summary Delete chat widget
 */
export const deleteChatWidget = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteChatWidget200> => {
  return customFetch<DeleteChatWidget200>(getDeleteChatWidgetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteChatWidgetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChatWidget>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChatWidget>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteChatWidget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChatWidget>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChatWidget(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChatWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChatWidget>>
>;

export type DeleteChatWidgetMutationError = ErrorType<unknown>;

/**
 * @summary Delete chat widget
 */
export const useDeleteChatWidget = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChatWidget>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChatWidget>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteChatWidgetMutationOptions(options));
};

export const getGetChatLeadsUrl = (id: number) => {
  return `/api/chat-widgets/${id}/leads`;
};

/**
 * @summary Get chat leads
 */
export const getChatLeads = async (
  id: number,
  options?: RequestInit,
): Promise<ChatLead[]> => {
  return customFetch<ChatLead[]>(getGetChatLeadsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetChatLeadsQueryKey = (id: number) => {
  return [`/api/chat-widgets/${id}/leads`] as const;
};

export const getGetChatLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatLeads>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatLeads>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatLeadsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatLeads>>> = ({
    signal,
  }) => getChatLeads(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatLeads>>
>;
export type GetChatLeadsQueryError = ErrorType<unknown>;

/**
 * @summary Get chat leads
 */

export function useGetChatLeads<
  TData = Awaited<ReturnType<typeof getChatLeads>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatLeads>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetChatLeadsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWidgetChatsUrl = (id: number) => {
  return `/api/chat-widgets/${id}/chats`;
};

/**
 * @summary Get chat sessions for a widget
 */
export const getWidgetChats = async (
  id: number,
  options?: RequestInit,
): Promise<WidgetChat[]> => {
  return customFetch<WidgetChat[]>(getGetWidgetChatsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetWidgetChatsQueryKey = (id: number) => {
  return [`/api/chat-widgets/${id}/chats`] as const;
};

export const getGetWidgetChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWidgetChats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWidgetChats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWidgetChatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetChats>>> = ({
    signal,
  }) => getWidgetChats(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWidgetChats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWidgetChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWidgetChats>>
>;
export type GetWidgetChatsQueryError = ErrorType<unknown>;

/**
 * @summary Get chat sessions for a widget
 */

export function useGetWidgetChats<
  TData = Awaited<ReturnType<typeof getWidgetChats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWidgetChats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWidgetChatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWhiteLabelSettingsUrl = () => {
  return `/api/api/white-label`;
};

/**
 * @summary Get white-label settings
 */
export const getWhiteLabelSettings = async (
  options?: RequestInit,
): Promise<WhiteLabelSettings> => {
  return customFetch<WhiteLabelSettings>(getGetWhiteLabelSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWhiteLabelSettingsQueryKey = () => {
  return [`/api/api/white-label`] as const;
};

export const getGetWhiteLabelSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhiteLabelSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWhiteLabelSettings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWhiteLabelSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWhiteLabelSettings>>
  > = ({ signal }) => getWhiteLabelSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWhiteLabelSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWhiteLabelSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWhiteLabelSettings>>
>;
export type GetWhiteLabelSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get white-label settings
 */

export function useGetWhiteLabelSettings<
  TData = Awaited<ReturnType<typeof getWhiteLabelSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getWhiteLabelSettings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWhiteLabelSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateWhiteLabelSettingsUrl = () => {
  return `/api/api/white-label`;
};

/**
 * @summary Update white-label settings
 */
export const updateWhiteLabelSettings = async (
  whiteLabelSettings: WhiteLabelSettings,
  options?: RequestInit,
): Promise<WhiteLabelSettings> => {
  return customFetch<WhiteLabelSettings>(getUpdateWhiteLabelSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(whiteLabelSettings),
  });
};

export const getUpdateWhiteLabelSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWhiteLabelSettings>>,
    TError,
    { data: BodyType<WhiteLabelSettings> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWhiteLabelSettings>>,
  TError,
  { data: BodyType<WhiteLabelSettings> },
  TContext
> => {
  const mutationKey = ["updateWhiteLabelSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWhiteLabelSettings>>,
    { data: BodyType<WhiteLabelSettings> }
  > = (props) => {
    const { data } = props ?? {};

    return updateWhiteLabelSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWhiteLabelSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWhiteLabelSettings>>
>;
export type UpdateWhiteLabelSettingsMutationBody = BodyType<WhiteLabelSettings>;
export type UpdateWhiteLabelSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update white-label settings
 */
export const useUpdateWhiteLabelSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWhiteLabelSettings>>,
    TError,
    { data: BodyType<WhiteLabelSettings> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWhiteLabelSettings>>,
  TError,
  { data: BodyType<WhiteLabelSettings> },
  TContext
> => {
  return useMutation(getUpdateWhiteLabelSettingsMutationOptions(options));
};

export const getGetAgencyClientsUrl = () => {
  return `/api/api/agency/clients`;
};

/**
 * @summary List agency clients
 */
export const getAgencyClients = async (
  options?: RequestInit,
): Promise<AgencyClient[]> => {
  return customFetch<AgencyClient[]>(getGetAgencyClientsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAgencyClientsQueryKey = () => {
  return [`/api/api/agency/clients`] as const;
};

export const getGetAgencyClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgencyClients>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAgencyClients>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgencyClientsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAgencyClients>>
  > = ({ signal }) => getAgencyClients({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgencyClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgencyClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgencyClients>>
>;
export type GetAgencyClientsQueryError = ErrorType<unknown>;

/**
 * @summary List agency clients
 */

export function useGetAgencyClients<
  TData = Awaited<ReturnType<typeof getAgencyClients>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAgencyClients>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAgencyClientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateAgencyClientUrl = () => {
  return `/api/api/agency/clients`;
};

/**
 * @summary Create agency client
 */
export const createAgencyClient = async (
  createAgencyClientBody: CreateAgencyClientBody,
  options?: RequestInit,
): Promise<AgencyClient> => {
  return customFetch<AgencyClient>(getCreateAgencyClientUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAgencyClientBody),
  });
};

export const getCreateAgencyClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgencyClient>>,
    TError,
    { data: BodyType<CreateAgencyClientBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgencyClient>>,
  TError,
  { data: BodyType<CreateAgencyClientBody> },
  TContext
> => {
  const mutationKey = ["createAgencyClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgencyClient>>,
    { data: BodyType<CreateAgencyClientBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAgencyClient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgencyClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgencyClient>>
>;
export type CreateAgencyClientMutationBody = BodyType<CreateAgencyClientBody>;
export type CreateAgencyClientMutationError = ErrorType<unknown>;

/**
 * @summary Create agency client
 */
export const useCreateAgencyClient = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgencyClient>>,
    TError,
    { data: BodyType<CreateAgencyClientBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAgencyClient>>,
  TError,
  { data: BodyType<CreateAgencyClientBody> },
  TContext
> => {
  return useMutation(getCreateAgencyClientMutationOptions(options));
};

export const getUpdateAgencyClientUrl = (id: number) => {
  return `/api/api/agency/clients/${id}`;
};

/**
 * @summary Update agency client
 */
export const updateAgencyClient = async (
  id: number,
  createAgencyClientBody: CreateAgencyClientBody,
  options?: RequestInit,
): Promise<AgencyClient> => {
  return customFetch<AgencyClient>(getUpdateAgencyClientUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAgencyClientBody),
  });
};

export const getUpdateAgencyClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgencyClient>>,
    TError,
    { id: number; data: BodyType<CreateAgencyClientBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAgencyClient>>,
  TError,
  { id: number; data: BodyType<CreateAgencyClientBody> },
  TContext
> => {
  const mutationKey = ["updateAgencyClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAgencyClient>>,
    { id: number; data: BodyType<CreateAgencyClientBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAgencyClient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAgencyClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAgencyClient>>
>;
export type UpdateAgencyClientMutationBody = BodyType<CreateAgencyClientBody>;
export type UpdateAgencyClientMutationError = ErrorType<unknown>;

/**
 * @summary Update agency client
 */
export const useUpdateAgencyClient = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgencyClient>>,
    TError,
    { id: number; data: BodyType<CreateAgencyClientBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAgencyClient>>,
  TError,
  { id: number; data: BodyType<CreateAgencyClientBody> },
  TContext
> => {
  return useMutation(getUpdateAgencyClientMutationOptions(options));
};

export const getDeleteAgencyClientUrl = (id: number) => {
  return `/api/api/agency/clients/${id}`;
};

/**
 * @summary Delete agency client
 */
export const deleteAgencyClient = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteAgencyClient200> => {
  return customFetch<DeleteAgencyClient200>(getDeleteAgencyClientUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAgencyClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgencyClient>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgencyClient>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAgencyClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgencyClient>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAgencyClient(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgencyClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgencyClient>>
>;

export type DeleteAgencyClientMutationError = ErrorType<unknown>;

/**
 * @summary Delete agency client
 */
export const useDeleteAgencyClient = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgencyClient>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgencyClient>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAgencyClientMutationOptions(options));
};
